let cityId = { "code": 0, "msg": "获取城市列表成功", "time": 1541585335624, "data": [{ "id": 4, "name": "北京市", "sonList": [{ "id": 4, "name": "北京市", "sonList":[{ "id": 5, "name": "东城区", "sonList": [] },
{ "id": 6, "name": "西城区", "sonList": [] },
{ "id": 7, "name": "朝阳区", "sonList": [] },
{ "id": 8, "name": "海淀区", "sonList": [] },
{ "id": 9, "name": "丰台区", "sonList": [] },
{ "id": 10, "name": "石景山区", "sonList": [] },
{ "id": 11, "name": "顺义区", "sonList": [] },
{ "id": 12, "name": "昌平区", "sonList": [] },
{ "id": 13, "name": "门头沟区", "sonList": [] },
{ "id": 14, "name": "通州区", "sonList": [] },
{ "id": 15, "name": "房山区", "sonList": [] },
{ "id": 16, "name": "大兴区", "sonList": [] },
{ "id": 17, "name": "延庆县", "sonList": [] },
{ "id": 18, "name": "怀柔区", "sonList": [] },
{ "id": 19, "name": "平谷区", "sonList": [] },
{ "id": 20, "name": "密云县", "sonList": [] },
{ "id": 21, "name": "亦庄开发区", "sonList": [] }] }] },
{ "id": 22, "name": "天津市", "sonList": [{"id": 22, "name": "天津市", "sonList": [{ "id": 23, "name": "和平区", "sonList": [] },
{ "id": 24, "name": "河北区", "sonList": [] },
{ "id": 25, "name": "河东区", "sonList": [] },
{ "id": 26, "name": "河西区", "sonList": [] },
{ "id": 27, "name": "南开区", "sonList": [] },
{ "id": 28, "name": "红桥区", "sonList": [] },
{ "id": 29, "name": "滨海新区", "sonList": [] },
{ "id": 30, "name": "东丽区", "sonList": [] },
{ "id": 31, "name": "西青区", "sonList": [] },
{ "id": 32, "name": "津南区", "sonList": [] },
{ "id": 33, "name": "北辰区", "sonList": [] },
{ "id": 34, "name": "武清区", "sonList": [] },
{ "id": 35, "name": "宝坻区", "sonList": [] },
{ "id": 36, "name": "蓟县", "sonList": [] },
{ "id": 37, "name": "宁河县", "sonList": [] },
{ "id": 38, "name": "静海县", "sonList": [] },
{ "id": 39, "name": "开发区", "sonList": [] }] }]},
{ "id": 40, "name": "河北省", "sonList": [{ "id": 41, "name": "石家庄市", "sonList": [{ "id": 42, "name": "长安区", "sonList": [] },
{ "id": 43, "name": "桥东区", "sonList": [] },
{ "id": 44, "name": "桥西区", "sonList": [] },
{ "id": 45, "name": "新华区", "sonList": [] },
{ "id": 46, "name": "井陉矿区", "sonList": [] },
{ "id": 47, "name": "裕华区", "sonList": [] },
{ "id": 48, "name": "井陉县", "sonList": [] },
{ "id": 49, "name": "正定县", "sonList": [] },
{ "id": 50, "name": "栾城县", "sonList": [] },
{ "id": 51, "name": "行唐县", "sonList": [] },
{ "id": 52, "name": "灵寿县", "sonList": [] },
{ "id": 53, "name": "高邑县", "sonList": [] },
{ "id": 54, "name": "深泽县", "sonList": [] },
{ "id": 55, "name": "赞皇县", "sonList": [] },
{ "id": 56, "name": "无极县", "sonList": [] },
{ "id": 57, "name": "平山县", "sonList": [] },
{ "id": 58, "name": "元氏县", "sonList": [] },
{ "id": 59, "name": "赵县", "sonList": [] },
{ "id": 60, "name": "辛集市", "sonList": [] },
{ "id": 61, "name": "藁城市", "sonList": [] },
{ "id": 62, "name": "晋州市", "sonList": [] },
{ "id": 63, "name": "新乐市", "sonList": [] },
{ "id": 64, "name": "鹿泉市", "sonList": [] },
{ "id": 65, "name": "高新区", "sonList": [] }] },
{ "id": 66, "name": "秦皇岛市", "sonList": [{ "id": 67, "name": "海港区", "sonList": [] },
{ "id": 68, "name": "山海关区", "sonList": [] },
{ "id": 69, "name": "北戴河区", "sonList": [] },
{ "id": 70, "name": "青龙县", "sonList": [] },
{ "id": 71, "name": "昌黎县", "sonList": [] },
{ "id": 72, "name": "抚宁县", "sonList": [] },
{ "id": 73, "name": "卢龙县", "sonList": [] },
{ "id": 74, "name": "开发区", "sonList": [] }] },
{ "id": 75, "name": "唐山市", "sonList": [{ "id": 76, "name": "路南区", "sonList": [] },
{ "id": 77, "name": "路北区", "sonList": [] },
{ "id": 78, "name": "古冶区", "sonList": [] },
{ "id": 79, "name": "开平区", "sonList": [] },
{ "id": 80, "name": "丰南区", "sonList": [] },
{ "id": 81, "name": "丰润区", "sonList": [] },
{ "id": 82, "name": "滦县", "sonList": [] },
{ "id": 83, "name": "滦南县", "sonList": [] },
{ "id": 84, "name": "乐亭县", "sonList": [] },
{ "id": 85, "name": "迁西县", "sonList": [] },
{ "id": 86, "name": "玉田县", "sonList": [] },
{ "id": 87, "name": "唐海县", "sonList": [] },
{ "id": 88, "name": "遵化市", "sonList": [] },
{ "id": 89, "name": "迁安市", "sonList": [] }] },
{ "id": 90, "name": "张家口市", "sonList": [{ "id": 91, "name": "桥东区", "sonList": [] },
{ "id": 92, "name": "桥西区", "sonList": [] },
{ "id": 93, "name": "宣化区", "sonList": [] },
{ "id": 94, "name": "下花园区", "sonList": [] },
{ "id": 95, "name": "宣化县", "sonList": [] },
{ "id": 96, "name": "张北县", "sonList": [] },
{ "id": 97, "name": "康保县", "sonList": [] },
{ "id": 98, "name": "沽源县", "sonList": [] },
{ "id": 99, "name": "尚义县", "sonList": [] },
{ "id": 100, "name": "蔚县", "sonList": [] },
{ "id": 101, "name": "阳原县", "sonList": [] },
{ "id": 102, "name": "怀安县", "sonList": [] },
{ "id": 103, "name": "万全县", "sonList": [] },
{ "id": 104, "name": "怀来县", "sonList": [] },
{ "id": 105, "name": "涿鹿县", "sonList": [] },
{ "id": 106, "name": "赤城县", "sonList": [] },
{ "id": 107, "name": "崇礼县", "sonList": [] }] },
{ "id": 108, "name": "廊坊市", "sonList": [{ "id": 109, "name": "安次区", "sonList": [] },
{ "id": 110, "name": "广阳区", "sonList": [] },
{ "id": 111, "name": "固安县", "sonList": [] },
{ "id": 112, "name": "永清县", "sonList": [] },
{ "id": 113, "name": "香河县", "sonList": [] },
{ "id": 114, "name": "大城县", "sonList": [] },
{ "id": 115, "name": "文安县", "sonList": [] },
{ "id": 116, "name": "大厂县", "sonList": [] },
{ "id": 117, "name": "霸州市", "sonList": [] },
{ "id": 118, "name": "三河市", "sonList": [] },
{ "id": 119, "name": "开发区", "sonList": [] }] },
{ "id": 120, "name": "衡水市", "sonList": [{ "id": 121, "name": "桃城区", "sonList": [] },
{ "id": 122, "name": "枣强县", "sonList": [] },
{ "id": 123, "name": "武邑县", "sonList": [] },
{ "id": 124, "name": "武强县", "sonList": [] },
{ "id": 125, "name": "饶阳县", "sonList": [] },
{ "id": 126, "name": "安平县", "sonList": [] },
{ "id": 127, "name": "故城县", "sonList": [] },
{ "id": 128, "name": "景县", "sonList": [] },
{ "id": 129, "name": "阜城县", "sonList": [] },
{ "id": 130, "name": "冀州市", "sonList": [] },
{ "id": 131, "name": "深州市", "sonList": [] }] },
{ "id": 132, "name": "保定市", "sonList": [{ "id": 133, "name": "新市区", "sonList": [] },
{ "id": 134, "name": "北市区", "sonList": [] },
{ "id": 135, "name": "南市区", "sonList": [] },
{ "id": 136, "name": "满城县", "sonList": [] },
{ "id": 137, "name": "清苑县", "sonList": [] },
{ "id": 138, "name": "涞水县", "sonList": [] },
{ "id": 139, "name": "阜平县", "sonList": [] },
{ "id": 140, "name": "徐水县", "sonList": [] },
{ "id": 141, "name": "定兴县", "sonList": [] },
{ "id": 142, "name": "唐县", "sonList": [] },
{ "id": 143, "name": "高阳县", "sonList": [] },
{ "id": 144, "name": "容城县", "sonList": [] },
{ "id": 145, "name": "涞源县", "sonList": [] },
{ "id": 146, "name": "望都县", "sonList": [] },
{ "id": 147, "name": "安新县", "sonList": [] },
{ "id": 148, "name": "易县", "sonList": [] },
{ "id": 149, "name": "曲阳县", "sonList": [] },
{ "id": 150, "name": "蠡县", "sonList": [] },
{ "id": 151, "name": "顺平县", "sonList": [] },
{ "id": 152, "name": "博野县", "sonList": [] },
{ "id": 153, "name": "雄县", "sonList": [] },
{ "id": 154, "name": "涿州市", "sonList": [] },
{ "id": 155, "name": "定州市", "sonList": [] },
{ "id": 156, "name": "安国市", "sonList": [] },
{ "id": 157, "name": "高碑店市", "sonList": [] },
{ "id": 158, "name": "高新区", "sonList": [] }] },
{ "id": 159, "name": "承德市", "sonList": [{ "id": 160, "name": "双桥区", "sonList": [] },
{ "id": 161, "name": "双滦区", "sonList": [] },
{ "id": 162, "name": "鹰手营子", "sonList": [] },
{ "id": 163, "name": "承德县", "sonList": [] },
{ "id": 164, "name": "兴隆县", "sonList": [] },
{ "id": 165, "name": "平泉县", "sonList": [] },
{ "id": 166, "name": "滦平县", "sonList": [] },
{ "id": 167, "name": "隆化县", "sonList": [] },
{ "id": 168, "name": "丰宁县", "sonList": [] },
{ "id": 169, "name": "宽城县", "sonList": [] },
{ "id": 170, "name": "围场县", "sonList": [] }] },
{ "id": 171, "name": "邢台市", "sonList": [{ "id": 172, "name": "桥东区", "sonList": [] },
{ "id": 173, "name": "桥西区", "sonList": [] },
{ "id": 174, "name": "邢台县", "sonList": [] },
{ "id": 175, "name": "临城县", "sonList": [] },
{ "id": 176, "name": "内丘县", "sonList": [] },
{ "id": 177, "name": "柏乡县", "sonList": [] },
{ "id": 178, "name": "隆尧县", "sonList": [] },
{ "id": 179, "name": "任县", "sonList": [] },
{ "id": 180, "name": "南和县", "sonList": [] },
{ "id": 181, "name": "宁晋县", "sonList": [] },
{ "id": 182, "name": "巨鹿县", "sonList": [] },
{ "id": 183, "name": "新河县", "sonList": [] },
{ "id": 184, "name": "广宗县", "sonList": [] },
{ "id": 185, "name": "平乡县", "sonList": [] },
{ "id": 186, "name": "威县", "sonList": [] },
{ "id": 187, "name": "清河县", "sonList": [] },
{ "id": 188, "name": "临西县", "sonList": [] },
{ "id": 189, "name": "南宫市", "sonList": [] },
{ "id": 190, "name": "沙河市", "sonList": [] }] },
{ "id": 191, "name": "沧州市", "sonList": [{ "id": 192, "name": "新华区", "sonList": [] },
{ "id": 193, "name": "运河区", "sonList": [] },
{ "id": 194, "name": "沧县", "sonList": [] },
{ "id": 195, "name": "青县", "sonList": [] },
{ "id": 196, "name": "东光县", "sonList": [] },
{ "id": 197, "name": "海兴县", "sonList": [] },
{ "id": 198, "name": "盐山县", "sonList": [] },
{ "id": 199, "name": "肃宁县", "sonList": [] },
{ "id": 200, "name": "南皮县", "sonList": [] },
{ "id": 201, "name": "吴桥县", "sonList": [] },
{ "id": 202, "name": "献县", "sonList": [] },
{ "id": 203, "name": "孟村县", "sonList": [] },
{ "id": 204, "name": "泊头市", "sonList": [] },
{ "id": 205, "name": "任丘市", "sonList": [] },
{ "id": 206, "name": "黄骅市", "sonList": [] },
{ "id": 207, "name": "河间市", "sonList": [] },
{ "id": 208, "name": "开发区", "sonList": [] }] },
{ "id": 209, "name": "邯郸市", "sonList": [{ "id": 210, "name": "邯山区", "sonList": [] },
{ "id": 211, "name": "丛台区", "sonList": [] },
{ "id": 212, "name": "复兴区", "sonList": [] },
{ "id": 213, "name": "峰峰矿区", "sonList": [] },
{ "id": 214, "name": "邯郸县", "sonList": [] },
{ "id": 215, "name": "临漳县", "sonList": [] },
{ "id": 216, "name": "成安县", "sonList": [] },
{ "id": 217, "name": "大名县", "sonList": [] },
{ "id": 218, "name": "涉县", "sonList": [] },
{ "id": 219, "name": "磁县", "sonList": [] },
{ "id": 220, "name": "肥乡县", "sonList": [] },
{ "id": 221, "name": "永年县", "sonList": [] },
{ "id": 222, "name": "邱县", "sonList": [] },
{ "id": 223, "name": "鸡泽县", "sonList": [] },
{ "id": 224, "name": "广平县", "sonList": [] },
{ "id": 225, "name": "馆陶县", "sonList": [] },
{ "id": 226, "name": "魏县", "sonList": [] },
{ "id": 227, "name": "曲周县", "sonList": [] },
{ "id": 228, "name": "武安市", "sonList": [] }] }] },
{ "id": 229, "name": "内蒙古", "sonList": [{ "id": 230, "name": "呼和浩特市", "sonList": [{ "id": 231, "name": "新城区", "sonList": [] },
{ "id": 232, "name": "回民区", "sonList": [] },
{ "id": 233, "name": "玉泉区", "sonList": [] },
{ "id": 234, "name": "赛罕区", "sonList": [] },
{ "id": 235, "name": "土默特左旗", "sonList": [] },
{ "id": 236, "name": "托克托县", "sonList": [] },
{ "id": 237, "name": "和林格尔县", "sonList": [] },
{ "id": 238, "name": "清水河县", "sonList": [] },
{ "id": 239, "name": "武川县", "sonList": [] },
{ "id": 240, "name": "开发区", "sonList": [] }] },
{ "id": 241, "name": "包头市", "sonList": [{ "id": 242, "name": "东河区", "sonList": [] },
{ "id": 243, "name": "昆都仑区", "sonList": [] },
{ "id": 244, "name": "青山区", "sonList": [] },
{ "id": 245, "name": "石拐区", "sonList": [] },
{ "id": 246, "name": "白云鄂博", "sonList": [] },
{ "id": 247, "name": "九原区", "sonList": [] },
{ "id": 248, "name": "土默特右旗", "sonList": [] },
{ "id": 249, "name": "固阳县", "sonList": [] },
{ "id": 250, "name": "达茂联合旗", "sonList": [] },
{ "id": 251, "name": "高新区", "sonList": [] }] },
{ "id": 252, "name": "呼伦贝尔市", "sonList": [{ "id": 253, "name": "海拉尔区", "sonList": [] },
{ "id": 254, "name": "阿荣旗", "sonList": [] },
{ "id": 255, "name": "莫旗", "sonList": [] },
{ "id": 256, "name": "鄂伦春自治旗", "sonList": [] },
{ "id": 257, "name": "鄂温克旗", "sonList": [] },
{ "id": 258, "name": "陈巴尔虎旗", "sonList": [] },
{ "id": 259, "name": "新巴尔虎左旗", "sonList": [] },
{ "id": 260, "name": "新巴尔虎右旗", "sonList": [] },
{ "id": 261, "name": "牙克石市", "sonList": [] },
{ "id": 262, "name": "扎兰屯市", "sonList": [] },
{ "id": 263, "name": "额尔古纳市", "sonList": [] },
{ "id": 264, "name": "根河市", "sonList": [] }] },
{ "id": 265, "name": "兴安盟", "sonList": [{ "id": 266, "name": "乌兰浩特市", "sonList": [] },
{ "id": 267, "name": "阿尔山市", "sonList": [] },
{ "id": 268, "name": "科右前旗", "sonList": [] },
{ "id": 269, "name": "科右中旗", "sonList": [] },
{ "id": 270, "name": "扎赉特旗", "sonList": [] },
{ "id": 271, "name": "突泉县", "sonList": [] }] },
{ "id": 272, "name": "通辽市", "sonList": [{ "id": 273, "name": "科尔沁区", "sonList": [] },
{ "id": 274, "name": "科左中旗", "sonList": [] },
{ "id": 275, "name": "科左后旗", "sonList": [] },
{ "id": 276, "name": "开鲁县", "sonList": [] },
{ "id": 277, "name": "库伦旗", "sonList": [] },
{ "id": 278, "name": "奈曼旗", "sonList": [] },
{ "id": 279, "name": "扎鲁特旗", "sonList": [] },
{ "id": 280, "name": "霍林郭勒市", "sonList": [] }] },
{ "id": 281, "name": "赤峰市", "sonList": [{ "id": 282, "name": "红山区", "sonList": [] },
{ "id": 283, "name": "元宝山区", "sonList": [] },
{ "id": 284, "name": "松山区", "sonList": [] },
{ "id": 285, "name": "阿鲁科尔沁旗", "sonList": [] },
{ "id": 286, "name": "巴林左旗", "sonList": [] },
{ "id": 287, "name": "巴林右旗", "sonList": [] },
{ "id": 288, "name": "林西县", "sonList": [] },
{ "id": 289, "name": "克什克腾旗", "sonList": [] },
{ "id": 290, "name": "翁牛特旗", "sonList": [] },
{ "id": 291, "name": "喀喇沁旗", "sonList": [] },
{ "id": 292, "name": "宁城县", "sonList": [] },
{ "id": 293, "name": "敖汉旗", "sonList": [] }] },
{ "id": 294, "name": "锡林郭勒盟", "sonList": [{ "id": 295, "name": "锡林浩特市", "sonList": [] },
{ "id": 296, "name": "阿巴嘎旗", "sonList": [] },
{ "id": 297, "name": "苏尼特左旗", "sonList": [] },
{ "id": 298, "name": "苏尼特右旗", "sonList": [] },
{ "id": 299, "name": "东乌珠穆沁旗", "sonList": [] },
{ "id": 300, "name": "西乌珠穆沁旗", "sonList": [] },
{ "id": 301, "name": "太仆寺旗", "sonList": [] },
{ "id": 302, "name": "镶黄旗", "sonList": [] },
{ "id": 303, "name": "正镶白旗", "sonList": [] },
{ "id": 304, "name": "正蓝旗", "sonList": [] },
{ "id": 305, "name": "多伦县", "sonList": [] }] },
{ "id": 306, "name": "乌兰察布市", "sonList": [{ "id": 307, "name": "集宁区", "sonList": [] },
{ "id": 308, "name": "卓资县", "sonList": [] },
{ "id": 309, "name": "化德县", "sonList": [] },
{ "id": 310, "name": "商都县", "sonList": [] },
{ "id": 311, "name": "兴和县", "sonList": [] },
{ "id": 312, "name": "凉城县", "sonList": [] },
{ "id": 313, "name": "察右前旗", "sonList": [] },
{ "id": 314, "name": "察右中旗", "sonList": [] },
{ "id": 315, "name": "察右后旗", "sonList": [] },
{ "id": 316, "name": "四子王旗", "sonList": [] },
{ "id": 317, "name": "丰镇市", "sonList": [] }] },
{ "id": 318, "name": "鄂尔多斯市", "sonList": [{ "id": 319, "name": "东胜区", "sonList": [] },
{ "id": 320, "name": "达拉特旗", "sonList": [] },
{ "id": 321, "name": "准格尔旗", "sonList": [] },
{ "id": 322, "name": "鄂托克前旗", "sonList": [] },
{ "id": 323, "name": "鄂托克旗", "sonList": [] },
{ "id": 324, "name": "杭锦旗", "sonList": [] },
{ "id": 325, "name": "乌审旗", "sonList": [] },
{ "id": 326, "name": "伊金霍洛旗", "sonList": [] }] },
{ "id": 327, "name": "巴彦淖尔市", "sonList": [{ "id": 328, "name": "临河区", "sonList": [] },
{ "id": 329, "name": "五原县", "sonList": [] },
{ "id": 330, "name": "磴口县", "sonList": [] },
{ "id": 331, "name": "乌拉特前旗", "sonList": [] },
{ "id": 332, "name": "乌拉特中旗", "sonList": [] },
{ "id": 333, "name": "乌拉特后旗", "sonList": [] },
{ "id": 334, "name": "杭锦后旗", "sonList": [] }] },
{ "id": 335, "name": "乌海市", "sonList": [{ "id": 336, "name": "海勃湾区", "sonList": [] },
{ "id": 337, "name": "海南区", "sonList": [] },
{ "id": 338, "name": "乌达区", "sonList": [] }] },
{ "id": 339, "name": "阿拉善盟", "sonList": [{ "id": 340, "name": "阿拉善左旗", "sonList": [] },
{ "id": 341, "name": "阿拉善右旗", "sonList": [] },
{ "id": 342, "name": "额济纳旗", "sonList": [] }] },
{ "id": 343, "name": "满洲里", "sonList": [] },
{ "id": 344, "name": "二连浩特", "sonList": [] }] },
{ "id": 345, "name": "山西省", "sonList": [{ "id": 346, "name": "太原市", "sonList": [{ "id": 347, "name": "小店区", "sonList": [] },
{ "id": 348, "name": "迎泽区", "sonList": [] },
{ "id": 349, "name": "杏花岭区", "sonList": [] },
{ "id": 350, "name": "尖草坪区", "sonList": [] },
{ "id": 351, "name": "万柏林区", "sonList": [] },
{ "id": 352, "name": "晋源区", "sonList": [] },
{ "id": 353, "name": "清徐县", "sonList": [] },
{ "id": 354, "name": "阳曲县", "sonList": [] },
{ "id": 355, "name": "娄烦县", "sonList": [] },
{ "id": 356, "name": "古交市", "sonList": [] },
{ "id": 357, "name": "开发区", "sonList": [] }] },
{ "id": 358, "name": "大同市", "sonList": [{ "id": 359, "name": "城区", "sonList": [] },
{ "id": 360, "name": "矿区", "sonList": [] },
{ "id": 361, "name": "南郊区", "sonList": [] },
{ "id": 362, "name": "新荣区", "sonList": [] },
{ "id": 363, "name": "阳高县", "sonList": [] },
{ "id": 364, "name": "天镇县", "sonList": [] },
{ "id": 365, "name": "广灵县", "sonList": [] },
{ "id": 366, "name": "灵丘县", "sonList": [] },
{ "id": 367, "name": "浑源县", "sonList": [] },
{ "id": 368, "name": "左云县", "sonList": [] },
{ "id": 369, "name": "大同县", "sonList": [] },
{ "id": 370, "name": "开发区", "sonList": [] }] },
{ "id": 371, "name": "阳泉市", "sonList": [{ "id": 372, "name": "城区", "sonList": [] },
{ "id": 373, "name": "矿区", "sonList": [] },
{ "id": 374, "name": "郊区", "sonList": [] },
{ "id": 375, "name": "平定县", "sonList": [] },
{ "id": 376, "name": "盂县", "sonList": [] }] },
{ "id": 377, "name": "长治市", "sonList": [{ "id": 378, "name": "城区", "sonList": [] },
{ "id": 379, "name": "郊区", "sonList": [] },
{ "id": 380, "name": "长治县", "sonList": [] },
{ "id": 381, "name": "襄垣县", "sonList": [] },
{ "id": 382, "name": "屯留县", "sonList": [] },
{ "id": 383, "name": "平顺县", "sonList": [] },
{ "id": 384, "name": "黎城县", "sonList": [] },
{ "id": 385, "name": "壶关县", "sonList": [] },
{ "id": 386, "name": "长子县", "sonList": [] },
{ "id": 387, "name": "武乡县", "sonList": [] },
{ "id": 388, "name": "沁县", "sonList": [] },
{ "id": 389, "name": "沁源县", "sonList": [] },
{ "id": 390, "name": "潞城市", "sonList": [] }] },
{ "id": 391, "name": "晋城市", "sonList": [{ "id": 392, "name": "城区", "sonList": [] },
{ "id": 393, "name": "沁水县", "sonList": [] },
{ "id": 394, "name": "阳城县", "sonList": [] },
{ "id": 395, "name": "陵川县", "sonList": [] },
{ "id": 396, "name": "泽州县", "sonList": [] },
{ "id": 397, "name": "高平市", "sonList": [] }] },
{ "id": 398, "name": "朔州市", "sonList": [{ "id": 399, "name": "朔城区", "sonList": [] },
{ "id": 400, "name": "平鲁区", "sonList": [] },
{ "id": 401, "name": "山阴县", "sonList": [] },
{ "id": 402, "name": "应县", "sonList": [] },
{ "id": 403, "name": "右玉县", "sonList": [] },
{ "id": 404, "name": "怀仁县", "sonList": [] }] },
{ "id": 405, "name": "忻州市", "sonList": [{ "id": 406, "name": "忻府区", "sonList": [] },
{ "id": 407, "name": "定襄县", "sonList": [] },
{ "id": 408, "name": "五台县", "sonList": [] },
{ "id": 409, "name": "代县", "sonList": [] },
{ "id": 410, "name": "繁峙县", "sonList": [] },
{ "id": 411, "name": "宁武县", "sonList": [] },
{ "id": 412, "name": "静乐县", "sonList": [] },
{ "id": 413, "name": "神池县", "sonList": [] },
{ "id": 414, "name": "五寨县", "sonList": [] },
{ "id": 415, "name": "岢岚县", "sonList": [] },
{ "id": 416, "name": "河曲县", "sonList": [] },
{ "id": 417, "name": "保德县", "sonList": [] },
{ "id": 418, "name": "偏关县", "sonList": [] },
{ "id": 419, "name": "原平市", "sonList": [] }] },
{ "id": 420, "name": "晋中市", "sonList": [{ "id": 421, "name": "榆次区", "sonList": [] },
{ "id": 422, "name": "榆社县", "sonList": [] },
{ "id": 423, "name": "左权县", "sonList": [] },
{ "id": 424, "name": "和顺县", "sonList": [] },
{ "id": 425, "name": "昔阳县", "sonList": [] },
{ "id": 426, "name": "寿阳县", "sonList": [] },
{ "id": 427, "name": "太谷县", "sonList": [] },
{ "id": 428, "name": "祁县", "sonList": [] },
{ "id": 429, "name": "平遥县", "sonList": [] },
{ "id": 430, "name": "灵石县", "sonList": [] },
{ "id": 431, "name": "介休市", "sonList": [] }] },
{ "id": 432, "name": "临汾市", "sonList": [{ "id": 433, "name": "尧都区", "sonList": [] },
{ "id": 434, "name": "曲沃县", "sonList": [] },
{ "id": 435, "name": "翼城县", "sonList": [] },
{ "id": 436, "name": "襄汾县", "sonList": [] },
{ "id": 437, "name": "洪洞县", "sonList": [] },
{ "id": 438, "name": "古县", "sonList": [] },
{ "id": 439, "name": "安泽县", "sonList": [] },
{ "id": 440, "name": "浮山县", "sonList": [] },
{ "id": 441, "name": "吉县", "sonList": [] },
{ "id": 442, "name": "乡宁县", "sonList": [] },
{ "id": 443, "name": "大宁县", "sonList": [] },
{ "id": 444, "name": "隰县", "sonList": [] },
{ "id": 445, "name": "永和县", "sonList": [] },
{ "id": 446, "name": "蒲县", "sonList": [] },
{ "id": 447, "name": "汾西县", "sonList": [] },
{ "id": 448, "name": "侯马市", "sonList": [] },
{ "id": 449, "name": "霍州市", "sonList": [] }] },
{ "id": 450, "name": "吕梁市", "sonList": [{ "id": 451, "name": "离石区", "sonList": [] },
{ "id": 452, "name": "文水县", "sonList": [] },
{ "id": 453, "name": "交城县", "sonList": [] },
{ "id": 454, "name": "兴县", "sonList": [] },
{ "id": 455, "name": "临县", "sonList": [] },
{ "id": 456, "name": "柳林县", "sonList": [] },
{ "id": 457, "name": "石楼县", "sonList": [] },
{ "id": 458, "name": "岚县", "sonList": [] },
{ "id": 459, "name": "方山县", "sonList": [] },
{ "id": 460, "name": "中阳县", "sonList": [] },
{ "id": 461, "name": "交口县", "sonList": [] },
{ "id": 462, "name": "孝义市", "sonList": [] },
{ "id": 463, "name": "汾阳市", "sonList": [] }] },
{ "id": 464, "name": "运城市", "sonList": [{ "id": 465, "name": "盐湖区", "sonList": [] },
{ "id": 466, "name": "临猗县", "sonList": [] },
{ "id": 467, "name": "万荣县", "sonList": [] },
{ "id": 468, "name": "闻喜县", "sonList": [] },
{ "id": 469, "name": "稷山县", "sonList": [] },
{ "id": 470, "name": "新绛县", "sonList": [] },
{ "id": 471, "name": "绛县", "sonList": [] },
{ "id": 472, "name": "垣曲县", "sonList": [] },
{ "id": 473, "name": "夏县", "sonList": [] },
{ "id": 474, "name": "平陆县", "sonList": [] },
{ "id": 475, "name": "芮城县", "sonList": [] },
{ "id": 476, "name": "永济市", "sonList": [] },
{ "id": 477, "name": "河津市", "sonList": [] }] }] },
{ "id": 478, "name": "辽宁省", "sonList": [{ "id": 479, "name": "沈阳市", "sonList": [{ "id": 480, "name": "和平区", "sonList": [] },
{ "id": 481, "name": "沈河区", "sonList": [] },
{ "id": 482, "name": "大东区", "sonList": [] },
{ "id": 483, "name": "皇姑区", "sonList": [] },
{ "id": 484, "name": "铁西区", "sonList": [] },
{ "id": 485, "name": "苏家屯区", "sonList": [] },
{ "id": 486, "name": "东陵区", "sonList": [] },
{ "id": 487, "name": "沈北新区", "sonList": [] },
{ "id": 488, "name": "于洪区", "sonList": [] },
{ "id": 489, "name": "辽中县", "sonList": [] },
{ "id": 490, "name": "康平县", "sonList": [] },
{ "id": 491, "name": "法库县", "sonList": [] },
{ "id": 492, "name": "新民市", "sonList": [] },
{ "id": 493, "name": "浑南新区", "sonList": [] }] },
{ "id": 494, "name": "大连市", "sonList": [{ "id": 495, "name": "中山区", "sonList": [] },
{ "id": 496, "name": "西岗区", "sonList": [] },
{ "id": 497, "name": "沙河口区", "sonList": [] },
{ "id": 498, "name": "甘井子区", "sonList": [] },
{ "id": 499, "name": "旅顺口区", "sonList": [] },
{ "id": 500, "name": "金州区", "sonList": [] },
{ "id": 501, "name": "长海县", "sonList": [] },
{ "id": 502, "name": "瓦房店市", "sonList": [] },
{ "id": 503, "name": "普兰店市", "sonList": [] },
{ "id": 504, "name": "庄河市", "sonList": [] },
{ "id": 505, "name": "开发区", "sonList": [] }] },
{ "id": 506, "name": "鞍山市", "sonList": [{ "id": 507, "name": "铁东区", "sonList": [] },
{ "id": 508, "name": "铁西区", "sonList": [] },
{ "id": 509, "name": "立山区", "sonList": [] },
{ "id": 510, "name": "千山区", "sonList": [] },
{ "id": 511, "name": "台安县", "sonList": [] },
{ "id": 512, "name": "岫岩县", "sonList": [] },
{ "id": 513, "name": "海城市", "sonList": [] },
{ "id": 514, "name": "高新区", "sonList": [] }] },
{ "id": 515, "name": "锦州市", "sonList": [{ "id": 516, "name": "古塔区", "sonList": [] },
{ "id": 517, "name": "凌河区", "sonList": [] },
{ "id": 518, "name": "太和区", "sonList": [] },
{ "id": 519, "name": "黑山县", "sonList": [] },
{ "id": 520, "name": "义县", "sonList": [] },
{ "id": 521, "name": "凌海市", "sonList": [] },
{ "id": 522, "name": "北镇市", "sonList": [] },
{ "id": 523, "name": "开发区", "sonList": [] }] },
{ "id": 524, "name": "丹东市", "sonList": [{ "id": 525, "name": "元宝区", "sonList": [] },
{ "id": 526, "name": "振兴区", "sonList": [] },
{ "id": 527, "name": "振安区", "sonList": [] },
{ "id": 528, "name": "宽甸县", "sonList": [] },
{ "id": 529, "name": "东港市", "sonList": [] },
{ "id": 530, "name": "凤城市", "sonList": [] }] },
{ "id": 531, "name": "盘锦市", "sonList": [{ "id": 532, "name": "双台子区", "sonList": [] },
{ "id": 533, "name": "兴隆台区", "sonList": [] },
{ "id": 534, "name": "大洼县", "sonList": [] },
{ "id": 535, "name": "盘山县", "sonList": [] }] },
{ "id": 536, "name": "铁岭市", "sonList": [{ "id": 537, "name": "银州区", "sonList": [] },
{ "id": 538, "name": "清河区", "sonList": [] },
{ "id": 539, "name": "铁岭县", "sonList": [] },
{ "id": 540, "name": "西丰县", "sonList": [] },
{ "id": 541, "name": "昌图县", "sonList": [] },
{ "id": 542, "name": "调兵山市", "sonList": [] },
{ "id": 543, "name": "开原市", "sonList": [] }] },
{ "id": 544, "name": "抚顺市", "sonList": [{ "id": 545, "name": "新抚区", "sonList": [] },
{ "id": 546, "name": "东洲区", "sonList": [] },
{ "id": 547, "name": "望花区", "sonList": [] },
{ "id": 548, "name": "顺城区", "sonList": [] },
{ "id": 549, "name": "抚顺县", "sonList": [] },
{ "id": 550, "name": "新宾县", "sonList": [] },
{ "id": 551, "name": "清原县", "sonList": [] }] },
{ "id": 552, "name": "营口市", "sonList": [{ "id": 553, "name": "站前区", "sonList": [] },
{ "id": 554, "name": "鲅鱼圈区", "sonList": [] },
{ "id": 555, "name": "老边区", "sonList": [] },
{ "id": 556, "name": "盖州市", "sonList": [] },
{ "id": 557, "name": "大石桥市", "sonList": [] },
{ "id": 558, "name": "开发区", "sonList": [] }] },
{ "id": 559, "name": "辽阳市", "sonList": [{ "id": 560, "name": "白塔区", "sonList": [] },
{ "id": 561, "name": "文圣区", "sonList": [] },
{ "id": 562, "name": "宏伟区", "sonList": [] },
{ "id": 563, "name": "弓长岭区", "sonList": [] },
{ "id": 564, "name": "太子河区", "sonList": [] },
{ "id": 565, "name": "辽阳县", "sonList": [] },
{ "id": 566, "name": "灯塔市", "sonList": [] },
{ "id": 567, "name": "高新区", "sonList": [] }] },
{ "id": 568, "name": "阜新市", "sonList": [{ "id": 569, "name": "海州区", "sonList": [] },
{ "id": 570, "name": "新邱区", "sonList": [] },
{ "id": 571, "name": "太平区", "sonList": [] },
{ "id": 572, "name": "清河门区", "sonList": [] },
{ "id": 573, "name": "细河区", "sonList": [] },
{ "id": 574, "name": "阜新县", "sonList": [] },
{ "id": 575, "name": "彰武县", "sonList": [] }] },
{ "id": 576, "name": "本溪市", "sonList": [{ "id": 577, "name": "平山区", "sonList": [] },
{ "id": 578, "name": "溪湖区", "sonList": [] },
{ "id": 579, "name": "明山区", "sonList": [] },
{ "id": 580, "name": "南芬区", "sonList": [] },
{ "id": 581, "name": "本溪县", "sonList": [] },
{ "id": 582, "name": "桓仁县", "sonList": [] }] },
{ "id": 583, "name": "朝阳市", "sonList": [{ "id": 584, "name": "双塔区", "sonList": [] },
{ "id": 585, "name": "龙城区", "sonList": [] },
{ "id": 586, "name": "朝阳县", "sonList": [] },
{ "id": 587, "name": "建平县", "sonList": [] },
{ "id": 588, "name": "喀左县", "sonList": [] },
{ "id": 589, "name": "北票市", "sonList": [] },
{ "id": 590, "name": "凌源市", "sonList": [] }] },
{ "id": 591, "name": "葫芦岛市", "sonList": [{ "id": 592, "name": "连山区", "sonList": [] },
{ "id": 593, "name": "龙港区", "sonList": [] },
{ "id": 594, "name": "南票区", "sonList": [] },
{ "id": 595, "name": "绥中县", "sonList": [] },
{ "id": 596, "name": "建昌县", "sonList": [] },
{ "id": 597, "name": "兴城市", "sonList": [] }] }] },
{ "id": 598, "name": "吉林省", "sonList": [{ "id": 599, "name": "长春市", "sonList": [{ "id": 600, "name": "南关区", "sonList": [] },
{ "id": 601, "name": "宽城区", "sonList": [] },
{ "id": 602, "name": "朝阳区", "sonList": [] },
{ "id": 603, "name": "二道区", "sonList": [] },
{ "id": 604, "name": "绿园区", "sonList": [] },
{ "id": 605, "name": "双阳区", "sonList": [] },
{ "id": 606, "name": "农安县", "sonList": [] },
{ "id": 607, "name": "九台市", "sonList": [] },
{ "id": 608, "name": "榆树市", "sonList": [] },
{ "id": 609, "name": "德惠市", "sonList": [] },
{ "id": 610, "name": "开发区", "sonList": [] }] },
{ "id": 611, "name": "吉林市", "sonList": [{ "id": 612, "name": "昌邑区", "sonList": [] },
{ "id": 613, "name": "龙潭区", "sonList": [] },
{ "id": 614, "name": "船营区", "sonList": [] },
{ "id": 615, "name": "丰满区", "sonList": [] },
{ "id": 616, "name": "永吉县", "sonList": [] },
{ "id": 617, "name": "蛟河市", "sonList": [] },
{ "id": 618, "name": "桦甸市", "sonList": [] },
{ "id": 619, "name": "舒兰市", "sonList": [] },
{ "id": 620, "name": "磐石市", "sonList": [] },
{ "id": 621, "name": "开发区", "sonList": [] }] },
{ "id": 622, "name": "四平市", "sonList": [{ "id": 623, "name": "铁西区", "sonList": [] },
{ "id": 624, "name": "铁东区", "sonList": [] },
{ "id": 625, "name": "梨树县", "sonList": [] },
{ "id": 626, "name": "伊通县", "sonList": [] },
{ "id": 627, "name": "公主岭市", "sonList": [] },
{ "id": 628, "name": "双辽市", "sonList": [] },
{ "id": 629, "name": "开发区", "sonList": [] }] },
{ "id": 630, "name": "辽源市", "sonList": [{ "id": 631, "name": "龙山区", "sonList": [] },
{ "id": 632, "name": "西安区", "sonList": [] },
{ "id": 633, "name": "东丰县", "sonList": [] },
{ "id": 634, "name": "东辽县", "sonList": [] }] },
{ "id": 635, "name": "通化市", "sonList": [{ "id": 636, "name": "东昌区", "sonList": [] },
{ "id": 637, "name": "二道江区", "sonList": [] },
{ "id": 638, "name": "通化县", "sonList": [] },
{ "id": 639, "name": "辉南县", "sonList": [] },
{ "id": 640, "name": "柳河县", "sonList": [] },
{ "id": 641, "name": "梅河口市", "sonList": [] },
{ "id": 642, "name": "集安市", "sonList": [] }] },
{ "id": 643, "name": "白山市", "sonList": [{ "id": 644, "name": "八道江区", "sonList": [] },
{ "id": 645, "name": "江源区", "sonList": [] },
{ "id": 646, "name": "抚松县", "sonList": [] },
{ "id": 647, "name": "靖宇县", "sonList": [] },
{ "id": 648, "name": "长白县", "sonList": [] },
{ "id": 649, "name": "临江市", "sonList": [] }] },
{ "id": 650, "name": "松原市", "sonList": [{ "id": 651, "name": "宁江区", "sonList": [] },
{ "id": 652, "name": "前郭县", "sonList": [] },
{ "id": 653, "name": "长岭县", "sonList": [] },
{ "id": 654, "name": "乾安县", "sonList": [] },
{ "id": 655, "name": "扶余县", "sonList": [] }] },
{ "id": 656, "name": "白城市", "sonList": [{ "id": 657, "name": "洮北区", "sonList": [] },
{ "id": 658, "name": "镇赉县", "sonList": [] },
{ "id": 659, "name": "通榆县", "sonList": [] },
{ "id": 660, "name": "洮南市", "sonList": [] },
{ "id": 661, "name": "大安市", "sonList": [] }] },
{ "id": 662, "name": "延边州", "sonList": [{ "id": 663, "name": "延吉市", "sonList": [] },
{ "id": 664, "name": "图们市", "sonList": [] },
{ "id": 665, "name": "敦化市", "sonList": [] },
{ "id": 666, "name": "珲春市", "sonList": [] },
{ "id": 667, "name": "龙井市", "sonList": [] },
{ "id": 668, "name": "和龙市", "sonList": [] },
{ "id": 669, "name": "汪清县", "sonList": [] },
{ "id": 670, "name": "安图县", "sonList": [] },
{ "id": 671, "name": "高新区", "sonList": [] }] }] },
{ "id": 672, "name": "黑龙江省", "sonList": [{ "id": 673, "name": "哈尔滨市", "sonList": [{ "id": 674, "name": "道里区", "sonList": [] },
{ "id": 675, "name": "南岗区", "sonList": [] },
{ "id": 676, "name": "道外区", "sonList": [] },
{ "id": 677, "name": "平房区", "sonList": [] },
{ "id": 678, "name": "松北区", "sonList": [] },
{ "id": 679, "name": "香坊区", "sonList": [] },
{ "id": 680, "name": "呼兰区", "sonList": [] },
{ "id": 681, "name": "阿城区", "sonList": [] },
{ "id": 682, "name": "依兰县", "sonList": [] },
{ "id": 683, "name": "方正县", "sonList": [] },
{ "id": 684, "name": "宾县", "sonList": [] },
{ "id": 685, "name": "巴彦县", "sonList": [] },
{ "id": 686, "name": "木兰县", "sonList": [] },
{ "id": 687, "name": "通河县", "sonList": [] },
{ "id": 688, "name": "延寿县", "sonList": [] },
{ "id": 689, "name": "双城市", "sonList": [] },
{ "id": 690, "name": "尚志市", "sonList": [] },
{ "id": 691, "name": "五常市", "sonList": [] },
{ "id": 692, "name": "开发区", "sonList": [] }] },
{ "id": 693, "name": "齐齐哈尔市", "sonList": [{ "id": 694, "name": "龙沙区", "sonList": [] },
{ "id": 695, "name": "建华区", "sonList": [] },
{ "id": 696, "name": "铁锋区", "sonList": [] },
{ "id": 697, "name": "昂昂溪区", "sonList": [] },
{ "id": 698, "name": "富拉尔基区", "sonList": [] },
{ "id": 699, "name": "碾子山区", "sonList": [] },
{ "id": 700, "name": "梅里斯区", "sonList": [] },
{ "id": 701, "name": "龙江县", "sonList": [] },
{ "id": 702, "name": "依安县", "sonList": [] },
{ "id": 703, "name": "泰来县", "sonList": [] },
{ "id": 704, "name": "甘南县", "sonList": [] },
{ "id": 705, "name": "富裕县", "sonList": [] },
{ "id": 706, "name": "克山县", "sonList": [] },
{ "id": 707, "name": "克东县", "sonList": [] },
{ "id": 708, "name": "拜泉县", "sonList": [] },
{ "id": 709, "name": "讷河市", "sonList": [] },
{ "id": 710, "name": "高新区", "sonList": [] }] },
{ "id": 711, "name": "鸡西市", "sonList": [{ "id": 712, "name": "鸡冠区", "sonList": [] },
{ "id": 713, "name": "恒山区", "sonList": [] },
{ "id": 714, "name": "滴道区", "sonList": [] },
{ "id": 715, "name": "梨树区", "sonList": [] },
{ "id": 716, "name": "城子河区", "sonList": [] },
{ "id": 717, "name": "麻山区", "sonList": [] },
{ "id": 718, "name": "鸡东县", "sonList": [] },
{ "id": 719, "name": "虎林市", "sonList": [] },
{ "id": 720, "name": "密山市", "sonList": [] }] },
{ "id": 721, "name": "鹤岗市", "sonList": [{ "id": 722, "name": "向阳区", "sonList": [] },
{ "id": 723, "name": "工农区", "sonList": [] },
{ "id": 724, "name": "南山区", "sonList": [] },
{ "id": 725, "name": "兴安区", "sonList": [] },
{ "id": 726, "name": "东山区", "sonList": [] },
{ "id": 727, "name": "兴山区", "sonList": [] },
{ "id": 728, "name": "萝北县", "sonList": [] },
{ "id": 729, "name": "绥滨县", "sonList": [] }] },
{ "id": 730, "name": "双鸭山市", "sonList": [{ "id": 731, "name": "尖山区", "sonList": [] },
{ "id": 732, "name": "岭东区", "sonList": [] },
{ "id": 733, "name": "四方台区", "sonList": [] },
{ "id": 734, "name": "宝山区", "sonList": [] },
{ "id": 735, "name": "集贤县", "sonList": [] },
{ "id": 736, "name": "友谊县", "sonList": [] },
{ "id": 737, "name": "宝清县", "sonList": [] },
{ "id": 738, "name": "饶河县", "sonList": [] }] },
{ "id": 739, "name": "大庆市", "sonList": [{ "id": 740, "name": "萨尔图区", "sonList": [] },
{ "id": 741, "name": "龙凤区", "sonList": [] },
{ "id": 742, "name": "让胡路区", "sonList": [] },
{ "id": 743, "name": "红岗区", "sonList": [] },
{ "id": 744, "name": "大同区", "sonList": [] },
{ "id": 745, "name": "肇州县", "sonList": [] },
{ "id": 746, "name": "肇源县", "sonList": [] },
{ "id": 747, "name": "林甸县", "sonList": [] },
{ "id": 748, "name": "杜尔伯特县", "sonList": [] },
{ "id": 749, "name": "高新区", "sonList": [] }] },
{ "id": 750, "name": "伊春市", "sonList": [{ "id": 751, "name": "伊春区", "sonList": [] },
{ "id": 752, "name": "南岔区", "sonList": [] },
{ "id": 753, "name": "友好区", "sonList": [] },
{ "id": 754, "name": "西林区", "sonList": [] },
{ "id": 755, "name": "翠峦区", "sonList": [] },
{ "id": 756, "name": "新青区", "sonList": [] },
{ "id": 757, "name": "美溪区", "sonList": [] },
{ "id": 758, "name": "金山屯区", "sonList": [] },
{ "id": 759, "name": "五营区", "sonList": [] },
{ "id": 760, "name": "乌马河区", "sonList": [] },
{ "id": 761, "name": "汤旺河区", "sonList": [] },
{ "id": 762, "name": "带岭区", "sonList": [] },
{ "id": 763, "name": "乌伊岭区", "sonList": [] },
{ "id": 764, "name": "红星区", "sonList": [] },
{ "id": 765, "name": "上甘岭区", "sonList": [] },
{ "id": 766, "name": "嘉荫县", "sonList": [] },
{ "id": 767, "name": "铁力市", "sonList": [] }] },
{ "id": 768, "name": "佳木斯市", "sonList": [{ "id": 769, "name": "向阳区", "sonList": [] },
{ "id": 770, "name": "前进区", "sonList": [] },
{ "id": 771, "name": "东风区", "sonList": [] },
{ "id": 772, "name": "郊区", "sonList": [] },
{ "id": 773, "name": "桦南县", "sonList": [] },
{ "id": 774, "name": "桦川县", "sonList": [] },
{ "id": 775, "name": "汤原县", "sonList": [] },
{ "id": 776, "name": "抚远县", "sonList": [] },
{ "id": 777, "name": "同江市", "sonList": [] },
{ "id": 778, "name": "富锦市", "sonList": [] }] },
{ "id": 779, "name": "七台河市", "sonList": [{ "id": 780, "name": "新兴区", "sonList": [] },
{ "id": 781, "name": "桃山区", "sonList": [] },
{ "id": 782, "name": "茄子河区", "sonList": [] },
{ "id": 783, "name": "勃利县", "sonList": [] }] },
{ "id": 784, "name": "牡丹江市", "sonList": [{ "id": 785, "name": "东安区", "sonList": [] },
{ "id": 786, "name": "阳明区", "sonList": [] },
{ "id": 787, "name": "爱民区", "sonList": [] },
{ "id": 788, "name": "西安区", "sonList": [] },
{ "id": 789, "name": "东宁县", "sonList": [] },
{ "id": 790, "name": "林口县", "sonList": [] },
{ "id": 791, "name": "绥芬河市", "sonList": [] },
{ "id": 792, "name": "海林市", "sonList": [] },
{ "id": 793, "name": "宁安市", "sonList": [] },
{ "id": 794, "name": "穆棱市", "sonList": [] }] },
{ "id": 795, "name": "黑河市", "sonList": [{ "id": 796, "name": "爱辉区", "sonList": [] },
{ "id": 797, "name": "嫩江县", "sonList": [] },
{ "id": 798, "name": "逊克县", "sonList": [] },
{ "id": 799, "name": "孙吴县", "sonList": [] },
{ "id": 800, "name": "北安市", "sonList": [] },
{ "id": 801, "name": "五大连池市", "sonList": [] }] },
{ "id": 802, "name": "绥化市", "sonList": [{ "id": 803, "name": "北林区", "sonList": [] },
{ "id": 804, "name": "望奎县", "sonList": [] },
{ "id": 805, "name": "兰西县", "sonList": [] },
{ "id": 806, "name": "青冈县", "sonList": [] },
{ "id": 807, "name": "庆安县", "sonList": [] },
{ "id": 808, "name": "明水县", "sonList": [] },
{ "id": 809, "name": "绥棱县", "sonList": [] },
{ "id": 810, "name": "安达市", "sonList": [] },
{ "id": 811, "name": "肇东市", "sonList": [] },
{ "id": 812, "name": "海伦市", "sonList": [] }] },
{ "id": 813, "name": "大兴安岭地区", "sonList": [{ "id": 814, "name": "加格达奇区", "sonList": [] },
{ "id": 815, "name": "松岭区", "sonList": [] },
{ "id": 816, "name": "新林区", "sonList": [] },
{ "id": 817, "name": "呼中区", "sonList": [] },
{ "id": 818, "name": "呼玛县", "sonList": [] },
{ "id": 819, "name": "塔河县", "sonList": [] },
{ "id": 820, "name": "漠河县", "sonList": [] }] }] },
{ "id": 821, "name": "上海市", "sonList": [{ "id": 821, "name": "上海市", "sonList": [{ "id": 822, "name": "宝山区", "sonList": [] },
{ "id": 823, "name": "金山区", "sonList": [] },
{ "id": 824, "name": "长宁区", "sonList": [] },
{ "id": 825, "name": "静安区", "sonList": [] },
{ "id": 826, "name": "青浦区", "sonList": [] },
{ "id": 827, "name": "崇明县", "sonList": [] },
{ "id": 828, "name": "松江区", "sonList": [] },
{ "id": 829, "name": "奉贤区", "sonList": [] },
{ "id": 830, "name": "浦东新区", "sonList": [] },
{ "id": 831, "name": "杨浦区", "sonList": [] },
{ "id": 832, "name": "虹口区", "sonList": [] },
{ "id": 833, "name": "普陀区", "sonList": [] },
{ "id": 834, "name": "闸北区", "sonList": [] },
{ "id": 835, "name": "黄浦区", "sonList": [] },
{ "id": 836, "name": "闵行区", "sonList": [] },
{ "id": 837, "name": "徐汇区", "sonList": [] },
{ "id": 838, "name": "嘉定区", "sonList": [] }] }]},
{ "id": 839, "name": "江苏省", "sonList": [{ "id": 840, "name": "南京市", "sonList": [{ "id": 841, "name": "玄武区", "sonList": [] },
{ "id": 842, "name": "白下区", "sonList": [] },
{ "id": 843, "name": "秦淮区", "sonList": [] },
{ "id": 844, "name": "建邺区", "sonList": [] },
{ "id": 845, "name": "鼓楼区", "sonList": [] },
{ "id": 846, "name": "下关区", "sonList": [] },
{ "id": 847, "name": "浦口区", "sonList": [] },
{ "id": 848, "name": "栖霞区", "sonList": [] },
{ "id": 849, "name": "雨花台区", "sonList": [] },
{ "id": 850, "name": "江宁区", "sonList": [] },
{ "id": 851, "name": "六合区", "sonList": [] },
{ "id": 852, "name": "溧水县", "sonList": [] },
{ "id": 853, "name": "高淳县", "sonList": [] },
{ "id": 854, "name": "开发区", "sonList": [] }] },
{ "id": 855, "name": "苏州市", "sonList": [{ "id": 856, "name": "沧浪区", "sonList": [] },
{ "id": 857, "name": "平江区", "sonList": [] },
{ "id": 858, "name": "金阊区", "sonList": [] },
{ "id": 859, "name": "虎丘区", "sonList": [] },
{ "id": 860, "name": "吴中区", "sonList": [] },
{ "id": 861, "name": "相城区", "sonList": [] },
{ "id": 862, "name": "常熟市", "sonList": [] },
{ "id": 863, "name": "张家港市", "sonList": [] },
{ "id": 864, "name": "昆山市", "sonList": [] },
{ "id": 865, "name": "吴江市", "sonList": [] },
{ "id": 866, "name": "太仓市", "sonList": [] },
{ "id": 867, "name": "工业园区", "sonList": [] },
{ "id": 868, "name": "高新区", "sonList": [] }] },
{ "id": 869, "name": "无锡市", "sonList": [{ "id": 870, "name": "崇安区", "sonList": [] },
{ "id": 871, "name": "南长区", "sonList": [] },
{ "id": 872, "name": "北塘区", "sonList": [] },
{ "id": 873, "name": "锡山区", "sonList": [] },
{ "id": 874, "name": "惠山区", "sonList": [] },
{ "id": 875, "name": "滨湖区", "sonList": [] },
{ "id": 876, "name": "江阴市", "sonList": [] },
{ "id": 877, "name": "宜兴市", "sonList": [] },
{ "id": 878, "name": "高新区", "sonList": [] }] },
{ "id": 879, "name": "镇江市", "sonList": [{ "id": 880, "name": "京口区", "sonList": [] },
{ "id": 881, "name": "润州区", "sonList": [] },
{ "id": 882, "name": "丹徒区", "sonList": [] },
{ "id": 883, "name": "丹阳市", "sonList": [] },
{ "id": 884, "name": "扬中市", "sonList": [] },
{ "id": 885, "name": "句容市", "sonList": [] },
{ "id": 886, "name": "开发区", "sonList": [] }] },
{ "id": 887, "name": "扬州市", "sonList": [{ "id": 888, "name": "广陵区", "sonList": [] },
{ "id": 889, "name": "邗江区", "sonList": [] },
{ "id": 890, "name": "宝应县", "sonList": [] },
{ "id": 891, "name": "仪征市", "sonList": [] },
{ "id": 892, "name": "高邮市", "sonList": [] },
{ "id": 893, "name": "江都区", "sonList": [] },
{ "id": 894, "name": "开发区", "sonList": [] }] },
{ "id": 895, "name": "南通市", "sonList": [{ "id": 896, "name": "崇川区", "sonList": [] },
{ "id": 897, "name": "港闸区", "sonList": [] },
{ "id": 898, "name": "海安县", "sonList": [] },
{ "id": 899, "name": "如东县", "sonList": [] },
{ "id": 900, "name": "启东市", "sonList": [] },
{ "id": 901, "name": "如皋市", "sonList": [] },
{ "id": 902, "name": "通州市", "sonList": [] },
{ "id": 903, "name": "海门市", "sonList": [] },
{ "id": 904, "name": "开发区", "sonList": [] }] },
{ "id": 905, "name": "常州市", "sonList": [{ "id": 906, "name": "天宁区", "sonList": [] },
{ "id": 907, "name": "钟楼区", "sonList": [] },
{ "id": 908, "name": "戚墅堰区", "sonList": [] },
{ "id": 909, "name": "新北区", "sonList": [] },
{ "id": 910, "name": "武进区", "sonList": [] },
{ "id": 911, "name": "溧阳市", "sonList": [] },
{ "id": 912, "name": "金坛市", "sonList": [] }] },
{ "id": 913, "name": "徐州市", "sonList": [{ "id": 914, "name": "鼓楼区", "sonList": [] },
{ "id": 915, "name": "云龙区", "sonList": [] },
{ "id": 916, "name": "九里区", "sonList": [] },
{ "id": 917, "name": "贾汪区", "sonList": [] },
{ "id": 918, "name": "泉山区", "sonList": [] },
{ "id": 919, "name": "丰县", "sonList": [] },
{ "id": 920, "name": "沛县", "sonList": [] },
{ "id": 921, "name": "铜山县", "sonList": [] },
{ "id": 922, "name": "睢宁县", "sonList": [] },
{ "id": 923, "name": "新沂市", "sonList": [] },
{ "id": 924, "name": "邳州市", "sonList": [] },
{ "id": 925, "name": "开发区", "sonList": [] }] },
{ "id": 926, "name": "连云港市", "sonList": [{ "id": 927, "name": "连云区", "sonList": [] },
{ "id": 928, "name": "新浦区", "sonList": [] },
{ "id": 929, "name": "海州区", "sonList": [] },
{ "id": 930, "name": "赣榆县", "sonList": [] },
{ "id": 931, "name": "东海县", "sonList": [] },
{ "id": 932, "name": "灌云县", "sonList": [] },
{ "id": 933, "name": "灌南县", "sonList": [] },
{ "id": 934, "name": "开发区", "sonList": [] }] },
{ "id": 935, "name": "盐城市", "sonList": [{ "id": 936, "name": "亭湖区", "sonList": [] },
{ "id": 937, "name": "盐都区", "sonList": [] },
{ "id": 938, "name": "响水县", "sonList": [] },
{ "id": 939, "name": "滨海县", "sonList": [] },
{ "id": 940, "name": "阜宁县", "sonList": [] },
{ "id": 941, "name": "射阳县", "sonList": [] },
{ "id": 942, "name": "建湖县", "sonList": [] },
{ "id": 943, "name": "东台市", "sonList": [] },
{ "id": 944, "name": "大丰市", "sonList": [] },
{ "id": 945, "name": "开发区", "sonList": [] }] },
{ "id": 946, "name": "淮安市", "sonList": [{ "id": 947, "name": "清河区", "sonList": [] },
{ "id": 948, "name": "楚州区", "sonList": [] },
{ "id": 949, "name": "淮阴区", "sonList": [] },
{ "id": 950, "name": "清浦区", "sonList": [] },
{ "id": 951, "name": "涟水县", "sonList": [] },
{ "id": 952, "name": "洪泽县", "sonList": [] },
{ "id": 953, "name": "盱眙县", "sonList": [] },
{ "id": 954, "name": "金湖县", "sonList": [] },
{ "id": 955, "name": "开发区", "sonList": [] }] },
{ "id": 956, "name": "泰州市", "sonList": [{ "id": 957, "name": "海陵区", "sonList": [] },
{ "id": 958, "name": "高港区", "sonList": [] },
{ "id": 959, "name": "兴化市", "sonList": [] },
{ "id": 960, "name": "靖江市", "sonList": [] },
{ "id": 961, "name": "泰兴市", "sonList": [] },
{ "id": 962, "name": "姜堰市", "sonList": [] },
{ "id": 963, "name": "高新区", "sonList": [] }] },
{ "id": 964, "name": "宿迁市", "sonList": [{ "id": 965, "name": "宿城区", "sonList": [] },
{ "id": 966, "name": "宿豫区", "sonList": [] },
{ "id": 967, "name": "沭阳县", "sonList": [] },
{ "id": 968, "name": "泗阳县", "sonList": [] },
{ "id": 969, "name": "泗洪县", "sonList": [] }] }] },
{ "id": 970, "name": "山东省", "sonList": [{ "id": 971, "name": "济南市", "sonList": [{ "id": 972, "name": "历下区", "sonList": [] },
{ "id": 973, "name": "市中区", "sonList": [] },
{ "id": 974, "name": "槐荫区", "sonList": [] },
{ "id": 975, "name": "天桥区", "sonList": [] },
{ "id": 976, "name": "历城区", "sonList": [] },
{ "id": 977, "name": "长清区", "sonList": [] },
{ "id": 978, "name": "平阴县", "sonList": [] },
{ "id": 979, "name": "济阳县", "sonList": [] },
{ "id": 980, "name": "商河县", "sonList": [] },
{ "id": 981, "name": "章丘市", "sonList": [] },
{ "id": 982, "name": "高新区", "sonList": [] }] },
{ "id": 983, "name": "青岛市", "sonList": [{ "id": 984, "name": "市南区", "sonList": [] },
{ "id": 985, "name": "市北区", "sonList": [] },
{ "id": 986, "name": "四方区", "sonList": [] },
{ "id": 987, "name": "黄岛区", "sonList": [] },
{ "id": 988, "name": "崂山区", "sonList": [] },
{ "id": 989, "name": "李沧区", "sonList": [] },
{ "id": 990, "name": "城阳区", "sonList": [] },
{ "id": 991, "name": "胶州市", "sonList": [] },
{ "id": 992, "name": "即墨市", "sonList": [] },
{ "id": 993, "name": "平度市", "sonList": [] },
{ "id": 994, "name": "胶南市", "sonList": [] },
{ "id": 995, "name": "莱西市", "sonList": [] },
{ "id": 996, "name": "开发区", "sonList": [] }] },
{ "id": 997, "name": "烟台市", "sonList": [{ "id": 998, "name": "芝罘区", "sonList": [] },
{ "id": 999, "name": "福山区", "sonList": [] },
{ "id": 1000, "name": "牟平区", "sonList": [] },
{ "id": 1001, "name": "莱山区", "sonList": [] },
{ "id": 1002, "name": "长岛县", "sonList": [] },
{ "id": 1003, "name": "龙口市", "sonList": [] },
{ "id": 1004, "name": "莱阳市", "sonList": [] },
{ "id": 1005, "name": "莱州市", "sonList": [] },
{ "id": 1006, "name": "蓬莱市", "sonList": [] },
{ "id": 1007, "name": "招远市", "sonList": [] },
{ "id": 1008, "name": "栖霞市", "sonList": [] },
{ "id": 1009, "name": "海阳市", "sonList": [] },
{ "id": 1010, "name": "高新区", "sonList": [] },
{ "id": 1011, "name": "开发区", "sonList": [] }] },
{ "id": 1012, "name": "淄博市", "sonList": [{ "id": 1013, "name": "淄川区", "sonList": [] },
{ "id": 1014, "name": "张店区", "sonList": [] },
{ "id": 1015, "name": "博山区", "sonList": [] },
{ "id": 1016, "name": "临淄区", "sonList": [] },
{ "id": 1017, "name": "周村区", "sonList": [] },
{ "id": 1018, "name": "桓台县", "sonList": [] },
{ "id": 1019, "name": "高青县", "sonList": [] },
{ "id": 1020, "name": "沂源县", "sonList": [] },
{ "id": 1021, "name": "高新区", "sonList": [] }] },
{ "id": 1022, "name": "泰安市", "sonList": [{ "id": 1023, "name": "泰山区", "sonList": [] },
{ "id": 1024, "name": "岱岳区", "sonList": [] },
{ "id": 1025, "name": "宁阳县", "sonList": [] },
{ "id": 1026, "name": "东平县", "sonList": [] },
{ "id": 1027, "name": "新泰市", "sonList": [] },
{ "id": 1028, "name": "肥城市", "sonList": [] }] },
{ "id": 1029, "name": "潍坊市", "sonList": [{ "id": 1030, "name": "潍城区", "sonList": [] },
{ "id": 1031, "name": "寒亭区", "sonList": [] },
{ "id": 1032, "name": "坊子区", "sonList": [] },
{ "id": 1033, "name": "奎文区", "sonList": [] },
{ "id": 1034, "name": "临朐县", "sonList": [] },
{ "id": 1035, "name": "昌乐县", "sonList": [] },
{ "id": 1036, "name": "青州市", "sonList": [] },
{ "id": 1037, "name": "诸城市", "sonList": [] },
{ "id": 1038, "name": "寿光市", "sonList": [] },
{ "id": 1039, "name": "安丘市", "sonList": [] },
{ "id": 1040, "name": "高密市", "sonList": [] },
{ "id": 1041, "name": "昌邑市", "sonList": [] },
{ "id": 1042, "name": "开发区", "sonList": [] }] },
{ "id": 1043, "name": "济宁市", "sonList": [{ "id": 1044, "name": "市中区", "sonList": [] },
{ "id": 1045, "name": "任城区", "sonList": [] },
{ "id": 1046, "name": "微山县", "sonList": [] },
{ "id": 1047, "name": "鱼台县", "sonList": [] },
{ "id": 1048, "name": "金乡县", "sonList": [] },
{ "id": 1049, "name": "嘉祥县", "sonList": [] },
{ "id": 1050, "name": "汶上县", "sonList": [] },
{ "id": 1051, "name": "泗水县", "sonList": [] },
{ "id": 1052, "name": "梁山县", "sonList": [] },
{ "id": 1053, "name": "曲阜市", "sonList": [] },
{ "id": 1054, "name": "兖州市", "sonList": [] },
{ "id": 1055, "name": "邹城市", "sonList": [] },
{ "id": 1056, "name": "高新区", "sonList": [] }] },
{ "id": 1057, "name": "枣庄市", "sonList": [{ "id": 1058, "name": "市中区", "sonList": [] },
{ "id": 1059, "name": "薛城区", "sonList": [] },
{ "id": 1060, "name": "峄城区", "sonList": [] },
{ "id": 1061, "name": "台儿庄区", "sonList": [] },
{ "id": 1062, "name": "山亭区", "sonList": [] },
{ "id": 1063, "name": "滕州市", "sonList": [] },
{ "id": 1064, "name": "高新区", "sonList": [] }] },
{ "id": 1065, "name": "德州市", "sonList": [{ "id": 1066, "name": "德城区", "sonList": [] },
{ "id": 1067, "name": "陵县", "sonList": [] },
{ "id": 1068, "name": "宁津县", "sonList": [] },
{ "id": 1069, "name": "庆云县", "sonList": [] },
{ "id": 1070, "name": "临邑县", "sonList": [] },
{ "id": 1071, "name": "齐河县", "sonList": [] },
{ "id": 1072, "name": "平原县", "sonList": [] },
{ "id": 1073, "name": "夏津县", "sonList": [] },
{ "id": 1074, "name": "武城县", "sonList": [] },
{ "id": 1075, "name": "乐陵市", "sonList": [] },
{ "id": 1076, "name": "禹城市", "sonList": [] }] },
{ "id": 1077, "name": "威海市", "sonList": [{ "id": 1078, "name": "环翠区", "sonList": [] },
{ "id": 1079, "name": "文登市", "sonList": [] },
{ "id": 1080, "name": "荣成市", "sonList": [] },
{ "id": 1081, "name": "乳山市", "sonList": [] },
{ "id": 1082, "name": "开发区", "sonList": [] }] },
{ "id": 1083, "name": "日照市", "sonList": [{ "id": 1084, "name": "东港区", "sonList": [] },
{ "id": 1085, "name": "岚山区", "sonList": [] },
{ "id": 1086, "name": "五莲县", "sonList": [] },
{ "id": 1087, "name": "莒县", "sonList": [] },
{ "id": 1088, "name": "开发区", "sonList": [] }] },
{ "id": 1089, "name": "莱芜市", "sonList": [{ "id": 1090, "name": "莱城区", "sonList": [] },
{ "id": 1091, "name": "钢城区", "sonList": [] }] },
{ "id": 1092, "name": "滨州市", "sonList": [{ "id": 1093, "name": "滨城区", "sonList": [] },
{ "id": 1094, "name": "惠民县", "sonList": [] },
{ "id": 1095, "name": "阳信县", "sonList": [] },
{ "id": 1096, "name": "无棣县", "sonList": [] },
{ "id": 1097, "name": "沾化县", "sonList": [] },
{ "id": 1098, "name": "博兴县", "sonList": [] },
{ "id": 1099, "name": "邹平县", "sonList": [] }] },
{ "id": 1100, "name": "东营市", "sonList": [{ "id": 1101, "name": "东营区", "sonList": [] },
{ "id": 1102, "name": "河口区", "sonList": [] },
{ "id": 1103, "name": "垦利县", "sonList": [] },
{ "id": 1104, "name": "利津县", "sonList": [] },
{ "id": 1105, "name": "广饶县", "sonList": [] },
{ "id": 1106, "name": "开发区", "sonList": [] }] },
{ "id": 1107, "name": "聊城市", "sonList": [{ "id": 1108, "name": "东昌府区", "sonList": [] },
{ "id": 1109, "name": "阳谷县", "sonList": [] },
{ "id": 1110, "name": "莘县", "sonList": [] },
{ "id": 1111, "name": "茌平县", "sonList": [] },
{ "id": 1112, "name": "东阿县", "sonList": [] },
{ "id": 1113, "name": "冠县", "sonList": [] },
{ "id": 1114, "name": "高唐县", "sonList": [] },
{ "id": 1115, "name": "临清市", "sonList": [] },
{ "id": 1116, "name": "高新区", "sonList": [] }] },
{ "id": 1117, "name": "菏泽市", "sonList": [{ "id": 1118, "name": "牡丹区", "sonList": [] },
{ "id": 1119, "name": "曹县", "sonList": [] },
{ "id": 1120, "name": "单县", "sonList": [] },
{ "id": 1121, "name": "成武县", "sonList": [] },
{ "id": 1122, "name": "巨野县", "sonList": [] },
{ "id": 1123, "name": "郓城县", "sonList": [] },
{ "id": 1124, "name": "鄄城县", "sonList": [] },
{ "id": 1125, "name": "定陶县", "sonList": [] },
{ "id": 1126, "name": "东明县", "sonList": [] }] },
{ "id": 1127, "name": "临沂市", "sonList": [{ "id": 1128, "name": "兰山区", "sonList": [] },
{ "id": 1129, "name": "罗庄区", "sonList": [] },
{ "id": 1130, "name": "河东区", "sonList": [] },
{ "id": 1131, "name": "沂南县", "sonList": [] },
{ "id": 1132, "name": "郯城县", "sonList": [] },
{ "id": 1133, "name": "沂水县", "sonList": [] },
{ "id": 1134, "name": "苍山县", "sonList": [] },
{ "id": 1135, "name": "费县", "sonList": [] },
{ "id": 1136, "name": "平邑县", "sonList": [] },
{ "id": 1137, "name": "莒南县", "sonList": [] },
{ "id": 1138, "name": "蒙阴县", "sonList": [] },
{ "id": 1139, "name": "临沭县", "sonList": [] },
{ "id": 1140, "name": "开发区", "sonList": [] }] }] },
{ "id": 1141, "name": "安徽省", "sonList": [{ "id": 1142, "name": "合肥市", "sonList": [{ "id": 1143, "name": "瑶海区", "sonList": [] },
{ "id": 1144, "name": "庐阳区", "sonList": [] },
{ "id": 1145, "name": "蜀山区", "sonList": [] },
{ "id": 1146, "name": "包河区", "sonList": [] },
{ "id": 1147, "name": "长丰县", "sonList": [] },
{ "id": 1148, "name": "肥东县", "sonList": [] },
{ "id": 1149, "name": "肥西县", "sonList": [] },
{ "id": 1150, "name": "开发区", "sonList": [] }] },
{ "id": 1151, "name": "芜湖市", "sonList": [{ "id": 1152, "name": "镜湖区", "sonList": [] },
{ "id": 1153, "name": "弋江区", "sonList": [] },
{ "id": 1154, "name": "鸠江区", "sonList": [] },
{ "id": 1155, "name": "三山区", "sonList": [] },
{ "id": 1156, "name": "芜湖县", "sonList": [] },
{ "id": 1157, "name": "繁昌县", "sonList": [] },
{ "id": 1158, "name": "南陵县", "sonList": [] },
{ "id": 1159, "name": "开发区", "sonList": [] }] },
{ "id": 1160, "name": "蚌埠市", "sonList": [{ "id": 1161, "name": "龙子湖区", "sonList": [] },
{ "id": 1162, "name": "蚌山区", "sonList": [] },
{ "id": 1163, "name": "禹会区", "sonList": [] },
{ "id": 1164, "name": "淮上区", "sonList": [] },
{ "id": 1165, "name": "怀远县", "sonList": [] },
{ "id": 1166, "name": "五河县", "sonList": [] },
{ "id": 1167, "name": "固镇县", "sonList": [] },
{ "id": 1168, "name": "高新区", "sonList": [] }] },
{ "id": 1169, "name": "马鞍山市", "sonList": [{ "id": 1170, "name": "金家庄区", "sonList": [] },
{ "id": 1171, "name": "花山区", "sonList": [] },
{ "id": 1172, "name": "雨山区", "sonList": [] },
{ "id": 1173, "name": "当涂县", "sonList": [] },
{ "id": 1174, "name": "开发区", "sonList": [] }] },
{ "id": 1175, "name": "淮北市", "sonList": [{ "id": 1176, "name": "杜集区", "sonList": [] },
{ "id": 1177, "name": "相山区", "sonList": [] },
{ "id": 1178, "name": "烈山区", "sonList": [] },
{ "id": 1179, "name": "濉溪县", "sonList": [] }] },
{ "id": 1180, "name": "铜陵市", "sonList": [{ "id": 1181, "name": "铜官山区", "sonList": [] },
{ "id": 1182, "name": "狮子山区", "sonList": [] },
{ "id": 1183, "name": "郊区", "sonList": [] },
{ "id": 1184, "name": "铜陵县", "sonList": [] },
{ "id": 1185, "name": "开发区", "sonList": [] }] },
{ "id": 1186, "name": "安庆市", "sonList": [{ "id": 1187, "name": "迎江区", "sonList": [] },
{ "id": 1188, "name": "大观区", "sonList": [] },
{ "id": 1189, "name": "宜秀区", "sonList": [] },
{ "id": 1190, "name": "怀宁县", "sonList": [] },
{ "id": 1191, "name": "枞阳县", "sonList": [] },
{ "id": 1192, "name": "潜山县", "sonList": [] },
{ "id": 1193, "name": "太湖县", "sonList": [] },
{ "id": 1194, "name": "宿松县", "sonList": [] },
{ "id": 1195, "name": "望江县", "sonList": [] },
{ "id": 1196, "name": "岳西县", "sonList": [] },
{ "id": 1197, "name": "桐城市", "sonList": [] },
{ "id": 1198, "name": "开发区", "sonList": [] }] },
{ "id": 1199, "name": "黄山市", "sonList": [{ "id": 1200, "name": "屯溪区", "sonList": [] },
{ "id": 1201, "name": "黄山区", "sonList": [] },
{ "id": 1202, "name": "徽州区", "sonList": [] },
{ "id": 1203, "name": "歙县", "sonList": [] },
{ "id": 1204, "name": "休宁县", "sonList": [] },
{ "id": 1205, "name": "黟县", "sonList": [] },
{ "id": 1206, "name": "祁门县", "sonList": [] }] },
{ "id": 1207, "name": "滁州市", "sonList": [{ "id": 1208, "name": "琅琊区", "sonList": [] },
{ "id": 1209, "name": "南谯区", "sonList": [] },
{ "id": 1210, "name": "来安县", "sonList": [] },
{ "id": 1211, "name": "全椒县", "sonList": [] },
{ "id": 1212, "name": "定远县", "sonList": [] },
{ "id": 1213, "name": "凤阳县", "sonList": [] },
{ "id": 1214, "name": "天长市", "sonList": [] },
{ "id": 1215, "name": "明光市", "sonList": [] }] },
{ "id": 1216, "name": "宿州市", "sonList": [{ "id": 1217, "name": "埇桥区", "sonList": [] },
{ "id": 1218, "name": "砀山县", "sonList": [] },
{ "id": 1219, "name": "萧县", "sonList": [] },
{ "id": 1220, "name": "灵璧县", "sonList": [] },
{ "id": 1221, "name": "泗县", "sonList": [] }] },
{ "id": 1222, "name": "池州市", "sonList": [{ "id": 1223, "name": "贵池区", "sonList": [] },
{ "id": 1224, "name": "东至县", "sonList": [] },
{ "id": 1225, "name": "石台县", "sonList": [] },
{ "id": 1226, "name": "青阳县", "sonList": [] }] },
{ "id": 1227, "name": "淮南市", "sonList": [{ "id": 1228, "name": "大通区", "sonList": [] },
{ "id": 1229, "name": "田家庵区", "sonList": [] },
{ "id": 1230, "name": "谢家集区", "sonList": [] },
{ "id": 1231, "name": "八公山区", "sonList": [] },
{ "id": 1232, "name": "潘集区", "sonList": [] },
{ "id": 1233, "name": "凤台县", "sonList": [] }] },
{ "id": 1234, "name": "巢湖市", "sonList": [{ "id": 1235, "name": "居巢区", "sonList": [] },
{ "id": 1236, "name": "庐江县", "sonList": [] },
{ "id": 1237, "name": "无为县", "sonList": [] },
{ "id": 1238, "name": "含山县", "sonList": [] },
{ "id": 1239, "name": "和县", "sonList": [] }] },
{ "id": 1240, "name": "阜阳市", "sonList": [{ "id": 1241, "name": "颍州区", "sonList": [] },
{ "id": 1242, "name": "颍东区", "sonList": [] },
{ "id": 1243, "name": "颍泉区", "sonList": [] },
{ "id": 1244, "name": "临泉县", "sonList": [] },
{ "id": 1245, "name": "太和县", "sonList": [] },
{ "id": 1246, "name": "阜南县", "sonList": [] },
{ "id": 1247, "name": "颍上县", "sonList": [] },
{ "id": 1248, "name": "界首市", "sonList": [] }] },
{ "id": 1249, "name": "六安市", "sonList": [{ "id": 1250, "name": "金安区", "sonList": [] },
{ "id": 1251, "name": "裕安区", "sonList": [] },
{ "id": 1252, "name": "寿县", "sonList": [] },
{ "id": 1253, "name": "霍邱县", "sonList": [] },
{ "id": 1254, "name": "舒城县", "sonList": [] },
{ "id": 1255, "name": "金寨县", "sonList": [] },
{ "id": 1256, "name": "霍山县", "sonList": [] }] },
{ "id": 1257, "name": "宣城市", "sonList": [{ "id": 1258, "name": "宣州区", "sonList": [] },
{ "id": 1259, "name": "郎溪县", "sonList": [] },
{ "id": 1260, "name": "广德县", "sonList": [] },
{ "id": 1261, "name": "泾县", "sonList": [] },
{ "id": 1262, "name": "绩溪县", "sonList": [] },
{ "id": 1263, "name": "旌德县", "sonList": [] },
{ "id": 1264, "name": "宁国市", "sonList": [] }] },
{ "id": 1265, "name": "亳州市", "sonList": [{ "id": 1266, "name": "谯城区", "sonList": [] },
{ "id": 1267, "name": "涡阳县", "sonList": [] },
{ "id": 1268, "name": "蒙城县", "sonList": [] },
{ "id": 1269, "name": "利辛县", "sonList": [] }] }] },
{ "id": 1270, "name": "福建省", "sonList": [{ "id": 1271, "name": "福州市", "sonList": [{ "id": 1272, "name": "鼓楼区", "sonList": [] },
{ "id": 1273, "name": "台江区", "sonList": [] },
{ "id": 1274, "name": "仓山区", "sonList": [] },
{ "id": 1275, "name": "马尾区", "sonList": [] },
{ "id": 1276, "name": "晋安区", "sonList": [] },
{ "id": 1277, "name": "闽侯县", "sonList": [] },
{ "id": 1278, "name": "连江县", "sonList": [] },
{ "id": 1279, "name": "罗源县", "sonList": [] },
{ "id": 1280, "name": "闽清县", "sonList": [] },
{ "id": 1281, "name": "永泰县", "sonList": [] },
{ "id": 1282, "name": "平潭县", "sonList": [] },
{ "id": 1283, "name": "福清市", "sonList": [] },
{ "id": 1284, "name": "长乐市", "sonList": [] },
{ "id": 1285, "name": "开发区", "sonList": [] }] },
{ "id": 1286, "name": "厦门市", "sonList": [{ "id": 1287, "name": "思明区", "sonList": [] },
{ "id": 1288, "name": "海沧区", "sonList": [] },
{ "id": 1289, "name": "湖里区", "sonList": [] },
{ "id": 1290, "name": "集美区", "sonList": [] },
{ "id": 1291, "name": "同安区", "sonList": [] },
{ "id": 1292, "name": "翔安区", "sonList": [] },
{ "id": 1293, "name": "开发区", "sonList": [] }] },
{ "id": 1294, "name": "漳州市", "sonList": [{ "id": 1295, "name": "芗城区", "sonList": [] },
{ "id": 1296, "name": "龙文区", "sonList": [] },
{ "id": 1297, "name": "云霄县", "sonList": [] },
{ "id": 1298, "name": "漳浦县", "sonList": [] },
{ "id": 1299, "name": "诏安县", "sonList": [] },
{ "id": 1300, "name": "长泰县", "sonList": [] },
{ "id": 1301, "name": "东山县", "sonList": [] },
{ "id": 1302, "name": "南靖县", "sonList": [] },
{ "id": 1303, "name": "平和县", "sonList": [] },
{ "id": 1304, "name": "华安县", "sonList": [] },
{ "id": 1305, "name": "龙海市", "sonList": [] },
{ "id": 1306, "name": "开发区", "sonList": [] }] },
{ "id": 1307, "name": "泉州市", "sonList": [{ "id": 1308, "name": "鲤城区", "sonList": [] },
{ "id": 1309, "name": "丰泽区", "sonList": [] },
{ "id": 1310, "name": "洛江区", "sonList": [] },
{ "id": 1311, "name": "泉港区", "sonList": [] },
{ "id": 1312, "name": "惠安县", "sonList": [] },
{ "id": 1313, "name": "安溪县", "sonList": [] },
{ "id": 1314, "name": "永春县", "sonList": [] },
{ "id": 1315, "name": "德化县", "sonList": [] },
{ "id": 1316, "name": "金门县", "sonList": [] },
{ "id": 1317, "name": "石狮市", "sonList": [] },
{ "id": 1318, "name": "晋江市", "sonList": [] },
{ "id": 1319, "name": "南安市", "sonList": [] },
{ "id": 1320, "name": "开发区", "sonList": [] }] },
{ "id": 1321, "name": "莆田市", "sonList": [{ "id": 1322, "name": "城厢区", "sonList": [] },
{ "id": 1323, "name": "涵江区", "sonList": [] },
{ "id": 1324, "name": "荔城区", "sonList": [] },
{ "id": 1325, "name": "秀屿区", "sonList": [] },
{ "id": 1326, "name": "仙游县", "sonList": [] }] },
{ "id": 1327, "name": "三明市", "sonList": [{ "id": 1328, "name": "梅列区", "sonList": [] },
{ "id": 1329, "name": "三元区", "sonList": [] },
{ "id": 1330, "name": "明溪县", "sonList": [] },
{ "id": 1331, "name": "清流县", "sonList": [] },
{ "id": 1332, "name": "宁化县", "sonList": [] },
{ "id": 1333, "name": "大田县", "sonList": [] },
{ "id": 1334, "name": "尤溪县", "sonList": [] },
{ "id": 1335, "name": "沙县", "sonList": [] },
{ "id": 1336, "name": "将乐县", "sonList": [] },
{ "id": 1337, "name": "泰宁县", "sonList": [] },
{ "id": 1338, "name": "建宁县", "sonList": [] },
{ "id": 1339, "name": "永安市", "sonList": [] }] },
{ "id": 1340, "name": "南平市", "sonList": [{ "id": 1341, "name": "延平区", "sonList": [] },
{ "id": 1342, "name": "顺昌县", "sonList": [] },
{ "id": 1343, "name": "浦城县", "sonList": [] },
{ "id": 1344, "name": "光泽县", "sonList": [] },
{ "id": 1345, "name": "松溪县", "sonList": [] },
{ "id": 1346, "name": "政和县", "sonList": [] },
{ "id": 1347, "name": "邵武市", "sonList": [] },
{ "id": 1348, "name": "武夷山市", "sonList": [] },
{ "id": 1349, "name": "建瓯市", "sonList": [] },
{ "id": 1350, "name": "建阳市", "sonList": [] }] },
{ "id": 1351, "name": "龙岩市", "sonList": [{ "id": 1352, "name": "新罗区", "sonList": [] },
{ "id": 1353, "name": "长汀县", "sonList": [] },
{ "id": 1354, "name": "永定县", "sonList": [] },
{ "id": 1355, "name": "上杭县", "sonList": [] },
{ "id": 1356, "name": "武平县", "sonList": [] },
{ "id": 1357, "name": "连城县", "sonList": [] },
{ "id": 1358, "name": "漳平市", "sonList": [] }] },
{ "id": 1359, "name": "宁德市", "sonList": [{ "id": 1360, "name": "蕉城区", "sonList": [] },
{ "id": 1361, "name": "霞浦县", "sonList": [] },
{ "id": 1362, "name": "古田县", "sonList": [] },
{ "id": 1363, "name": "屏南县", "sonList": [] },
{ "id": 1364, "name": "寿宁县", "sonList": [] },
{ "id": 1365, "name": "周宁县", "sonList": [] },
{ "id": 1366, "name": "柘荣县", "sonList": [] },
{ "id": 1367, "name": "福安市", "sonList": [] },
{ "id": 1368, "name": "福鼎市", "sonList": [] }] }] },
{ "id": 1369, "name": "浙江省", "sonList": [{ "id": 1370, "name": "杭州市", "sonList": [{ "id": 1371, "name": "上城区", "sonList": [] },
{ "id": 1372, "name": "下城区", "sonList": [] },
{ "id": 1373, "name": "江干区", "sonList": [] },
{ "id": 1374, "name": "拱墅区", "sonList": [] },
{ "id": 1375, "name": "西湖区", "sonList": [] },
{ "id": 1376, "name": "滨江区", "sonList": [] },
{ "id": 1377, "name": "萧山区", "sonList": [] },
{ "id": 1378, "name": "余杭区", "sonList": [] },
{ "id": 1379, "name": "桐庐县", "sonList": [] },
{ "id": 1380, "name": "淳安县", "sonList": [] },
{ "id": 1381, "name": "建德市", "sonList": [] },
{ "id": 1382, "name": "富阳市", "sonList": [] },
{ "id": 1383, "name": "临安市", "sonList": [] },
{ "id": 1384, "name": "开发区", "sonList": [] }] },
{ "id": 1385, "name": "宁波市", "sonList": [{ "id": 1386, "name": "海曙区", "sonList": [] },
{ "id": 1387, "name": "江东区", "sonList": [] },
{ "id": 1388, "name": "江北区", "sonList": [] },
{ "id": 1389, "name": "北仑区", "sonList": [] },
{ "id": 1390, "name": "镇海区", "sonList": [] },
{ "id": 1391, "name": "鄞州区", "sonList": [] },
{ "id": 1392, "name": "象山县", "sonList": [] },
{ "id": 1393, "name": "宁海县", "sonList": [] },
{ "id": 1394, "name": "余姚市", "sonList": [] },
{ "id": 1395, "name": "慈溪市", "sonList": [] },
{ "id": 1396, "name": "奉化市", "sonList": [] },
{ "id": 1397, "name": "开发区", "sonList": [] }] },
{ "id": 1398, "name": "温州市", "sonList": [{ "id": 1399, "name": "鹿城区", "sonList": [] },
{ "id": 1400, "name": "龙湾区", "sonList": [] },
{ "id": 1401, "name": "瓯海区", "sonList": [] },
{ "id": 1402, "name": "洞头县", "sonList": [] },
{ "id": 1403, "name": "永嘉县", "sonList": [] },
{ "id": 1404, "name": "平阳县", "sonList": [] },
{ "id": 1405, "name": "苍南县", "sonList": [] },
{ "id": 1406, "name": "文成县", "sonList": [] },
{ "id": 1407, "name": "泰顺县", "sonList": [] },
{ "id": 1408, "name": "瑞安市", "sonList": [] },
{ "id": 1409, "name": "乐清市", "sonList": [] },
{ "id": 1410, "name": "开发区", "sonList": [] }] },
{ "id": 1411, "name": "嘉兴市", "sonList": [{ "id": 1412, "name": "南湖区", "sonList": [] },
{ "id": 1413, "name": "秀洲区", "sonList": [] },
{ "id": 1414, "name": "嘉善县", "sonList": [] },
{ "id": 1415, "name": "海盐县", "sonList": [] },
{ "id": 1416, "name": "海宁市", "sonList": [] },
{ "id": 1417, "name": "平湖市", "sonList": [] },
{ "id": 1418, "name": "桐乡市", "sonList": [] },
{ "id": 1419, "name": "开发区", "sonList": [] }] },
{ "id": 1420, "name": "湖州市", "sonList": [{ "id": 1421, "name": "吴兴区", "sonList": [] },
{ "id": 1422, "name": "南浔区", "sonList": [] },
{ "id": 1423, "name": "德清县", "sonList": [] },
{ "id": 1424, "name": "长兴县", "sonList": [] },
{ "id": 1425, "name": "安吉县", "sonList": [] },
{ "id": 1426, "name": "开发区", "sonList": [] }] },
{ "id": 1427, "name": "绍兴市", "sonList": [{ "id": 1428, "name": "越城区", "sonList": [] },
{ "id": 1429, "name": "绍兴县", "sonList": [] },
{ "id": 1430, "name": "新昌县", "sonList": [] },
{ "id": 1431, "name": "诸暨市", "sonList": [] },
{ "id": 1432, "name": "上虞市", "sonList": [] },
{ "id": 1433, "name": "嵊州市", "sonList": [] },
{ "id": 1434, "name": "开发区", "sonList": [] }] },
{ "id": 1435, "name": "金华市", "sonList": [{ "id": 1436, "name": "婺城区", "sonList": [] },
{ "id": 1437, "name": "金东区", "sonList": [] },
{ "id": 1438, "name": "武义县", "sonList": [] },
{ "id": 1439, "name": "浦江县", "sonList": [] },
{ "id": 1440, "name": "磐安县", "sonList": [] },
{ "id": 1441, "name": "兰溪市", "sonList": [] },
{ "id": 1442, "name": "义乌市", "sonList": [] },
{ "id": 1443, "name": "东阳市", "sonList": [] },
{ "id": 1444, "name": "永康市", "sonList": [] },
{ "id": 1445, "name": "开发区", "sonList": [] }] },
{ "id": 1446, "name": "衢州市", "sonList": [{ "id": 1447, "name": "柯城区", "sonList": [] },
{ "id": 1448, "name": "衢江区", "sonList": [] },
{ "id": 1449, "name": "常山县", "sonList": [] },
{ "id": 1450, "name": "开化县", "sonList": [] },
{ "id": 1451, "name": "龙游县", "sonList": [] },
{ "id": 1452, "name": "江山市", "sonList": [] }] },
{ "id": 1453, "name": "舟山市", "sonList": [{ "id": 1454, "name": "定海区", "sonList": [] },
{ "id": 1455, "name": "普陀区", "sonList": [] },
{ "id": 1456, "name": "岱山县", "sonList": [] },
{ "id": 1457, "name": "嵊泗县", "sonList": [] }] },
{ "id": 1458, "name": "台州市", "sonList": [{ "id": 1459, "name": "椒江区", "sonList": [] },
{ "id": 1460, "name": "黄岩区", "sonList": [] },
{ "id": 1461, "name": "路桥区", "sonList": [] },
{ "id": 1462, "name": "玉环县", "sonList": [] },
{ "id": 1463, "name": "三门县", "sonList": [] },
{ "id": 1464, "name": "天台县", "sonList": [] },
{ "id": 1465, "name": "仙居县", "sonList": [] },
{ "id": 1466, "name": "温岭市", "sonList": [] },
{ "id": 1467, "name": "临海市", "sonList": [] }] },
{ "id": 1468, "name": "丽水市", "sonList": [{ "id": 1469, "name": "莲都区", "sonList": [] },
{ "id": 1470, "name": "青田县", "sonList": [] },
{ "id": 1471, "name": "缙云县", "sonList": [] },
{ "id": 1472, "name": "遂昌县", "sonList": [] },
{ "id": 1473, "name": "松阳县", "sonList": [] },
{ "id": 1474, "name": "云和县", "sonList": [] },
{ "id": 1475, "name": "庆元县", "sonList": [] },
{ "id": 1476, "name": "景宁县", "sonList": [] },
{ "id": 1477, "name": "龙泉市", "sonList": [] }] }] },
{ "id": 1478, "name": "江西省", "sonList": [{ "id": 1479, "name": "南昌市", "sonList": [{ "id": 1480, "name": "东湖区", "sonList": [] },
{ "id": 1481, "name": "西湖区", "sonList": [] },
{ "id": 1482, "name": "青云谱区", "sonList": [] },
{ "id": 1483, "name": "湾里区", "sonList": [] },
{ "id": 1484, "name": "青山湖区", "sonList": [] },
{ "id": 1485, "name": "南昌县", "sonList": [] },
{ "id": 1486, "name": "新建县", "sonList": [] },
{ "id": 1487, "name": "安义县", "sonList": [] },
{ "id": 1488, "name": "进贤县", "sonList": [] },
{ "id": 1489, "name": "开发区", "sonList": [] }] },
{ "id": 1490, "name": "景德镇市", "sonList": [{ "id": 1491, "name": "昌江区", "sonList": [] },
{ "id": 1492, "name": "珠山区", "sonList": [] },
{ "id": 1493, "name": "浮梁县", "sonList": [] },
{ "id": 1494, "name": "乐平市", "sonList": [] },
{ "id": 1495, "name": "高新区", "sonList": [] }] },
{ "id": 1496, "name": "萍乡市", "sonList": [{ "id": 1497, "name": "安源区", "sonList": [] },
{ "id": 1498, "name": "湘东区", "sonList": [] },
{ "id": 1499, "name": "莲花县", "sonList": [] },
{ "id": 1500, "name": "上栗县", "sonList": [] },
{ "id": 1501, "name": "芦溪县", "sonList": [] },
{ "id": 1502, "name": "开发区", "sonList": [] }] },
{ "id": 1503, "name": "九江市", "sonList": [{ "id": 1504, "name": "庐山区", "sonList": [] },
{ "id": 1505, "name": "浔阳区", "sonList": [] },
{ "id": 1506, "name": "九江县", "sonList": [] },
{ "id": 1507, "name": "武宁县", "sonList": [] },
{ "id": 1508, "name": "修水县", "sonList": [] },
{ "id": 1509, "name": "永修县", "sonList": [] },
{ "id": 1510, "name": "德安县", "sonList": [] },
{ "id": 1511, "name": "星子县", "sonList": [] },
{ "id": 1512, "name": "都昌县", "sonList": [] },
{ "id": 1513, "name": "湖口县", "sonList": [] },
{ "id": 1514, "name": "彭泽县", "sonList": [] },
{ "id": 1515, "name": "瑞昌市", "sonList": [] },
{ "id": 1516, "name": "开发区", "sonList": [] }] },
{ "id": 1517, "name": "新余市", "sonList": [{ "id": 1518, "name": "渝水区", "sonList": [] },
{ "id": 1519, "name": "分宜县", "sonList": [] },
{ "id": 1520, "name": "高新区", "sonList": [] }] },
{ "id": 1521, "name": "鹰潭市", "sonList": [{ "id": 1522, "name": "月湖区", "sonList": [] },
{ "id": 1523, "name": "余江县", "sonList": [] },
{ "id": 1524, "name": "贵溪市", "sonList": [] }] },
{ "id": 1525, "name": "赣州市", "sonList": [{ "id": 1526, "name": "章贡区", "sonList": [] },
{ "id": 1527, "name": "赣县", "sonList": [] },
{ "id": 1528, "name": "信丰县", "sonList": [] },
{ "id": 1529, "name": "大余县", "sonList": [] },
{ "id": 1530, "name": "上犹县", "sonList": [] },
{ "id": 1531, "name": "崇义县", "sonList": [] },
{ "id": 1532, "name": "安远县", "sonList": [] },
{ "id": 1533, "name": "龙南县", "sonList": [] },
{ "id": 1534, "name": "定南县", "sonList": [] },
{ "id": 1535, "name": "全南县", "sonList": [] },
{ "id": 1536, "name": "宁都县", "sonList": [] },
{ "id": 1537, "name": "于都县", "sonList": [] },
{ "id": 1538, "name": "兴国县", "sonList": [] },
{ "id": 1539, "name": "会昌县", "sonList": [] },
{ "id": 1540, "name": "寻乌县", "sonList": [] },
{ "id": 1541, "name": "石城县", "sonList": [] },
{ "id": 1542, "name": "瑞金市", "sonList": [] },
{ "id": 1543, "name": "南康市", "sonList": [] },
{ "id": 1544, "name": "开发区", "sonList": [] }] },
{ "id": 1545, "name": "吉安市", "sonList": [{ "id": 1546, "name": "吉州区", "sonList": [] },
{ "id": 1547, "name": "青原区", "sonList": [] },
{ "id": 1548, "name": "吉安县", "sonList": [] },
{ "id": 1549, "name": "吉水县", "sonList": [] },
{ "id": 1550, "name": "峡江县", "sonList": [] },
{ "id": 1551, "name": "新干县", "sonList": [] },
{ "id": 1552, "name": "永丰县", "sonList": [] },
{ "id": 1553, "name": "泰和县", "sonList": [] },
{ "id": 1554, "name": "遂川县", "sonList": [] },
{ "id": 1555, "name": "万安县", "sonList": [] },
{ "id": 1556, "name": "安福县", "sonList": [] },
{ "id": 1557, "name": "永新县", "sonList": [] },
{ "id": 1558, "name": "井冈山市", "sonList": [] }] },
{ "id": 1559, "name": "宜春市", "sonList": [{ "id": 1560, "name": "袁州区", "sonList": [] },
{ "id": 1561, "name": "奉新县", "sonList": [] },
{ "id": 1562, "name": "万载县", "sonList": [] },
{ "id": 1563, "name": "上高县", "sonList": [] },
{ "id": 1564, "name": "宜丰县", "sonList": [] },
{ "id": 1565, "name": "靖安县", "sonList": [] },
{ "id": 1566, "name": "铜鼓县", "sonList": [] },
{ "id": 1567, "name": "丰城市", "sonList": [] },
{ "id": 1568, "name": "樟树市", "sonList": [] },
{ "id": 1569, "name": "高安市", "sonList": [] }] },
{ "id": 1570, "name": "抚州市", "sonList": [{ "id": 1571, "name": "临川区", "sonList": [] },
{ "id": 1572, "name": "南城县", "sonList": [] },
{ "id": 1573, "name": "黎川县", "sonList": [] },
{ "id": 1574, "name": "南丰县", "sonList": [] },
{ "id": 1575, "name": "崇仁县", "sonList": [] },
{ "id": 1576, "name": "乐安县", "sonList": [] },
{ "id": 1577, "name": "宜黄县", "sonList": [] },
{ "id": 1578, "name": "金溪县", "sonList": [] },
{ "id": 1579, "name": "资溪县", "sonList": [] },
{ "id": 1580, "name": "东乡县", "sonList": [] },
{ "id": 1581, "name": "广昌县", "sonList": [] }] },
{ "id": 1582, "name": "上饶市", "sonList": [{ "id": 1583, "name": "信州区", "sonList": [] },
{ "id": 1584, "name": "上饶县", "sonList": [] },
{ "id": 1585, "name": "广丰县", "sonList": [] },
{ "id": 1586, "name": "玉山县", "sonList": [] },
{ "id": 1587, "name": "铅山县", "sonList": [] },
{ "id": 1588, "name": "横峰县", "sonList": [] },
{ "id": 1589, "name": "弋阳县", "sonList": [] },
{ "id": 1590, "name": "余干县", "sonList": [] },
{ "id": 1591, "name": "鄱阳县", "sonList": [] },
{ "id": 1592, "name": "万年县", "sonList": [] },
{ "id": 1593, "name": "婺源县", "sonList": [] },
{ "id": 1594, "name": "德兴市", "sonList": [] },
{ "id": 1595, "name": "开发区", "sonList": [] }] }] },
{ "id": 1596, "name": "广东省", "sonList": [{ "id": 1597, "name": "广州市", "sonList": [{ "id": 1598, "name": "荔湾区", "sonList": [] },
{ "id": 1599, "name": "越秀区", "sonList": [] },
{ "id": 1600, "name": "海珠区", "sonList": [] },
{ "id": 1601, "name": "天河区", "sonList": [] },
{ "id": 1602, "name": "白云区", "sonList": [] },
{ "id": 1603, "name": "黄埔区", "sonList": [] },
{ "id": 1604, "name": "番禺区", "sonList": [] },
{ "id": 1605, "name": "花都区", "sonList": [] },
{ "id": 1606, "name": "南沙区", "sonList": [] },
{ "id": 1607, "name": "萝岗区", "sonList": [] },
{ "id": 1608, "name": "增城市", "sonList": [] },
{ "id": 1609, "name": "从化市", "sonList": [] },
{ "id": 1610, "name": "开发区", "sonList": [] }] },
{ "id": 1611, "name": "深圳市", "sonList": [{ "id": 1612, "name": "罗湖区", "sonList": [] },
{ "id": 1613, "name": "福田区", "sonList": [] },
{ "id": 1614, "name": "南山区", "sonList": [] },
{ "id": 1615, "name": "宝安区", "sonList": [] },
{ "id": 1616, "name": "龙岗区", "sonList": [] },
{ "id": 1617, "name": "盐田区", "sonList": [] },
{ "id": 1618, "name": "高新区", "sonList": [] }] },
{ "id": 1619, "name": "珠海市", "sonList": [{ "id": 1620, "name": "香洲区", "sonList": [] },
{ "id": 1621, "name": "斗门区", "sonList": [] },
{ "id": 1622, "name": "金湾区", "sonList": [] },
{ "id": 1623, "name": "高新区", "sonList": [] }] },
{ "id": 1624, "name": "汕头市", "sonList": [{ "id": 1625, "name": "龙湖区", "sonList": [] },
{ "id": 1626, "name": "金平区", "sonList": [] },
{ "id": 1627, "name": "濠江区", "sonList": [] },
{ "id": 1628, "name": "潮阳区", "sonList": [] },
{ "id": 1629, "name": "潮南区", "sonList": [] },
{ "id": 1630, "name": "澄海区", "sonList": [] },
{ "id": 1631, "name": "南澳县", "sonList": [] }] },
{ "id": 1632, "name": "韶关市", "sonList": [{ "id": 1633, "name": "武江区", "sonList": [] },
{ "id": 1634, "name": "浈江区", "sonList": [] },
{ "id": 1635, "name": "曲江区", "sonList": [] },
{ "id": 1636, "name": "始兴县", "sonList": [] },
{ "id": 1637, "name": "仁化县", "sonList": [] },
{ "id": 1638, "name": "翁源县", "sonList": [] },
{ "id": 1639, "name": "乳源县", "sonList": [] },
{ "id": 1640, "name": "新丰县", "sonList": [] },
{ "id": 1641, "name": "乐昌市", "sonList": [] },
{ "id": 1642, "name": "南雄市", "sonList": [] }] },
{ "id": 1643, "name": "河源市", "sonList": [{ "id": 1644, "name": "源城区", "sonList": [] },
{ "id": 1645, "name": "紫金县", "sonList": [] },
{ "id": 1646, "name": "龙川县", "sonList": [] },
{ "id": 1647, "name": "连平县", "sonList": [] },
{ "id": 1648, "name": "和平县", "sonList": [] },
{ "id": 1649, "name": "东源县", "sonList": [] }] },
{ "id": 1650, "name": "梅州市", "sonList": [{ "id": 1651, "name": "梅江区", "sonList": [] },
{ "id": 1652, "name": "梅县", "sonList": [] },
{ "id": 1653, "name": "大埔县", "sonList": [] },
{ "id": 1654, "name": "丰顺县", "sonList": [] },
{ "id": 1655, "name": "五华县", "sonList": [] },
{ "id": 1656, "name": "平远县", "sonList": [] },
{ "id": 1657, "name": "蕉岭县", "sonList": [] },
{ "id": 1658, "name": "兴宁市", "sonList": [] }] },
{ "id": 1659, "name": "惠州市", "sonList": [{ "id": 1660, "name": "惠城区", "sonList": [] },
{ "id": 1661, "name": "惠阳区", "sonList": [] },
{ "id": 1662, "name": "博罗县", "sonList": [] },
{ "id": 1663, "name": "惠东县", "sonList": [] },
{ "id": 1664, "name": "龙门县", "sonList": [] },
{ "id": 1665, "name": "高新区", "sonList": [] }] },
{ "id": 1666, "name": "汕尾市", "sonList": [{ "id": 1667, "name": "城区", "sonList": [] },
{ "id": 1668, "name": "海丰县", "sonList": [] },
{ "id": 1669, "name": "陆河县", "sonList": [] },
{ "id": 1670, "name": "陆丰市", "sonList": [] }] },
{ "id": 1671, "name": "东莞市", "sonList": [{ "id": 1672, "name": "高新区", "sonList": [] }] },
{ "id": 1673, "name": "中山市", "sonList": [{ "id": 1674, "name": "高新区", "sonList": [] }] },
{ "id": 1675, "name": "江门市", "sonList": [{ "id": 1676, "name": "蓬江区", "sonList": [] },
{ "id": 1677, "name": "江海区", "sonList": [] },
{ "id": 1678, "name": "新会区", "sonList": [] },
{ "id": 1679, "name": "台山市", "sonList": [] },
{ "id": 1680, "name": "开平市", "sonList": [] },
{ "id": 1681, "name": "鹤山市", "sonList": [] },
{ "id": 1682, "name": "恩平市", "sonList": [] },
{ "id": 1683, "name": "高新区", "sonList": [] }] },
{ "id": 1684, "name": "佛山市", "sonList": [{ "id": 1685, "name": "禅城区", "sonList": [] },
{ "id": 1686, "name": "南海区", "sonList": [] },
{ "id": 1687, "name": "顺德区", "sonList": [] },
{ "id": 1688, "name": "三水区", "sonList": [] },
{ "id": 1689, "name": "高明区", "sonList": [] },
{ "id": 1690, "name": "高新区", "sonList": [] }] },
{ "id": 1691, "name": "阳江市", "sonList": [{ "id": 1692, "name": "江城区", "sonList": [] },
{ "id": 1693, "name": "阳西县", "sonList": [] },
{ "id": 1694, "name": "阳东县", "sonList": [] },
{ "id": 1695, "name": "阳春市", "sonList": [] }] },
{ "id": 1696, "name": "湛江市", "sonList": [{ "id": 1697, "name": "赤坎区", "sonList": [] },
{ "id": 1698, "name": "霞山区", "sonList": [] },
{ "id": 1699, "name": "坡头区", "sonList": [] },
{ "id": 1700, "name": "麻章区", "sonList": [] },
{ "id": 1701, "name": "遂溪县", "sonList": [] },
{ "id": 1702, "name": "徐闻县", "sonList": [] },
{ "id": 1703, "name": "廉江市", "sonList": [] },
{ "id": 1704, "name": "雷州市", "sonList": [] },
{ "id": 1705, "name": "吴川市", "sonList": [] },
{ "id": 1706, "name": "开发区", "sonList": [] }] },
{ "id": 1707, "name": "茂名市", "sonList": [{ "id": 1708, "name": "茂南区", "sonList": [] },
{ "id": 1709, "name": "茂港区", "sonList": [] },
{ "id": 1710, "name": "电白县", "sonList": [] },
{ "id": 1711, "name": "高州市", "sonList": [] },
{ "id": 1712, "name": "化州市", "sonList": [] },
{ "id": 1713, "name": "信宜市", "sonList": [] }] },
{ "id": 1714, "name": "肇庆市", "sonList": [{ "id": 1715, "name": "端州区", "sonList": [] },
{ "id": 1716, "name": "鼎湖区", "sonList": [] },
{ "id": 1717, "name": "广宁县", "sonList": [] },
{ "id": 1718, "name": "怀集县", "sonList": [] },
{ "id": 1719, "name": "封开县", "sonList": [] },
{ "id": 1720, "name": "德庆县", "sonList": [] },
{ "id": 1721, "name": "高要市", "sonList": [] },
{ "id": 1722, "name": "四会市", "sonList": [] },
{ "id": 1723, "name": "高新区", "sonList": [] }] },
{ "id": 1724, "name": "清远市", "sonList": [{ "id": 1725, "name": "清城区", "sonList": [] },
{ "id": 1726, "name": "佛冈县", "sonList": [] },
{ "id": 1727, "name": "阳山县", "sonList": [] },
{ "id": 1728, "name": "连山县", "sonList": [] },
{ "id": 1729, "name": "连南县", "sonList": [] },
{ "id": 1730, "name": "清新县", "sonList": [] },
{ "id": 1731, "name": "英德市", "sonList": [] },
{ "id": 1732, "name": "连州市", "sonList": [] }] },
{ "id": 1733, "name": "潮州市", "sonList": [{ "id": 1734, "name": "湘桥区", "sonList": [] },
{ "id": 1735, "name": "潮安县", "sonList": [] },
{ "id": 1736, "name": "饶平县", "sonList": [] }] },
{ "id": 1737, "name": "揭阳市", "sonList": [{ "id": 1738, "name": "榕城区", "sonList": [] },
{ "id": 1739, "name": "揭东县", "sonList": [] },
{ "id": 1740, "name": "揭西县", "sonList": [] },
{ "id": 1741, "name": "惠来县", "sonList": [] },
{ "id": 1742, "name": "普宁市", "sonList": [] }] },
{ "id": 1743, "name": "云浮市", "sonList": [{ "id": 1744, "name": "云城区", "sonList": [] },
{ "id": 1745, "name": "新兴县", "sonList": [] },
{ "id": 1746, "name": "郁南县", "sonList": [] },
{ "id": 1747, "name": "云安县", "sonList": [] },
{ "id": 1748, "name": "罗定市", "sonList": [] }] }] },
{ "id": 1749, "name": "广西", "sonList": [{ "id": 1750, "name": "南宁市", "sonList": [{ "id": 1751, "name": "兴宁区", "sonList": [] },
{ "id": 1752, "name": "青秀区", "sonList": [] },
{ "id": 1753, "name": "江南区", "sonList": [] },
{ "id": 1754, "name": "西乡塘区", "sonList": [] },
{ "id": 1755, "name": "良庆区", "sonList": [] },
{ "id": 1756, "name": "邕宁区", "sonList": [] },
{ "id": 1757, "name": "武鸣县", "sonList": [] },
{ "id": 1758, "name": "隆安县", "sonList": [] },
{ "id": 1759, "name": "马山县", "sonList": [] },
{ "id": 1760, "name": "上林县", "sonList": [] },
{ "id": 1761, "name": "宾阳县", "sonList": [] },
{ "id": 1762, "name": "横县", "sonList": [] },
{ "id": 1763, "name": "开发区", "sonList": [] }] },
{ "id": 1764, "name": "柳州市", "sonList": [{ "id": 1765, "name": "城中区", "sonList": [] },
{ "id": 1766, "name": "鱼峰区", "sonList": [] },
{ "id": 1767, "name": "柳南区", "sonList": [] },
{ "id": 1768, "name": "柳北区", "sonList": [] },
{ "id": 1769, "name": "柳江县", "sonList": [] },
{ "id": 1770, "name": "柳城县", "sonList": [] },
{ "id": 1771, "name": "鹿寨县", "sonList": [] },
{ "id": 1772, "name": "融安县", "sonList": [] },
{ "id": 1773, "name": "融水县", "sonList": [] },
{ "id": 1774, "name": "三江县", "sonList": [] },
{ "id": 1775, "name": "高新区", "sonList": [] }] },
{ "id": 1776, "name": "桂林市", "sonList": [{ "id": 1777, "name": "秀峰区", "sonList": [] },
{ "id": 1778, "name": "叠彩区", "sonList": [] },
{ "id": 1779, "name": "象山区", "sonList": [] },
{ "id": 1780, "name": "七星区", "sonList": [] },
{ "id": 1781, "name": "雁山区", "sonList": [] },
{ "id": 1782, "name": "阳朔县", "sonList": [] },
{ "id": 1783, "name": "临桂县", "sonList": [] },
{ "id": 1784, "name": "灵川县", "sonList": [] },
{ "id": 1785, "name": "全州县", "sonList": [] },
{ "id": 1786, "name": "兴安县", "sonList": [] },
{ "id": 1787, "name": "永福县", "sonList": [] },
{ "id": 1788, "name": "灌阳县", "sonList": [] },
{ "id": 1789, "name": "龙胜县", "sonList": [] },
{ "id": 1790, "name": "资源县", "sonList": [] },
{ "id": 1791, "name": "平乐县", "sonList": [] },
{ "id": 1792, "name": "荔蒲县", "sonList": [] },
{ "id": 1793, "name": "恭城县", "sonList": [] },
{ "id": 1794, "name": "高新区", "sonList": [] }] },
{ "id": 1795, "name": "梧州市", "sonList": [{ "id": 1796, "name": "万秀区", "sonList": [] },
{ "id": 1797, "name": "蝶山区", "sonList": [] },
{ "id": 1798, "name": "长洲区", "sonList": [] },
{ "id": 1799, "name": "苍梧县", "sonList": [] },
{ "id": 1800, "name": "藤县", "sonList": [] },
{ "id": 1801, "name": "蒙山县", "sonList": [] },
{ "id": 1802, "name": "岑溪市", "sonList": [] }] },
{ "id": 1803, "name": "北海市", "sonList": [{ "id": 1804, "name": "海城区", "sonList": [] },
{ "id": 1805, "name": "银海区", "sonList": [] },
{ "id": 1806, "name": "铁山港区", "sonList": [] },
{ "id": 1807, "name": "合浦县", "sonList": [] }] },
{ "id": 1808, "name": "防城港市", "sonList": [{ "id": 1809, "name": "港口区", "sonList": [] },
{ "id": 1810, "name": "防城区", "sonList": [] },
{ "id": 1811, "name": "上思县", "sonList": [] },
{ "id": 1812, "name": "东兴市", "sonList": [] }] },
{ "id": 1813, "name": "钦州市", "sonList": [{ "id": 1814, "name": "钦南区", "sonList": [] },
{ "id": 1815, "name": "钦北区", "sonList": [] },
{ "id": 1816, "name": "灵山县", "sonList": [] },
{ "id": 1817, "name": "浦北县", "sonList": [] },
{ "id": 1818, "name": "开发区", "sonList": [] }] },
{ "id": 1819, "name": "贵港市", "sonList": [{ "id": 1820, "name": "港北区", "sonList": [] },
{ "id": 1821, "name": "港南区", "sonList": [] },
{ "id": 1822, "name": "覃塘区", "sonList": [] },
{ "id": 1823, "name": "平南县", "sonList": [] },
{ "id": 1824, "name": "桂平市", "sonList": [] }] },
{ "id": 1825, "name": "玉林市", "sonList": [{ "id": 1826, "name": "玉州区", "sonList": [] },
{ "id": 1827, "name": "容县", "sonList": [] },
{ "id": 1828, "name": "陆川县", "sonList": [] },
{ "id": 1829, "name": "博白县", "sonList": [] },
{ "id": 1830, "name": "兴业县", "sonList": [] },
{ "id": 1831, "name": "北流市", "sonList": [] }] },
{ "id": 1832, "name": "百色市", "sonList": [{ "id": 1833, "name": "右江区", "sonList": [] },
{ "id": 1834, "name": "田阳县", "sonList": [] },
{ "id": 1835, "name": "田东县", "sonList": [] },
{ "id": 1836, "name": "平果县", "sonList": [] },
{ "id": 1837, "name": "德保县", "sonList": [] },
{ "id": 1838, "name": "靖西县", "sonList": [] },
{ "id": 1839, "name": "那坡县", "sonList": [] },
{ "id": 1840, "name": "凌云县", "sonList": [] },
{ "id": 1841, "name": "乐业县", "sonList": [] },
{ "id": 1842, "name": "田林县", "sonList": [] },
{ "id": 1843, "name": "西林县", "sonList": [] },
{ "id": 1844, "name": "隆林县", "sonList": [] }] },
{ "id": 1845, "name": "贺州市", "sonList": [{ "id": 1846, "name": "八步区", "sonList": [] },
{ "id": 1847, "name": "昭平县", "sonList": [] },
{ "id": 1848, "name": "钟山县", "sonList": [] },
{ "id": 1849, "name": "富川县", "sonList": [] }] },
{ "id": 1850, "name": "河池市", "sonList": [{ "id": 1851, "name": "金城江区", "sonList": [] },
{ "id": 1852, "name": "南丹县", "sonList": [] },
{ "id": 1853, "name": "天峨县", "sonList": [] },
{ "id": 1854, "name": "凤山县", "sonList": [] },
{ "id": 1855, "name": "东兰县", "sonList": [] },
{ "id": 1856, "name": "罗城县", "sonList": [] },
{ "id": 1857, "name": "环江县", "sonList": [] },
{ "id": 1858, "name": "巴马县", "sonList": [] },
{ "id": 1859, "name": "都安县", "sonList": [] },
{ "id": 1860, "name": "大化县", "sonList": [] },
{ "id": 1861, "name": "宜州市", "sonList": [] }] },
{ "id": 1862, "name": "来宾市", "sonList": [{ "id": 1863, "name": "兴宾区", "sonList": [] },
{ "id": 1864, "name": "忻城县", "sonList": [] },
{ "id": 1865, "name": "象州县", "sonList": [] },
{ "id": 1866, "name": "武宣县", "sonList": [] },
{ "id": 1867, "name": "金秀县", "sonList": [] },
{ "id": 1868, "name": "合山市", "sonList": [] }] },
{ "id": 1869, "name": "崇左市", "sonList": [{ "id": 1870, "name": "江洲区", "sonList": [] },
{ "id": 1871, "name": "扶绥县", "sonList": [] },
{ "id": 1872, "name": "宁明县", "sonList": [] },
{ "id": 1873, "name": "龙州县", "sonList": [] },
{ "id": 1874, "name": "大新县", "sonList": [] },
{ "id": 1875, "name": "天等县", "sonList": [] },
{ "id": 1876, "name": "凭祥市", "sonList": [] }] }] },
{ "id": 1877, "name": "海南省", "sonList": [
	{ "id": 1878, "name": "海口市", "sonList": [{ "id": 1879, "name": "秀英区", "sonList": [] },
{ "id": 1880, "name": "龙华区", "sonList": [] },
{ "id": 1881, "name": "琼山区", "sonList": [] },
{ "id": 1882, "name": "美兰区", "sonList": [] },
{ "id": 1883, "name": "高新区", "sonList": [] }] },
{ "id": 1884, "name": "三亚市", "sonList": [
	{"name": "海棠区"},{"name": "吉阳区"},{"name": "天涯区"},{"name": "崖州区"}
] },
{"name":"三沙市","sonList": [
	{"name": "西沙群岛"},{"name": "南沙群岛"},{"name": "中沙群岛的岛礁及其海域"}
]},

{ "id": 1886, "name": "儋州市", "sonList": [
	{"name":"儋州市","sonList": []}
] },
{"name":"省直辖县级行政区划","sonList":[
	{ "id": 1885, "name": "琼海市", "sonList": [] },
	{ "id": 1887, "name": "文昌市", "sonList": [] },
	{ "id": 1888, "name": "东方市", "sonList": [] },
	{ "id": 1889, "name": "五指山市", "sonList": [] },
	{ "id": 1890, "name": "万宁市", "sonList": [] },
	{ "id": 1891, "name": "定安县", "sonList": [] },
	{ "id": 1892, "name": "屯昌县", "sonList": [] },
	{ "id": 1893, "name": "澄迈县", "sonList": [] },
	{ "id": 1894, "name": "临高县", "sonList": [] },
	{ "id": 1895, "name": "陵水县", "sonList": [] },
	{ "id": 1896, "name": "琼中县", "sonList": [] },
	{ "id": 1897, "name": "保亭县", "sonList": [] },
	{ "id": 1898, "name": "乐东县", "sonList": [] },
	{ "id": 1899, "name": "昌江县", "sonList": [] },
	{ "id": 1900, "name": "白沙县", "sonList": [] }
]}
] },
{ "id": 1903, "name": "重庆市", "sonList": [{ "id": 1903, "name": "重庆市", "sonList": [{ "id": 1904, "name": "万州区", "sonList": [] },
{ "id": 1905, "name": "涪陵区", "sonList": [] },
{ "id": 1906, "name": "渝中区", "sonList": [] },
{ "id": 1907, "name": "大渡口区", "sonList": [] },
{ "id": 1908, "name": "江北区", "sonList": [] },
{ "id": 1909, "name": "沙坪坝区", "sonList": [] },
{ "id": 1910, "name": "九龙坡区", "sonList": [] },
{ "id": 1911, "name": "南岸区", "sonList": [] },
{ "id": 1912, "name": "北碚区", "sonList": [] },
{ "id": 1913, "name": "万盛区", "sonList": [] },
{ "id": 1914, "name": "双桥区", "sonList": [] },
{ "id": 1915, "name": "渝北区", "sonList": [] },
{ "id": 1916, "name": "巴南区", "sonList": [] },
{ "id": 1917, "name": "黔江区", "sonList": [] },
{ "id": 1918, "name": "长寿区", "sonList": [] },
{ "id": 1919, "name": "江津区", "sonList": [] },
{ "id": 1920, "name": "合川区", "sonList": [] },
{ "id": 1921, "name": "永川区", "sonList": [] },
{ "id": 1922, "name": "南川区", "sonList": [] },
{ "id": 1923, "name": "綦江县", "sonList": [] },
{ "id": 1924, "name": "潼南县", "sonList": [] },
{ "id": 1925, "name": "铜梁县", "sonList": [] },
{ "id": 1926, "name": "大足县", "sonList": [] },
{ "id": 1927, "name": "荣昌县", "sonList": [] },
{ "id": 1928, "name": "璧山县", "sonList": [] },
{ "id": 1929, "name": "梁平县", "sonList": [] },
{ "id": 1930, "name": "城口县", "sonList": [] },
{ "id": 1931, "name": "丰都县", "sonList": [] },
{ "id": 1932, "name": "垫江县", "sonList": [] },
{ "id": 1933, "name": "武隆县", "sonList": [] },
{ "id": 1934, "name": "忠县", "sonList": [] },
{ "id": 1935, "name": "开县", "sonList": [] },
{ "id": 1936, "name": "云阳县", "sonList": [] },
{ "id": 1937, "name": "奉节县", "sonList": [] },
{ "id": 1938, "name": "巫山县", "sonList": [] },
{ "id": 1939, "name": "巫溪县", "sonList": [] },
{ "id": 1940, "name": "石柱县", "sonList": [] },
{ "id": 1941, "name": "秀山县", "sonList": [] },
{ "id": 1942, "name": "酉阳县", "sonList": [] },
{ "id": 1943, "name": "彭水苗族县", "sonList": [] },
{ "id": 1944, "name": "开发区", "sonList": [] }] }]},
{ "id": 1945, "name": "四川省", "sonList": [{ "id": 1946, "name": "成都市", "sonList": [{ "id": 1947, "name": "锦江区", "sonList": [] },
{ "id": 1948, "name": "青羊区", "sonList": [] },
{ "id": 1949, "name": "金牛区", "sonList": [] },
{ "id": 1950, "name": "武侯区", "sonList": [] },
{ "id": 1951, "name": "成华区", "sonList": [] },
{ "id": 1952, "name": "龙泉驿区", "sonList": [] },
{ "id": 1953, "name": "青白江区", "sonList": [] },
{ "id": 1954, "name": "新都区", "sonList": [] },
{ "id": 1955, "name": "温江区", "sonList": [] },
{ "id": 1956, "name": "金堂县", "sonList": [] },
{ "id": 1957, "name": "双流县", "sonList": [] },
{ "id": 1958, "name": "郫县", "sonList": [] },
{ "id": 1959, "name": "大邑县", "sonList": [] },
{ "id": 1960, "name": "蒲江县", "sonList": [] },
{ "id": 1961, "name": "新津县", "sonList": [] },
{ "id": 1962, "name": "都江堰市", "sonList": [] },
{ "id": 1963, "name": "彭州市", "sonList": [] },
{ "id": 1964, "name": "邛崃市", "sonList": [] },
{ "id": 1965, "name": "崇州市", "sonList": [] },
{ "id": 1966, "name": "高新区", "sonList": [] },
{ "id": 1967, "name": "开发区", "sonList": [] }] },
{ "id": 1968, "name": "德阳市", "sonList": [{ "id": 1969, "name": "旌阳区", "sonList": [] },
{ "id": 1970, "name": "中江县", "sonList": [] },
{ "id": 1971, "name": "罗江县", "sonList": [] },
{ "id": 1972, "name": "广汉市", "sonList": [] },
{ "id": 1973, "name": "什邡市", "sonList": [] },
{ "id": 1974, "name": "绵竹市", "sonList": [] },
{ "id": 1975, "name": "开发区", "sonList": [] }] },
{ "id": 1976, "name": "绵阳市", "sonList": [{ "id": 1977, "name": "涪城区", "sonList": [] },
{ "id": 1978, "name": "游仙区", "sonList": [] },
{ "id": 1979, "name": "三台县", "sonList": [] },
{ "id": 1980, "name": "盐亭县", "sonList": [] },
{ "id": 1981, "name": "安县", "sonList": [] },
{ "id": 1982, "name": "梓潼县", "sonList": [] },
{ "id": 1983, "name": "北川县", "sonList": [] },
{ "id": 1984, "name": "平武县", "sonList": [] },
{ "id": 1985, "name": "江油市", "sonList": [] },
{ "id": 1986, "name": "高新区", "sonList": [] }] },
{ "id": 1987, "name": "眉山市", "sonList": [{ "id": 1988, "name": "东坡区", "sonList": [] },
{ "id": 1989, "name": "仁寿县", "sonList": [] },
{ "id": 1990, "name": "彭山县", "sonList": [] },
{ "id": 1991, "name": "洪雅县", "sonList": [] },
{ "id": 1992, "name": "丹棱县", "sonList": [] },
{ "id": 1993, "name": "青神县", "sonList": [] }] },
{ "id": 1994, "name": "泸州市", "sonList": [{ "id": 1995, "name": "江阳区", "sonList": [] },
{ "id": 1996, "name": "纳溪区", "sonList": [] },
{ "id": 1997, "name": "龙马潭区", "sonList": [] },
{ "id": 1998, "name": "泸县", "sonList": [] },
{ "id": 1999, "name": "合江县", "sonList": [] },
{ "id": 2000, "name": "叙永县", "sonList": [] },
{ "id": 2001, "name": "古蔺县", "sonList": [] }] },
{ "id": 2002, "name": "南充市", "sonList": [{ "id": 2003, "name": "顺庆区", "sonList": [] },
{ "id": 2004, "name": "高坪区", "sonList": [] },
{ "id": 2005, "name": "嘉陵区", "sonList": [] },
{ "id": 2006, "name": "南部县", "sonList": [] },
{ "id": 2007, "name": "营山县", "sonList": [] },
{ "id": 2008, "name": "蓬安县", "sonList": [] },
{ "id": 2009, "name": "仪陇县", "sonList": [] },
{ "id": 2010, "name": "西充县", "sonList": [] },
{ "id": 2011, "name": "阆中市", "sonList": [] }] },
{ "id": 2012, "name": "自贡市", "sonList": [{ "id": 2013, "name": "自流井区", "sonList": [] },
{ "id": 2014, "name": "贡井区", "sonList": [] },
{ "id": 2015, "name": "大安区", "sonList": [] },
{ "id": 2016, "name": "沿滩区", "sonList": [] },
{ "id": 2017, "name": "荣县", "sonList": [] },
{ "id": 2018, "name": "富顺县", "sonList": [] },
{ "id": 2019, "name": "高新区", "sonList": [] }] },
{ "id": 2020, "name": "内江市", "sonList": [{ "id": 2021, "name": "市中区", "sonList": [] },
{ "id": 2022, "name": "东兴区", "sonList": [] },
{ "id": 2023, "name": "威远县", "sonList": [] },
{ "id": 2024, "name": "资中县", "sonList": [] },
{ "id": 2025, "name": "隆昌县", "sonList": [] }] },
{ "id": 2026, "name": "宜宾市", "sonList": [{ "id": 2027, "name": "翠屏区", "sonList": [] },
{ "id": 2028, "name": "宜宾县", "sonList": [] },
{ "id": 2029, "name": "南溪县", "sonList": [] },
{ "id": 2030, "name": "江安县", "sonList": [] },
{ "id": 2031, "name": "长宁县", "sonList": [] },
{ "id": 2032, "name": "高县", "sonList": [] },
{ "id": 2033, "name": "珙县", "sonList": [] },
{ "id": 2034, "name": "筠连县", "sonList": [] },
{ "id": 2035, "name": "兴文县", "sonList": [] },
{ "id": 2036, "name": "屏山县", "sonList": [] }] },
{ "id": 2037, "name": "乐山市", "sonList": [{ "id": 2038, "name": "市中区", "sonList": [] },
{ "id": 2039, "name": "沙湾区", "sonList": [] },
{ "id": 2040, "name": "五通桥区", "sonList": [] },
{ "id": 2041, "name": "金口河区", "sonList": [] },
{ "id": 2042, "name": "犍为县", "sonList": [] },
{ "id": 2043, "name": "井研县", "sonList": [] },
{ "id": 2044, "name": "夹江县", "sonList": [] },
{ "id": 2045, "name": "沐川县", "sonList": [] },
{ "id": 2046, "name": "峨边县", "sonList": [] },
{ "id": 2047, "name": "马边县", "sonList": [] },
{ "id": 2048, "name": "峨眉山市", "sonList": [] }] },
{ "id": 2049, "name": "雅安市", "sonList": [{ "id": 2050, "name": "雨城区", "sonList": [] },
{ "id": 2051, "name": "名山县", "sonList": [] },
{ "id": 2052, "name": "荥经县", "sonList": [] },
{ "id": 2053, "name": "汉源县", "sonList": [] },
{ "id": 2054, "name": "石棉县", "sonList": [] },
{ "id": 2055, "name": "天全县", "sonList": [] },
{ "id": 2056, "name": "芦山县", "sonList": [] },
{ "id": 2057, "name": "宝兴县", "sonList": [] }] },
{ "id": 2058, "name": "遂宁市", "sonList": [{ "id": 2059, "name": "船山区", "sonList": [] },
{ "id": 2060, "name": "安居区", "sonList": [] },
{ "id": 2061, "name": "蓬溪县", "sonList": [] },
{ "id": 2062, "name": "射洪县", "sonList": [] },
{ "id": 2063, "name": "大英县", "sonList": [] }] },
{ "id": 2064, "name": "达州市", "sonList": [{ "id": 2065, "name": "通川区", "sonList": [] },
{ "id": 2066, "name": "达县", "sonList": [] },
{ "id": 2067, "name": "宣汉县", "sonList": [] },
{ "id": 2068, "name": "开江县", "sonList": [] },
{ "id": 2069, "name": "大竹县", "sonList": [] },
{ "id": 2070, "name": "渠县", "sonList": [] },
{ "id": 2071, "name": "万源市", "sonList": [] }] },
{ "id": 2072, "name": "巴中市", "sonList": [{ "id": 2073, "name": "巴州区", "sonList": [] },
{ "id": 2074, "name": "通江县", "sonList": [] },
{ "id": 2075, "name": "南江县", "sonList": [] },
{ "id": 2076, "name": "平昌县", "sonList": [] }] },
{ "id": 2077, "name": "广元市", "sonList": [{ "id": 2078, "name": "市中区", "sonList": [] },
{ "id": 2079, "name": "元坝区", "sonList": [] },
{ "id": 2080, "name": "朝天区", "sonList": [] },
{ "id": 2081, "name": "旺苍县", "sonList": [] },
{ "id": 2082, "name": "青川县", "sonList": [] },
{ "id": 2083, "name": "剑阁县", "sonList": [] },
{ "id": 2084, "name": "苍溪县", "sonList": [] }] },
{ "id": 2085, "name": "广安市", "sonList": [{ "id": 2086, "name": "广安区", "sonList": [] },
{ "id": 2087, "name": "岳池县", "sonList": [] },
{ "id": 2088, "name": "武胜县", "sonList": [] },
{ "id": 2089, "name": "邻水县", "sonList": [] },
{ "id": 2090, "name": "华蓥市", "sonList": [] },
{ "id": 2091, "name": "开发区", "sonList": [] }] },
{ "id": 2092, "name": "资阳市", "sonList": [{ "id": 2093, "name": "雁江区", "sonList": [] },
{ "id": 2094, "name": "安岳县", "sonList": [] },
{ "id": 2095, "name": "乐至县", "sonList": [] },
{ "id": 2096, "name": "简阳市", "sonList": [] }] },
{ "id": 2097, "name": "阿坝州", "sonList": [{ "id": 2098, "name": "汶川县", "sonList": [] },
{ "id": 2099, "name": "理县", "sonList": [] },
{ "id": 2100, "name": "茂县", "sonList": [] },
{ "id": 2101, "name": "松潘县", "sonList": [] },
{ "id": 2102, "name": "九寨沟县", "sonList": [] },
{ "id": 2103, "name": "金川县", "sonList": [] },
{ "id": 2104, "name": "小金县", "sonList": [] },
{ "id": 2105, "name": "黑水县", "sonList": [] },
{ "id": 2106, "name": "马尔康县", "sonList": [] },
{ "id": 2107, "name": "壤塘县", "sonList": [] },
{ "id": 2108, "name": "阿坝县", "sonList": [] },
{ "id": 2109, "name": "若尔盖县", "sonList": [] },
{ "id": 2110, "name": "红原县", "sonList": [] }] },
{ "id": 2111, "name": "攀枝花市", "sonList": [{ "id": 2112, "name": "东区", "sonList": [] },
{ "id": 2113, "name": "西区", "sonList": [] },
{ "id": 2114, "name": "仁和区", "sonList": [] },
{ "id": 2115, "name": "米易县", "sonList": [] },
{ "id": 2116, "name": "盐边县", "sonList": [] }] },
{ "id": 2117, "name": "甘孜州", "sonList": [{ "id": 2118, "name": "康定县", "sonList": [] },
{ "id": 2119, "name": "泸定县", "sonList": [] },
{ "id": 2120, "name": "丹巴县", "sonList": [] },
{ "id": 2121, "name": "九龙县", "sonList": [] },
{ "id": 2122, "name": "雅江县", "sonList": [] },
{ "id": 2123, "name": "道孚县", "sonList": [] },
{ "id": 2124, "name": "炉霍县", "sonList": [] },
{ "id": 2125, "name": "甘孜县", "sonList": [] },
{ "id": 2126, "name": "新龙县", "sonList": [] },
{ "id": 2127, "name": "德格县", "sonList": [] },
{ "id": 2128, "name": "白玉县", "sonList": [] },
{ "id": 2129, "name": "石渠县", "sonList": [] },
{ "id": 2130, "name": "色达县", "sonList": [] },
{ "id": 2131, "name": "理塘县", "sonList": [] },
{ "id": 2132, "name": "巴塘县", "sonList": [] },
{ "id": 2133, "name": "乡城县", "sonList": [] },
{ "id": 2134, "name": "稻城县", "sonList": [] },
{ "id": 2135, "name": "得荣县", "sonList": [] }] },
{ "id": 2136, "name": "凉山州", "sonList": [{ "id": 2137, "name": "西昌市", "sonList": [] },
{ "id": 2138, "name": "木里县", "sonList": [] },
{ "id": 2139, "name": "盐源县", "sonList": [] },
{ "id": 2140, "name": "德昌县", "sonList": [] },
{ "id": 2141, "name": "会理县", "sonList": [] },
{ "id": 2142, "name": "会东县", "sonList": [] },
{ "id": 2143, "name": "宁南县", "sonList": [] },
{ "id": 2144, "name": "普格县", "sonList": [] },
{ "id": 2145, "name": "布拖县", "sonList": [] },
{ "id": 2146, "name": "金阳县", "sonList": [] },
{ "id": 2147, "name": "昭觉县", "sonList": [] },
{ "id": 2148, "name": "喜德县", "sonList": [] },
{ "id": 2149, "name": "冕宁县", "sonList": [] },
{ "id": 2150, "name": "越西县", "sonList": [] },
{ "id": 2151, "name": "甘洛县", "sonList": [] },
{ "id": 2152, "name": "美姑县", "sonList": [] },
{ "id": 2153, "name": "雷波县", "sonList": [] }] }] },
{ "id": 2154, "name": "云南省", "sonList": [{ "id": 2155, "name": "昆明市", "sonList": [{ "id": 2156, "name": "五华区", "sonList": [] },
{ "id": 2157, "name": "盘龙区", "sonList": [] },
{ "id": 2158, "name": "官渡区", "sonList": [] },
{ "id": 2159, "name": "西山区", "sonList": [] },
{ "id": 2160, "name": "东川区", "sonList": [] },
{ "id": 2161, "name": "呈贡县", "sonList": [] },
{ "id": 2162, "name": "晋宁县", "sonList": [] },
{ "id": 2163, "name": "富民县", "sonList": [] },
{ "id": 2164, "name": "宜良县", "sonList": [] },
{ "id": 2165, "name": "石林县", "sonList": [] },
{ "id": 2166, "name": "嵩明县", "sonList": [] },
{ "id": 2167, "name": "禄劝县", "sonList": [] },
{ "id": 2168, "name": "寻甸回族县", "sonList": [] },
{ "id": 2169, "name": "安宁市", "sonList": [] },
{ "id": 2170, "name": "开发区", "sonList": [] }] },
{ "id": 2171, "name": "曲靖市", "sonList": [{ "id": 2172, "name": "麒麟区", "sonList": [] },
{ "id": 2173, "name": "马龙县", "sonList": [] },
{ "id": 2174, "name": "陆良县", "sonList": [] },
{ "id": 2175, "name": "师宗县", "sonList": [] },
{ "id": 2176, "name": "罗平县", "sonList": [] },
{ "id": 2177, "name": "富源县", "sonList": [] },
{ "id": 2178, "name": "会泽县", "sonList": [] },
{ "id": 2179, "name": "沾益县", "sonList": [] },
{ "id": 2180, "name": "宣威市", "sonList": [] },
{ "id": 2181, "name": "开发区", "sonList": [] }] },
{ "id": 2182, "name": "玉溪市", "sonList": [{ "id": 2183, "name": "红塔区", "sonList": [] },
{ "id": 2184, "name": "江川县", "sonList": [] },
{ "id": 2185, "name": "澄江县", "sonList": [] },
{ "id": 2186, "name": "通海县", "sonList": [] },
{ "id": 2187, "name": "华宁县", "sonList": [] },
{ "id": 2188, "name": "易门县", "sonList": [] },
{ "id": 2189, "name": "峨山县", "sonList": [] },
{ "id": 2190, "name": "新平县", "sonList": [] },
{ "id": 2191, "name": "元江哈尼族县", "sonList": [] }] },
{ "id": 2192, "name": "昭通市", "sonList": [{ "id": 2193, "name": "昭阳区", "sonList": [] },
{ "id": 2194, "name": "鲁甸县", "sonList": [] },
{ "id": 2195, "name": "巧家县", "sonList": [] },
{ "id": 2196, "name": "盐津县", "sonList": [] },
{ "id": 2197, "name": "大关县", "sonList": [] },
{ "id": 2198, "name": "永善县", "sonList": [] },
{ "id": 2199, "name": "绥江县", "sonList": [] },
{ "id": 2200, "name": "镇雄县", "sonList": [] },
{ "id": 2201, "name": "彝良县", "sonList": [] },
{ "id": 2202, "name": "威信县", "sonList": [] },
{ "id": 2203, "name": "水富县", "sonList": [] }] },
{ "id": 2204, "name": "楚雄州", "sonList": [{ "id": 2205, "name": "楚雄市", "sonList": [] },
{ "id": 2206, "name": "双柏县", "sonList": [] },
{ "id": 2207, "name": "牟定县", "sonList": [] },
{ "id": 2208, "name": "南华县", "sonList": [] },
{ "id": 2209, "name": "姚安县", "sonList": [] },
{ "id": 2210, "name": "大姚县", "sonList": [] },
{ "id": 2211, "name": "永仁县", "sonList": [] },
{ "id": 2212, "name": "元谋县", "sonList": [] },
{ "id": 2213, "name": "武定县", "sonList": [] },
{ "id": 2214, "name": "禄丰县", "sonList": [] }] },
{ "id": 2215, "name": "红河哈尼族州", "sonList": [{ "id": 2216, "name": "个旧市", "sonList": [] },
{ "id": 2217, "name": "开远市", "sonList": [] },
{ "id": 2218, "name": "蒙自县", "sonList": [] },
{ "id": 2219, "name": "屏边县", "sonList": [] },
{ "id": 2220, "name": "建水县", "sonList": [] },
{ "id": 2221, "name": "石屏县", "sonList": [] },
{ "id": 2222, "name": "弥勒县", "sonList": [] },
{ "id": 2223, "name": "泸西县", "sonList": [] },
{ "id": 2224, "name": "元阳县", "sonList": [] },
{ "id": 2225, "name": "红河县", "sonList": [] },
{ "id": 2226, "name": "金平县", "sonList": [] },
{ "id": 2227, "name": "绿春县", "sonList": [] },
{ "id": 2228, "name": "河口县", "sonList": [] }] },
{ "id": 2229, "name": "丽江市", "sonList": [{ "id": 2230, "name": "古城区", "sonList": [] },
{ "id": 2231, "name": "玉龙县", "sonList": [] },
{ "id": 2232, "name": "永胜县", "sonList": [] },
{ "id": 2233, "name": "华坪县", "sonList": [] },
{ "id": 2234, "name": "宁蒗县", "sonList": [] }] },
{ "id": 2235, "name": "迪庆州", "sonList": [{ "id": 2236, "name": "香格里拉县", "sonList": [] },
{ "id": 2237, "name": "德钦县", "sonList": [] },
{ "id": 2238, "name": "维西县", "sonList": [] }] },
{ "id": 2239, "name": "文山州", "sonList": [{ "id": 2240, "name": "文山县", "sonList": [] },
{ "id": 2241, "name": "砚山县", "sonList": [] },
{ "id": 2242, "name": "西畴县", "sonList": [] },
{ "id": 2243, "name": "麻栗坡县", "sonList": [] },
{ "id": 2244, "name": "马关县", "sonList": [] },
{ "id": 2245, "name": "丘北县", "sonList": [] },
{ "id": 2246, "name": "广南县", "sonList": [] },
{ "id": 2247, "name": "富宁县", "sonList": [] }] },
{ "id": 2248, "name": "西双版纳州", "sonList": [{ "id": 2249, "name": "景洪市", "sonList": [] },
{ "id": 2250, "name": "勐海县", "sonList": [] },
{ "id": 2251, "name": "勐腊县", "sonList": [] }] },
{ "id": 2252, "name": "普洱市", "sonList": [{ "id": 2253, "name": "思茅区", "sonList": [] },
{ "id": 2254, "name": "宁洱哈尼族县", "sonList": [] },
{ "id": 2255, "name": "墨江县", "sonList": [] },
{ "id": 2256, "name": "景东县", "sonList": [] },
{ "id": 2257, "name": "景谷傣族县", "sonList": [] },
{ "id": 2258, "name": "镇沅县", "sonList": [] },
{ "id": 2259, "name": "江城哈尼族县", "sonList": [] },
{ "id": 2260, "name": "孟连县", "sonList": [] },
{ "id": 2261, "name": "澜沧县", "sonList": [] },
{ "id": 2262, "name": "西盟县", "sonList": [] }] },
{ "id": 2263, "name": "大理", "sonList": [{ "id": 2264, "name": "大理市", "sonList": [] },
{ "id": 2265, "name": "漾濞县", "sonList": [] },
{ "id": 2266, "name": "祥云县", "sonList": [] },
{ "id": 2267, "name": "宾川县", "sonList": [] },
{ "id": 2268, "name": "弥渡县", "sonList": [] },
{ "id": 2269, "name": "南涧县", "sonList": [] },
{ "id": 2270, "name": "巍山彝族县", "sonList": [] },
{ "id": 2271, "name": "永平县", "sonList": [] },
{ "id": 2272, "name": "云龙县", "sonList": [] },
{ "id": 2273, "name": "洱源县", "sonList": [] },
{ "id": 2274, "name": "剑川县", "sonList": [] },
{ "id": 2275, "name": "鹤庆县", "sonList": [] }] },
{ "id": 2276, "name": "保山市", "sonList": [{ "id": 2277, "name": "隆阳区", "sonList": [] },
{ "id": 2278, "name": "施甸县", "sonList": [] },
{ "id": 2279, "name": "腾冲县", "sonList": [] },
{ "id": 2280, "name": "龙陵县", "sonList": [] },
{ "id": 2281, "name": "昌宁县", "sonList": [] }] },
{ "id": 2282, "name": "德宏", "sonList": [{ "id": 2283, "name": "瑞丽市", "sonList": [] },
{ "id": 2284, "name": "潞西市", "sonList": [] },
{ "id": 2285, "name": "梁河县", "sonList": [] },
{ "id": 2286, "name": "盈江县", "sonList": [] },
{ "id": 2287, "name": "陇川县", "sonList": [] }] },
{ "id": 2288, "name": "怒江", "sonList": [{ "id": 2289, "name": "泸水县", "sonList": [] },
{ "id": 2290, "name": "福贡县", "sonList": [] },
{ "id": 2291, "name": "贡山县", "sonList": [] },
{ "id": 2292, "name": "兰坪县", "sonList": [] }] },
{ "id": 2293, "name": "临沧市", "sonList": [{ "id": 2294, "name": "临翔区", "sonList": [] },
{ "id": 2295, "name": "凤庆县", "sonList": [] },
{ "id": 2296, "name": "云县", "sonList": [] },
{ "id": 2297, "name": "永德县", "sonList": [] },
{ "id": 2298, "name": "镇康县", "sonList": [] },
{ "id": 2299, "name": "双江县", "sonList": [] },
{ "id": 2300, "name": "耿马傣族县", "sonList": [] },
{ "id": 2301, "name": "沧源县", "sonList": [] }] }] },
{ "id": 2302, "name": "贵州省", "sonList": [{ "id": 2303, "name": "贵阳市", "sonList": [{ "id": 2304, "name": "南明区", "sonList": [] },
{ "id": 2305, "name": "云岩区", "sonList": [] },
{ "id": 2306, "name": "花溪区", "sonList": [] },
{ "id": 2307, "name": "乌当区", "sonList": [] },
{ "id": 2308, "name": "白云区", "sonList": [] },
{ "id": 2309, "name": "小河区", "sonList": [] },
{ "id": 2310, "name": "开阳县", "sonList": [] },
{ "id": 2311, "name": "息烽县", "sonList": [] },
{ "id": 2312, "name": "修文县", "sonList": [] },
{ "id": 2313, "name": "清镇市", "sonList": [] },
{ "id": 2314, "name": "开发区", "sonList": [] }] },
{ "id": 2315, "name": "遵义市", "sonList": [{ "id": 2316, "name": "红花岗区", "sonList": [] },
{ "id": 2317, "name": "汇川区", "sonList": [] },
{ "id": 2318, "name": "遵义县", "sonList": [] },
{ "id": 2319, "name": "桐梓县", "sonList": [] },
{ "id": 2320, "name": "绥阳县", "sonList": [] },
{ "id": 2321, "name": "正安县", "sonList": [] },
{ "id": 2322, "name": "道真仡佬族县", "sonList": [] },
{ "id": 2323, "name": "务川仡佬族县", "sonList": [] },
{ "id": 2324, "name": "凤冈县", "sonList": [] },
{ "id": 2325, "name": "湄潭县", "sonList": [] },
{ "id": 2326, "name": "余庆县", "sonList": [] },
{ "id": 2327, "name": "习水县", "sonList": [] },
{ "id": 2328, "name": "赤水市", "sonList": [] },
{ "id": 2329, "name": "仁怀市", "sonList": [] },
{ "id": 2330, "name": "开发区", "sonList": [] }] },
{ "id": 2331, "name": "六盘水市", "sonList": [{ "id": 2332, "name": "钟山区", "sonList": [] },
{ "id": 2333, "name": "六枝特区", "sonList": [] },
{ "id": 2334, "name": "水城县", "sonList": [] },
{ "id": 2335, "name": "盘县", "sonList": [] }] },
{ "id": 2336, "name": "安顺市", "sonList": [{ "id": 2337, "name": "西秀区", "sonList": [] },
{ "id": 2338, "name": "平坝县", "sonList": [] },
{ "id": 2339, "name": "普定县", "sonList": [] },
{ "id": 2340, "name": "镇宁布依族县", "sonList": [] },
{ "id": 2341, "name": "关岭布依族县", "sonList": [] },
{ "id": 2342, "name": "紫云县", "sonList": [] }] },
{ "id": 2343, "name": "黔西南", "sonList": [{ "id": 2344, "name": "兴义市", "sonList": [] },
{ "id": 2345, "name": "兴仁县", "sonList": [] },
{ "id": 2346, "name": "普安县", "sonList": [] },
{ "id": 2347, "name": "晴隆县", "sonList": [] },
{ "id": 2348, "name": "贞丰县", "sonList": [] },
{ "id": 2349, "name": "望谟县", "sonList": [] },
{ "id": 2350, "name": "册亨县", "sonList": [] },
{ "id": 2351, "name": "安龙县", "sonList": [] }] },
{ "id": 2352, "name": "黔南", "sonList": [{ "id": 2353, "name": "都匀市", "sonList": [] },
{ "id": 2354, "name": "福泉市", "sonList": [] },
{ "id": 2355, "name": "荔波县", "sonList": [] },
{ "id": 2356, "name": "贵定县", "sonList": [] },
{ "id": 2357, "name": "瓮安县", "sonList": [] },
{ "id": 2358, "name": "独山县", "sonList": [] },
{ "id": 2359, "name": "平塘县", "sonList": [] },
{ "id": 2360, "name": "罗甸县", "sonList": [] },
{ "id": 2361, "name": "长顺县", "sonList": [] },
{ "id": 2362, "name": "龙里县", "sonList": [] },
{ "id": 2363, "name": "惠水县", "sonList": [] },
{ "id": 2364, "name": "三都县", "sonList": [] }] },
{ "id": 2365, "name": "铜仁地区", "sonList": [{ "id": 2366, "name": "铜仁市", "sonList": [] },
{ "id": 2367, "name": "江口县", "sonList": [] },
{ "id": 2368, "name": "玉屏县", "sonList": [] },
{ "id": 2369, "name": "石阡县", "sonList": [] },
{ "id": 2370, "name": "思南县", "sonList": [] },
{ "id": 2371, "name": "印江县", "sonList": [] },
{ "id": 2372, "name": "德江县", "sonList": [] },
{ "id": 2373, "name": "沿河县", "sonList": [] },
{ "id": 2374, "name": "松桃县", "sonList": [] },
{ "id": 2375, "name": "万山特区", "sonList": [] }] },
{ "id": 2376, "name": "毕节地区", "sonList": [{ "id": 2377, "name": "毕节市", "sonList": [] },
{ "id": 2378, "name": "大方县", "sonList": [] },
{ "id": 2379, "name": "黔西县", "sonList": [] },
{ "id": 2380, "name": "金沙县", "sonList": [] },
{ "id": 2381, "name": "织金县", "sonList": [] },
{ "id": 2382, "name": "纳雍县", "sonList": [] },
{ "id": 2383, "name": "威宁县", "sonList": [] },
{ "id": 2384, "name": "赫章县", "sonList": [] }] },
{ "id": 2385, "name": "黔东南", "sonList": [{ "id": 2386, "name": "凯里市", "sonList": [] },
{ "id": 2387, "name": "黄平县", "sonList": [] },
{ "id": 2388, "name": "施秉县", "sonList": [] },
{ "id": 2389, "name": "三穗县", "sonList": [] },
{ "id": 2390, "name": "镇远县", "sonList": [] },
{ "id": 2391, "name": "岑巩县", "sonList": [] },
{ "id": 2392, "name": "天柱县", "sonList": [] },
{ "id": 2393, "name": "锦屏县", "sonList": [] },
{ "id": 2394, "name": "剑河县", "sonList": [] },
{ "id": 2395, "name": "台江县", "sonList": [] },
{ "id": 2396, "name": "黎平县", "sonList": [] },
{ "id": 2397, "name": "榕江县", "sonList": [] },
{ "id": 2398, "name": "从江县", "sonList": [] },
{ "id": 2399, "name": "雷山县", "sonList": [] },
{ "id": 2400, "name": "麻江县", "sonList": [] },
{ "id": 2401, "name": "丹寨县", "sonList": [] }] }] },
{ "id": 2402, "name": "西藏", "sonList": [{ "id": 2403, "name": "拉萨市", "sonList": [{ "id": 2404, "name": "城关区", "sonList": [] },
{ "id": 2405, "name": "林周县", "sonList": [] },
{ "id": 2406, "name": "当雄县", "sonList": [] },
{ "id": 2407, "name": "尼木县", "sonList": [] },
{ "id": 2408, "name": "曲水县", "sonList": [] },
{ "id": 2409, "name": "堆龙德庆县", "sonList": [] },
{ "id": 2410, "name": "达孜县", "sonList": [] },
{ "id": 2411, "name": "墨竹工卡县", "sonList": [] },
{ "id": 2412, "name": "开发区", "sonList": [] }] },
{ "id": 2413, "name": "日喀则地区", "sonList": [{ "id": 2414, "name": "日喀则市", "sonList": [] },
{ "id": 2415, "name": "南木林县", "sonList": [] },
{ "id": 2416, "name": "江孜县", "sonList": [] },
{ "id": 2417, "name": "定日县", "sonList": [] },
{ "id": 2418, "name": "萨迦县", "sonList": [] },
{ "id": 2419, "name": "拉孜县", "sonList": [] },
{ "id": 2420, "name": "昂仁县", "sonList": [] },
{ "id": 2421, "name": "谢通门县", "sonList": [] },
{ "id": 2422, "name": "白朗县", "sonList": [] },
{ "id": 2423, "name": "仁布县", "sonList": [] },
{ "id": 2424, "name": "康马县", "sonList": [] },
{ "id": 2425, "name": "定结县", "sonList": [] },
{ "id": 2426, "name": "仲巴县", "sonList": [] },
{ "id": 2427, "name": "亚东县", "sonList": [] },
{ "id": 2428, "name": "吉隆县", "sonList": [] },
{ "id": 2429, "name": "聂拉木县", "sonList": [] },
{ "id": 2430, "name": "萨嘎县", "sonList": [] },
{ "id": 2431, "name": "岗巴县", "sonList": [] }] },
{ "id": 2432, "name": "山南地区", "sonList": [{ "id": 2433, "name": "乃东县", "sonList": [] },
{ "id": 2434, "name": "扎囊县", "sonList": [] },
{ "id": 2435, "name": "贡嘎县", "sonList": [] },
{ "id": 2436, "name": "桑日县", "sonList": [] },
{ "id": 2437, "name": "琼结县", "sonList": [] },
{ "id": 2438, "name": "曲松县", "sonList": [] },
{ "id": 2439, "name": "措美县", "sonList": [] },
{ "id": 2440, "name": "洛扎县", "sonList": [] },
{ "id": 2441, "name": "加查县", "sonList": [] },
{ "id": 2442, "name": "隆子县", "sonList": [] },
{ "id": 2443, "name": "错那县", "sonList": [] },
{ "id": 2444, "name": "浪卡子县", "sonList": [] }] },
{ "id": 2445, "name": "林芝地区", "sonList": [{ "id": 2446, "name": "林芝县", "sonList": [] },
{ "id": 2447, "name": "工布江达县", "sonList": [] },
{ "id": 2448, "name": "米林县", "sonList": [] },
{ "id": 2449, "name": "墨脱县", "sonList": [] },
{ "id": 2450, "name": "波密县", "sonList": [] },
{ "id": 2451, "name": "察隅县", "sonList": [] },
{ "id": 2452, "name": "朗县", "sonList": [] }] },
{ "id": 2453, "name": "昌都地区", "sonList": [{ "id": 2454, "name": "昌都县", "sonList": [] },
{ "id": 2455, "name": "江达县", "sonList": [] },
{ "id": 2456, "name": "贡觉县", "sonList": [] },
{ "id": 2457, "name": "类乌齐县", "sonList": [] },
{ "id": 2458, "name": "丁青县", "sonList": [] },
{ "id": 2459, "name": "察雅县", "sonList": [] },
{ "id": 2460, "name": "八宿县", "sonList": [] },
{ "id": 2461, "name": "左贡县", "sonList": [] },
{ "id": 2462, "name": "芒康县", "sonList": [] },
{ "id": 2463, "name": "洛隆县", "sonList": [] },
{ "id": 2464, "name": "边坝县", "sonList": [] }] },
{ "id": 2465, "name": "那曲地区", "sonList": [{ "id": 2466, "name": "那曲县", "sonList": [] },
{ "id": 2467, "name": "嘉黎县", "sonList": [] },
{ "id": 2468, "name": "比如县", "sonList": [] },
{ "id": 2469, "name": "聂荣县", "sonList": [] },
{ "id": 2470, "name": "安多县", "sonList": [] },
{ "id": 2471, "name": "申扎县", "sonList": [] },
{ "id": 2472, "name": "索县", "sonList": [] },
{ "id": 2473, "name": "班戈县", "sonList": [] },
{ "id": 2474, "name": "巴青县", "sonList": [] },
{ "id": 2475, "name": "尼玛县", "sonList": [] }] },
{ "id": 2476, "name": "阿里地区", "sonList": [{ "id": 2477, "name": "普兰县", "sonList": [] },
{ "id": 2478, "name": "札达县", "sonList": [] },
{ "id": 2479, "name": "噶尔县", "sonList": [] },
{ "id": 2480, "name": "日土县", "sonList": [] },
{ "id": 2481, "name": "革吉县", "sonList": [] },
{ "id": 2482, "name": "改则县", "sonList": [] },
{ "id": 2483, "name": "措勤县", "sonList": [] }] }] },
{ "id": 2484, "name": "河南省", "sonList": [{ "id": 2485, "name": "郑州市", "sonList": [{ "id": 2486, "name": "中原区", "sonList": [] },
{ "id": 2487, "name": "二七区", "sonList": [] },
{ "id": 2488, "name": "管城回族区", "sonList": [] },
{ "id": 2489, "name": "金水区", "sonList": [] },
{ "id": 2490, "name": "上街区", "sonList": [] },
{ "id": 2491, "name": "惠济区", "sonList": [] },
{ "id": 2492, "name": "中牟县", "sonList": [] },
{ "id": 2493, "name": "巩义市", "sonList": [] },
{ "id": 2494, "name": "荥阳市", "sonList": [] },
{ "id": 2495, "name": "新密市", "sonList": [] },
{ "id": 2496, "name": "新郑市", "sonList": [] },
{ "id": 2497, "name": "登封市", "sonList": [] },
{ "id": 2498, "name": "经济开发区", "sonList": [] },
{ "id": 2499, "name": "郑东新区", "sonList": [] },
{ "id": 2500, "name": "高新区", "sonList": [] }] },
{ "id": 2501, "name": "洛阳市", "sonList": [{ "id": 2502, "name": "老城区", "sonList": [] },
{ "id": 2503, "name": "西工区", "sonList": [] },
{ "id": 2504, "name": "瀍河回族区", "sonList": [] },
{ "id": 2505, "name": "涧西区", "sonList": [] },
{ "id": 2506, "name": "吉利区", "sonList": [] },
{ "id": 2507, "name": "洛龙区", "sonList": [] },
{ "id": 2508, "name": "孟津县", "sonList": [] },
{ "id": 2509, "name": "新安县", "sonList": [] },
{ "id": 2510, "name": "栾川县", "sonList": [] },
{ "id": 2511, "name": "嵩县", "sonList": [] },
{ "id": 2512, "name": "汝阳县", "sonList": [] },
{ "id": 2513, "name": "宜阳县", "sonList": [] },
{ "id": 2514, "name": "洛宁县", "sonList": [] },
{ "id": 2515, "name": "伊川县", "sonList": [] },
{ "id": 2516, "name": "偃师市", "sonList": [] },
{ "id": 2517, "name": "高新区", "sonList": [] }] },
{ "id": 2518, "name": "开封市", "sonList": [{ "id": 2519, "name": "龙亭区", "sonList": [] },
{ "id": 2520, "name": "顺河回族区", "sonList": [] },
{ "id": 2521, "name": "鼓楼区", "sonList": [] },
{ "id": 2522, "name": "禹王台区", "sonList": [] },
{ "id": 2523, "name": "金明区", "sonList": [] },
{ "id": 2524, "name": "杞县", "sonList": [] },
{ "id": 2525, "name": "通许县", "sonList": [] },
{ "id": 2526, "name": "尉氏县", "sonList": [] },
{ "id": 2527, "name": "开封县", "sonList": [] },
{ "id": 2528, "name": "兰考县", "sonList": [] },
{ "id": 2529, "name": "开发区", "sonList": [] }] },
{ "id": 2530, "name": "安阳市", "sonList": [{ "id": 2531, "name": "文峰区", "sonList": [] },
{ "id": 2532, "name": "北关区", "sonList": [] },
{ "id": 2533, "name": "殷都区", "sonList": [] },
{ "id": 2534, "name": "龙安区", "sonList": [] },
{ "id": 2535, "name": "安阳县", "sonList": [] },
{ "id": 2536, "name": "汤阴县", "sonList": [] },
{ "id": 2537, "name": "滑县", "sonList": [] },
{ "id": 2538, "name": "内黄县", "sonList": [] },
{ "id": 2539, "name": "林州市", "sonList": [] },
{ "id": 2540, "name": "高新区", "sonList": [] }] },
{ "id": 2541, "name": "新乡市", "sonList": [{ "id": 2542, "name": "红旗区", "sonList": [] },
{ "id": 2543, "name": "卫滨区", "sonList": [] },
{ "id": 2544, "name": "凤泉区", "sonList": [] },
{ "id": 2545, "name": "牧野区", "sonList": [] },
{ "id": 2546, "name": "新乡县", "sonList": [] },
{ "id": 2547, "name": "获嘉县", "sonList": [] },
{ "id": 2548, "name": "原阳县", "sonList": [] },
{ "id": 2549, "name": "延津县", "sonList": [] },
{ "id": 2550, "name": "封丘县", "sonList": [] },
{ "id": 2551, "name": "长垣县", "sonList": [] },
{ "id": 2552, "name": "卫辉市", "sonList": [] },
{ "id": 2553, "name": "辉县市", "sonList": [] }] },
{ "id": 2554, "name": "濮阳市", "sonList": [{ "id": 2555, "name": "华龙区", "sonList": [] },
{ "id": 2556, "name": "清丰县", "sonList": [] },
{ "id": 2557, "name": "南乐县", "sonList": [] },
{ "id": 2558, "name": "范县", "sonList": [] },
{ "id": 2559, "name": "台前县", "sonList": [] },
{ "id": 2560, "name": "濮阳县", "sonList": [] }] },
{ "id": 2561, "name": "焦作市", "sonList": [{ "id": 2562, "name": "解放区", "sonList": [] },
{ "id": 2563, "name": "中站区", "sonList": [] },
{ "id": 2564, "name": "马村区", "sonList": [] },
{ "id": 2565, "name": "山阳区", "sonList": [] },
{ "id": 2566, "name": "修武县", "sonList": [] },
{ "id": 2567, "name": "博爱县", "sonList": [] },
{ "id": 2568, "name": "武陟县", "sonList": [] },
{ "id": 2569, "name": "温县", "sonList": [] },
{ "id": 2570, "name": "沁阳市", "sonList": [] },
{ "id": 2571, "name": "孟州市", "sonList": [] }] },
{ "id": 2572, "name": "鹤壁市", "sonList": [{ "id": 2573, "name": "鹤山区", "sonList": [] },
{ "id": 2574, "name": "山城区", "sonList": [] },
{ "id": 2575, "name": "淇滨区", "sonList": [] },
{ "id": 2576, "name": "浚县", "sonList": [] },
{ "id": 2577, "name": "淇县", "sonList": [] },
{ "id": 2578, "name": "开发区", "sonList": [] }] },
{ "id": 2579, "name": "三门峡市", "sonList": [{ "id": 2580, "name": "湖滨区", "sonList": [] },
{ "id": 2581, "name": "渑池县", "sonList": [] },
{ "id": 2582, "name": "陕县", "sonList": [] },
{ "id": 2583, "name": "卢氏县", "sonList": [] },
{ "id": 2584, "name": "义马市", "sonList": [] },
{ "id": 2585, "name": "灵宝市", "sonList": [] }] },
{ "id": 2586, "name": "商丘市", "sonList": [{ "id": 2587, "name": "梁园区", "sonList": [] },
{ "id": 2588, "name": "睢阳区", "sonList": [] },
{ "id": 2589, "name": "民权县", "sonList": [] },
{ "id": 2590, "name": "睢县", "sonList": [] },
{ "id": 2591, "name": "宁陵县", "sonList": [] },
{ "id": 2592, "name": "柘城县", "sonList": [] },
{ "id": 2593, "name": "虞城县", "sonList": [] },
{ "id": 2594, "name": "夏邑县", "sonList": [] },
{ "id": 2595, "name": "永城市", "sonList": [] }] },
{ "id": 2596, "name": "许昌市", "sonList": [{ "id": 2597, "name": "魏都区", "sonList": [] },
{ "id": 2598, "name": "许昌县", "sonList": [] },
{ "id": 2599, "name": "鄢陵县", "sonList": [] },
{ "id": 2600, "name": "襄城县", "sonList": [] },
{ "id": 2601, "name": "禹州市", "sonList": [] },
{ "id": 2602, "name": "长葛市", "sonList": [] },
{ "id": 2603, "name": "开发区", "sonList": [] }] },
{ "id": 2604, "name": "漯河市", "sonList": [{ "id": 2605, "name": "源汇区", "sonList": [] },
{ "id": 2606, "name": "郾城区", "sonList": [] },
{ "id": 2607, "name": "召陵区", "sonList": [] },
{ "id": 2608, "name": "舞阳县", "sonList": [] },
{ "id": 2609, "name": "临颍县", "sonList": [] },
{ "id": 2610, "name": "开发区", "sonList": [] }] },
{ "id": 2611, "name": "平顶山市", "sonList": [{ "id": 2612, "name": "新华区", "sonList": [] },
{ "id": 2613, "name": "卫东区", "sonList": [] },
{ "id": 2614, "name": "石龙区", "sonList": [] },
{ "id": 2615, "name": "湛河区", "sonList": [] },
{ "id": 2616, "name": "宝丰县", "sonList": [] },
{ "id": 2617, "name": "叶县", "sonList": [] },
{ "id": 2618, "name": "鲁山县", "sonList": [] },
{ "id": 2619, "name": "郏县", "sonList": [] },
{ "id": 2620, "name": "舞钢市", "sonList": [] },
{ "id": 2621, "name": "汝州市", "sonList": [] }] },
{ "id": 2622, "name": "驻马店市", "sonList": [{ "id": 2623, "name": "驿城区", "sonList": [] },
{ "id": 2624, "name": "西平县", "sonList": [] },
{ "id": 2625, "name": "上蔡县", "sonList": [] },
{ "id": 2626, "name": "平舆县", "sonList": [] },
{ "id": 2627, "name": "正阳县", "sonList": [] },
{ "id": 2628, "name": "确山县", "sonList": [] },
{ "id": 2629, "name": "泌阳县", "sonList": [] },
{ "id": 2630, "name": "汝南县", "sonList": [] },
{ "id": 2631, "name": "遂平县", "sonList": [] },
{ "id": 2632, "name": "新蔡县", "sonList": [] }] },
{ "id": 2633, "name": "周口市", "sonList": [{ "id": 2634, "name": "川汇区", "sonList": [] },
{ "id": 2635, "name": "扶沟县", "sonList": [] },
{ "id": 2636, "name": "西华县", "sonList": [] },
{ "id": 2637, "name": "商水县", "sonList": [] },
{ "id": 2638, "name": "沈丘县", "sonList": [] },
{ "id": 2639, "name": "郸城县", "sonList": [] },
{ "id": 2640, "name": "淮阳县", "sonList": [] },
{ "id": 2641, "name": "太康县", "sonList": [] },
{ "id": 2642, "name": "鹿邑县", "sonList": [] },
{ "id": 2643, "name": "项城市", "sonList": [] }] },
{ "id": 2644, "name": "南阳市", "sonList": [{ "id": 2645, "name": "宛城区", "sonList": [] },
{ "id": 2646, "name": "卧龙区", "sonList": [] },
{ "id": 2647, "name": "南召县", "sonList": [] },
{ "id": 2648, "name": "方城县", "sonList": [] },
{ "id": 2649, "name": "西峡县", "sonList": [] },
{ "id": 2650, "name": "镇平县", "sonList": [] },
{ "id": 2651, "name": "内乡县", "sonList": [] },
{ "id": 2652, "name": "淅川县", "sonList": [] },
{ "id": 2653, "name": "社旗县", "sonList": [] },
{ "id": 2654, "name": "唐河县", "sonList": [] },
{ "id": 2655, "name": "新野县", "sonList": [] },
{ "id": 2656, "name": "桐柏县", "sonList": [] },
{ "id": 2657, "name": "邓州市", "sonList": [] },
{ "id": 2658, "name": "高新区", "sonList": [] }] },
{ "id": 2659, "name": "信阳市", "sonList": [{ "id": 2660, "name": "浉河区", "sonList": [] },
{ "id": 2661, "name": "平桥区", "sonList": [] },
{ "id": 2662, "name": "罗山县", "sonList": [] },
{ "id": 2663, "name": "光山县", "sonList": [] },
{ "id": 2664, "name": "新县", "sonList": [] },
{ "id": 2665, "name": "商城县", "sonList": [] },
{ "id": 2666, "name": "固始县", "sonList": [] },
{ "id": 2667, "name": "潢川县", "sonList": [] },
{ "id": 2668, "name": "淮滨县", "sonList": [] },
{ "id": 2669, "name": "息县", "sonList": [] }] },
{ "id": 2670, "name": "济源市", "sonList": [] }] },
{ "id": 2671, "name": "湖北省", "sonList": [{ "id": 2672, "name": "武汉市", "sonList": [{ "id": 2673, "name": "江岸区", "sonList": [] },
{ "id": 2674, "name": "江汉区", "sonList": [] },
{ "id": 2675, "name": "楚口区", "sonList": [] },
{ "id": 2676, "name": "汉阳区", "sonList": [] },
{ "id": 2677, "name": "武昌区", "sonList": [] },
{ "id": 2678, "name": "青山区", "sonList": [] },
{ "id": 2679, "name": "洪山区", "sonList": [] },
{ "id": 2680, "name": "东西湖区", "sonList": [] },
{ "id": 2681, "name": "汉南区", "sonList": [] },
{ "id": 2682, "name": "蔡甸区", "sonList": [] },
{ "id": 2683, "name": "江夏区", "sonList": [] },
{ "id": 2684, "name": "黄陂区", "sonList": [] },
{ "id": 2685, "name": "新洲区", "sonList": [] },
{ "id": 2686, "name": "开发区", "sonList": [] }] },
{ "id": 2687, "name": "黄石市", "sonList": [{ "id": 2688, "name": "黄石港区", "sonList": [] },
{ "id": 2689, "name": "西塞山区", "sonList": [] },
{ "id": 2690, "name": "下陆区", "sonList": [] },
{ "id": 2691, "name": "铁山区", "sonList": [] },
{ "id": 2692, "name": "阳新县", "sonList": [] },
{ "id": 2693, "name": "大冶市", "sonList": [] },
{ "id": 2694, "name": "开发区", "sonList": [] }] },
{ "id": 2695, "name": "襄阳市", "sonList": [{ "id": 2696, "name": "襄城区", "sonList": [] },
{ "id": 2697, "name": "樊城区", "sonList": [] },
{ "id": 2698, "name": "襄州区", "sonList": [] },
{ "id": 2699, "name": "南漳县", "sonList": [] },
{ "id": 2700, "name": "谷城县", "sonList": [] },
{ "id": 2701, "name": "保康县", "sonList": [] },
{ "id": 2702, "name": "老河口市", "sonList": [] },
{ "id": 2703, "name": "枣阳市", "sonList": [] },
{ "id": 2704, "name": "宜城市", "sonList": [] },
{ "id": 2705, "name": "开发区", "sonList": [] }] },
{ "id": 2706, "name": "十堰市", "sonList": [{ "id": 2707, "name": "茅箭区", "sonList": [] },
{ "id": 2708, "name": "张湾区", "sonList": [] },
{ "id": 2709, "name": "郧县", "sonList": [] },
{ "id": 2710, "name": "郧西县", "sonList": [] },
{ "id": 2711, "name": "竹山县", "sonList": [] },
{ "id": 2712, "name": "竹溪县", "sonList": [] },
{ "id": 2713, "name": "房县", "sonList": [] },
{ "id": 2714, "name": "丹江口市", "sonList": [] }] },
{ "id": 2715, "name": "荆州市", "sonList": [{ "id": 2716, "name": "荆州区", "sonList": [] },
{ "id": 2717, "name": "公安县", "sonList": [] },
{ "id": 2718, "name": "监利县", "sonList": [] },
{ "id": 2719, "name": "江陵县", "sonList": [] },
{ "id": 2720, "name": "石首市", "sonList": [] },
{ "id": 2721, "name": "洪湖市", "sonList": [] },
{ "id": 2722, "name": "松滋市", "sonList": [] }] },
{ "id": 2723, "name": "宜昌市", "sonList": [{ "id": 2724, "name": "西陵区", "sonList": [] },
{ "id": 2725, "name": "伍家岗区", "sonList": [] },
{ "id": 2726, "name": "点军区", "sonList": [] },
{ "id": 2727, "name": "猇亭区", "sonList": [] },
{ "id": 2728, "name": "夷陵区", "sonList": [] },
{ "id": 2729, "name": "远安县", "sonList": [] },
{ "id": 2730, "name": "兴山县", "sonList": [] },
{ "id": 2731, "name": "秭归县", "sonList": [] },
{ "id": 2732, "name": "长阳县", "sonList": [] },
{ "id": 2733, "name": "五峰县", "sonList": [] },
{ "id": 2734, "name": "宜都市", "sonList": [] },
{ "id": 2735, "name": "当阳市", "sonList": [] },
{ "id": 2736, "name": "枝江市", "sonList": [] },
{ "id": 2737, "name": "高新区", "sonList": [] }] },
{ "id": 2738, "name": "荆门市", "sonList": [{ "id": 2739, "name": "东宝区", "sonList": [] },
{ "id": 2740, "name": "掇刀区", "sonList": [] },
{ "id": 2741, "name": "京山县", "sonList": [] },
{ "id": 2742, "name": "沙洋县", "sonList": [] },
{ "id": 2743, "name": "钟祥市", "sonList": [] }] },
{ "id": 2744, "name": "鄂州市", "sonList": [{ "id": 2745, "name": "梁子湖区", "sonList": [] },
{ "id": 2746, "name": "华容区", "sonList": [] },
{ "id": 2747, "name": "鄂城区", "sonList": [] }] },
{ "id": 2748, "name": "孝感市", "sonList": [{ "id": 2749, "name": "孝南区", "sonList": [] },
{ "id": 2750, "name": "孝昌县", "sonList": [] },
{ "id": 2751, "name": "大悟县", "sonList": [] },
{ "id": 2752, "name": "云梦县", "sonList": [] },
{ "id": 2753, "name": "应城市", "sonList": [] },
{ "id": 2754, "name": "安陆市", "sonList": [] },
{ "id": 2755, "name": "汉川市", "sonList": [] }] },
{ "id": 2756, "name": "黄冈市", "sonList": [{ "id": 2757, "name": "黄州区", "sonList": [] },
{ "id": 2758, "name": "团风县", "sonList": [] },
{ "id": 2759, "name": "红安县", "sonList": [] },
{ "id": 2760, "name": "罗田县", "sonList": [] },
{ "id": 2761, "name": "英山县", "sonList": [] },
{ "id": 2762, "name": "浠水县", "sonList": [] },
{ "id": 2763, "name": "蕲春县", "sonList": [] },
{ "id": 2764, "name": "黄梅县", "sonList": [] },
{ "id": 2765, "name": "麻城市", "sonList": [] },
{ "id": 2766, "name": "武穴市", "sonList": [] }] },
{ "id": 2767, "name": "咸宁市", "sonList": [{ "id": 2768, "name": "咸安区", "sonList": [] },
{ "id": 2769, "name": "嘉鱼县", "sonList": [] },
{ "id": 2770, "name": "通城县", "sonList": [] },
{ "id": 2771, "name": "崇阳县", "sonList": [] },
{ "id": 2772, "name": "通山县", "sonList": [] },
{ "id": 2773, "name": "赤壁市", "sonList": [] }] },
{ "id": 2774, "name": "随州市", "sonList": [{ "id": 2775, "name": "曾都区", "sonList": [] },
{ "id": 2776, "name": "广水市", "sonList": [] }] },
{ "id": 2777, "name": "恩施", "sonList": [{ "id": 2778, "name": "恩施市", "sonList": [] },
{ "id": 2779, "name": "利川市", "sonList": [] },
{ "id": 2780, "name": "建始县", "sonList": [] },
{ "id": 2781, "name": "巴东县", "sonList": [] },
{ "id": 2782, "name": "宣恩县", "sonList": [] },
{ "id": 2783, "name": "咸丰县", "sonList": [] },
{ "id": 2784, "name": "来凤县", "sonList": [] },
{ "id": 2785, "name": "鹤峰县", "sonList": [] }] },
{ "id": 2786, "name": "潜江市", "sonList": [] },
{ "id": 2787, "name": "仙桃市", "sonList": [] },
{ "id": 2788, "name": "天门市", "sonList": [] },
{ "id": 2789, "name": "神农架林区", "sonList": [] }] },
{ "id": 2790, "name": "湖南省", "sonList": [{ "id": 2791, "name": "长沙市", "sonList": [{ "id": 2792, "name": "芙蓉区", "sonList": [] },
{ "id": 2793, "name": "天心区", "sonList": [] },
{ "id": 2794, "name": "岳麓区", "sonList": [] },
{ "id": 2795, "name": "开福区", "sonList": [] },
{ "id": 2796, "name": "雨花区", "sonList": [] },
{ "id": 2797, "name": "长沙县", "sonList": [] },
{ "id": 2798, "name": "望城县", "sonList": [] },
{ "id": 2799, "name": "宁乡县", "sonList": [] },
{ "id": 2800, "name": "浏阳市", "sonList": [] },
{ "id": 2801, "name": "开发区", "sonList": [] }] },
{ "id": 2802, "name": "株洲市", "sonList": [{ "id": 2803, "name": "荷塘区", "sonList": [] },
{ "id": 2804, "name": "芦淞区", "sonList": [] },
{ "id": 2805, "name": "石峰区", "sonList": [] },
{ "id": 2806, "name": "天元区", "sonList": [] },
{ "id": 2807, "name": "株洲县", "sonList": [] },
{ "id": 2808, "name": "攸县", "sonList": [] },
{ "id": 2809, "name": "茶陵县", "sonList": [] },
{ "id": 2810, "name": "炎陵县", "sonList": [] },
{ "id": 2811, "name": "醴陵市", "sonList": [] },
{ "id": 2812, "name": "高新区", "sonList": [] }] },
{ "id": 2813, "name": "湘潭市", "sonList": [{ "id": 2814, "name": "雨湖区", "sonList": [] },
{ "id": 2815, "name": "岳塘区", "sonList": [] },
{ "id": 2816, "name": "湘潭县", "sonList": [] },
{ "id": 2817, "name": "湘乡市", "sonList": [] },
{ "id": 2818, "name": "韶山市", "sonList": [] },
{ "id": 2819, "name": "高新区", "sonList": [] }] },
{ "id": 2820, "name": "衡阳市", "sonList": [{ "id": 2821, "name": "珠晖区", "sonList": [] },
{ "id": 2822, "name": "雁峰区", "sonList": [] },
{ "id": 2823, "name": "石鼓区", "sonList": [] },
{ "id": 2824, "name": "蒸湘区", "sonList": [] },
{ "id": 2825, "name": "南岳区", "sonList": [] },
{ "id": 2826, "name": "衡阳县", "sonList": [] },
{ "id": 2827, "name": "衡南县", "sonList": [] },
{ "id": 2828, "name": "衡山县", "sonList": [] },
{ "id": 2829, "name": "衡东县", "sonList": [] },
{ "id": 2830, "name": "祁东县", "sonList": [] },
{ "id": 2831, "name": "耒阳市", "sonList": [] },
{ "id": 2832, "name": "常宁市", "sonList": [] }] },
{ "id": 2833, "name": "益阳市", "sonList": [{ "id": 2834, "name": "资阳区", "sonList": [] },
{ "id": 2835, "name": "赫山区", "sonList": [] },
{ "id": 2836, "name": "南县", "sonList": [] },
{ "id": 2837, "name": "桃江县", "sonList": [] },
{ "id": 2838, "name": "安化县", "sonList": [] },
{ "id": 2839, "name": "沅江市", "sonList": [] },
{ "id": 2840, "name": "高新区", "sonList": [] }] },
{ "id": 2841, "name": "常德市", "sonList": [{ "id": 2842, "name": "武陵区", "sonList": [] },
{ "id": 2843, "name": "鼎城区", "sonList": [] },
{ "id": 2844, "name": "安乡县", "sonList": [] },
{ "id": 2845, "name": "汉寿县", "sonList": [] },
{ "id": 2846, "name": "澧县", "sonList": [] },
{ "id": 2847, "name": "临澧县", "sonList": [] },
{ "id": 2848, "name": "桃源县", "sonList": [] },
{ "id": 2849, "name": "石门县", "sonList": [] },
{ "id": 2850, "name": "津市市", "sonList": [] },
{ "id": 2851, "name": "开发区", "sonList": [] }] },
{ "id": 2852, "name": "岳阳市", "sonList": [{ "id": 2853, "name": "岳阳楼区", "sonList": [] },
{ "id": 2854, "name": "云溪区", "sonList": [] },
{ "id": 2855, "name": "君山区", "sonList": [] },
{ "id": 2856, "name": "岳阳县", "sonList": [] },
{ "id": 2857, "name": "华容县", "sonList": [] },
{ "id": 2858, "name": "湘阴县", "sonList": [] },
{ "id": 2859, "name": "平江县", "sonList": [] },
{ "id": 2860, "name": "汨罗市", "sonList": [] },
{ "id": 2861, "name": "临湘市", "sonList": [] },
{ "id": 2862, "name": "开发区", "sonList": [] }] },
{ "id": 2863, "name": "邵阳市", "sonList": [{ "id": 2864, "name": "双清区", "sonList": [] },
{ "id": 2865, "name": "大祥区", "sonList": [] },
{ "id": 2866, "name": "北塔区", "sonList": [] },
{ "id": 2867, "name": "邵东县", "sonList": [] },
{ "id": 2868, "name": "新邵县", "sonList": [] },
{ "id": 2869, "name": "邵阳县", "sonList": [] },
{ "id": 2870, "name": "隆回县", "sonList": [] },
{ "id": 2871, "name": "洞口县", "sonList": [] },
{ "id": 2872, "name": "绥宁县", "sonList": [] },
{ "id": 2873, "name": "新宁县", "sonList": [] },
{ "id": 2874, "name": "城步县", "sonList": [] },
{ "id": 2875, "name": "武冈市", "sonList": [] }] },
{ "id": 2876, "name": "郴州市", "sonList": [{ "id": 2877, "name": "北湖区", "sonList": [] },
{ "id": 2878, "name": "苏仙区", "sonList": [] },
{ "id": 2879, "name": "桂阳县", "sonList": [] },
{ "id": 2880, "name": "宜章县", "sonList": [] },
{ "id": 2881, "name": "永兴县", "sonList": [] },
{ "id": 2882, "name": "嘉禾县", "sonList": [] },
{ "id": 2883, "name": "临武县", "sonList": [] },
{ "id": 2884, "name": "汝城县", "sonList": [] },
{ "id": 2885, "name": "桂东县", "sonList": [] },
{ "id": 2886, "name": "安仁县", "sonList": [] },
{ "id": 2887, "name": "资兴市", "sonList": [] }] },
{ "id": 2888, "name": "娄底市", "sonList": [{ "id": 2889, "name": "娄星区", "sonList": [] },
{ "id": 2890, "name": "双峰县", "sonList": [] },
{ "id": 2891, "name": "新化县", "sonList": [] },
{ "id": 2892, "name": "冷水江市", "sonList": [] },
{ "id": 2893, "name": "涟源市", "sonList": [] }] },
{ "id": 2894, "name": "永州市", "sonList": [{ "id": 2895, "name": "零陵区", "sonList": [] },
{ "id": 2896, "name": "冷水滩区", "sonList": [] },
{ "id": 2897, "name": "祁阳县", "sonList": [] },
{ "id": 2898, "name": "东安县", "sonList": [] },
{ "id": 2899, "name": "双牌县", "sonList": [] },
{ "id": 2900, "name": "道县", "sonList": [] },
{ "id": 2901, "name": "江永县", "sonList": [] },
{ "id": 2902, "name": "宁远县", "sonList": [] },
{ "id": 2903, "name": "蓝山县", "sonList": [] },
{ "id": 2904, "name": "新田县", "sonList": [] },
{ "id": 2905, "name": "江华县", "sonList": [] }] },
{ "id": 2906, "name": "怀化市", "sonList": [{ "id": 2907, "name": "鹤城区", "sonList": [] },
{ "id": 2908, "name": "中方县", "sonList": [] },
{ "id": 2909, "name": "沅陵县", "sonList": [] },
{ "id": 2910, "name": "辰溪县", "sonList": [] },
{ "id": 2911, "name": "溆浦县", "sonList": [] },
{ "id": 2912, "name": "会同县", "sonList": [] },
{ "id": 2913, "name": "麻阳县", "sonList": [] },
{ "id": 2914, "name": "新晃县", "sonList": [] },
{ "id": 2915, "name": "芷江县", "sonList": [] },
{ "id": 2916, "name": "靖州苗族县", "sonList": [] },
{ "id": 2917, "name": "通道县", "sonList": [] },
{ "id": 2918, "name": "洪江市", "sonList": [] }] },
{ "id": 2919, "name": "张家界市", "sonList": [{ "id": 2920, "name": "永定区", "sonList": [] },
{ "id": 2921, "name": "武陵源区", "sonList": [] },
{ "id": 2922, "name": "慈利县", "sonList": [] },
{ "id": 2923, "name": "桑植县", "sonList": [] }] },
{ "id": 2924, "name": "湘西", "sonList": [{ "id": 2925, "name": "吉首市", "sonList": [] },
{ "id": 2926, "name": "泸溪县", "sonList": [] },
{ "id": 2927, "name": "凤凰县", "sonList": [] },
{ "id": 2928, "name": "花垣县", "sonList": [] },
{ "id": 2929, "name": "保靖县", "sonList": [] },
{ "id": 2930, "name": "古丈县", "sonList": [] },
{ "id": 2931, "name": "永顺县", "sonList": [] },
{ "id": 2932, "name": "龙山县", "sonList": [] }] }] },
{ "id": 2933, "name": "陕西省", "sonList": [{ "id": 2934, "name": "西安市", "sonList": [{ "id": 2935, "name": "新城区", "sonList": [] },
{ "id": 2936, "name": "碑林区", "sonList": [] },
{ "id": 2937, "name": "莲湖区", "sonList": [] },
{ "id": 2938, "name": "灞桥区", "sonList": [] },
{ "id": 2939, "name": "未央区", "sonList": [] },
{ "id": 2940, "name": "雁塔区", "sonList": [] },
{ "id": 2941, "name": "阎良区", "sonList": [] },
{ "id": 2942, "name": "临潼区", "sonList": [] },
{ "id": 2943, "name": "长安区", "sonList": [] },
{ "id": 2944, "name": "蓝田县", "sonList": [] },
{ "id": 2945, "name": "周至县", "sonList": [] },
{ "id": 2946, "name": "户县", "sonList": [] },
{ "id": 2947, "name": "高陵县", "sonList": [] },
{ "id": 2948, "name": "经济开发区", "sonList": [] },
{ "id": 2949, "name": "高新区", "sonList": [] }] },
{ "id": 2950, "name": "宝鸡市", "sonList": [{ "id": 2951, "name": "渭滨区", "sonList": [] },
{ "id": 2952, "name": "金台区", "sonList": [] },
{ "id": 2953, "name": "陈仓区", "sonList": [] },
{ "id": 2954, "name": "凤翔县", "sonList": [] },
{ "id": 2955, "name": "岐山县", "sonList": [] },
{ "id": 2956, "name": "扶风县", "sonList": [] },
{ "id": 2957, "name": "眉县", "sonList": [] },
{ "id": 2958, "name": "陇县", "sonList": [] },
{ "id": 2959, "name": "千阳县", "sonList": [] },
{ "id": 2960, "name": "麟游县", "sonList": [] },
{ "id": 2961, "name": "凤县", "sonList": [] },
{ "id": 2962, "name": "太白县", "sonList": [] },
{ "id": 2963, "name": "高新区", "sonList": [] }] },
{ "id": 2964, "name": "咸阳市", "sonList": [{ "id": 2965, "name": "秦都区", "sonList": [] },
{ "id": 2966, "name": "渭城区", "sonList": [] },
{ "id": 2967, "name": "三原县", "sonList": [] },
{ "id": 2968, "name": "泾阳县", "sonList": [] },
{ "id": 2969, "name": "乾县", "sonList": [] },
{ "id": 2970, "name": "礼泉县", "sonList": [] },
{ "id": 2971, "name": "永寿县", "sonList": [] },
{ "id": 2972, "name": "彬县", "sonList": [] },
{ "id": 2973, "name": "长武县", "sonList": [] },
{ "id": 2974, "name": "旬邑县", "sonList": [] },
{ "id": 2975, "name": "淳化县", "sonList": [] },
{ "id": 2976, "name": "武功县", "sonList": [] },
{ "id": 2977, "name": "兴平市", "sonList": [] }] },
{ "id": 2978, "name": "渭南市", "sonList": [{ "id": 2979, "name": "临渭区", "sonList": [] },
{ "id": 2980, "name": "华县", "sonList": [] },
{ "id": 2981, "name": "潼关县", "sonList": [] },
{ "id": 2982, "name": "大荔县", "sonList": [] },
{ "id": 2983, "name": "合阳县", "sonList": [] },
{ "id": 2984, "name": "澄城县", "sonList": [] },
{ "id": 2985, "name": "蒲城县", "sonList": [] },
{ "id": 2986, "name": "白水县", "sonList": [] },
{ "id": 2987, "name": "富平县", "sonList": [] },
{ "id": 2988, "name": "韩城市", "sonList": [] },
{ "id": 2989, "name": "华阴市", "sonList": [] },
{ "id": 2990, "name": "高新区", "sonList": [] }] },
{ "id": 2991, "name": "延安市", "sonList": [{ "id": 2992, "name": "宝塔区", "sonList": [] },
{ "id": 2993, "name": "延长县", "sonList": [] },
{ "id": 2994, "name": "延川县", "sonList": [] },
{ "id": 2995, "name": "子长县", "sonList": [] },
{ "id": 2996, "name": "安塞县", "sonList": [] },
{ "id": 2997, "name": "志丹县", "sonList": [] },
{ "id": 2998, "name": "吴起县", "sonList": [] },
{ "id": 2999, "name": "甘泉县", "sonList": [] },
{ "id": 3000, "name": "富县", "sonList": [] },
{ "id": 3001, "name": "洛川县", "sonList": [] },
{ "id": 3002, "name": "宜川县", "sonList": [] },
{ "id": 3003, "name": "黄龙县", "sonList": [] },
{ "id": 3004, "name": "黄陵县", "sonList": [] }] },
{ "id": 3005, "name": "榆林市", "sonList": [{ "id": 3006, "name": "榆阳区", "sonList": [] },
{ "id": 3007, "name": "神木县", "sonList": [] },
{ "id": 3008, "name": "府谷县", "sonList": [] },
{ "id": 3009, "name": "横山县", "sonList": [] },
{ "id": 3010, "name": "靖边县", "sonList": [] },
{ "id": 3011, "name": "定边县", "sonList": [] },
{ "id": 3012, "name": "绥德县", "sonList": [] },
{ "id": 3013, "name": "米脂县", "sonList": [] },
{ "id": 3014, "name": "佳县", "sonList": [] },
{ "id": 3015, "name": "吴堡县", "sonList": [] },
{ "id": 3016, "name": "清涧县", "sonList": [] },
{ "id": 3017, "name": "子洲县", "sonList": [] }] },
{ "id": 3018, "name": "铜川市", "sonList": [{ "id": 3019, "name": "王益区", "sonList": [] },
{ "id": 3020, "name": "印台区", "sonList": [] },
{ "id": 3021, "name": "耀州区", "sonList": [] },
{ "id": 3022, "name": "宜君县", "sonList": [] }] },
{ "id": 3023, "name": "汉中市", "sonList": [{ "id": 3024, "name": "汉台区", "sonList": [] },
{ "id": 3025, "name": "南郑县", "sonList": [] },
{ "id": 3026, "name": "城固县", "sonList": [] },
{ "id": 3027, "name": "洋县", "sonList": [] },
{ "id": 3028, "name": "西乡县", "sonList": [] },
{ "id": 3029, "name": "勉县", "sonList": [] },
{ "id": 3030, "name": "宁强县", "sonList": [] },
{ "id": 3031, "name": "略阳县", "sonList": [] },
{ "id": 3032, "name": "镇巴县", "sonList": [] },
{ "id": 3033, "name": "留坝县", "sonList": [] },
{ "id": 3034, "name": "佛坪县", "sonList": [] }] },
{ "id": 3035, "name": "安康市", "sonList": [{ "id": 3036, "name": "汉滨区", "sonList": [] },
{ "id": 3037, "name": "汉阴县", "sonList": [] },
{ "id": 3038, "name": "石泉县", "sonList": [] },
{ "id": 3039, "name": "宁陕县", "sonList": [] },
{ "id": 3040, "name": "紫阳县", "sonList": [] },
{ "id": 3041, "name": "岚皋县", "sonList": [] },
{ "id": 3042, "name": "平利县", "sonList": [] },
{ "id": 3043, "name": "镇坪县", "sonList": [] },
{ "id": 3044, "name": "旬阳县", "sonList": [] },
{ "id": 3045, "name": "白河县", "sonList": [] }] },
{ "id": 3046, "name": "商洛市", "sonList": [{ "id": 3047, "name": "商州区", "sonList": [] },
{ "id": 3048, "name": "洛南县", "sonList": [] },
{ "id": 3049, "name": "丹凤县", "sonList": [] },
{ "id": 3050, "name": "商南县", "sonList": [] },
{ "id": 3051, "name": "山阳县", "sonList": [] },
{ "id": 3052, "name": "镇安县", "sonList": [] },
{ "id": 3053, "name": "柞水县", "sonList": [] }] },
{ "id": 3054, "name": "杨凌", "sonList": [{ "id": 3055, "name": "农业示范区", "sonList": [] }] }] },
{ "id": 3056, "name": "青海省", "sonList": [{ "id": 3057, "name": "西宁市", "sonList": [{ "id": 3058, "name": "城东区", "sonList": [] },
{ "id": 3059, "name": "城中区", "sonList": [] },
{ "id": 3060, "name": "城西区", "sonList": [] },
{ "id": 3061, "name": "城北区", "sonList": [] },
{ "id": 3062, "name": "大通县", "sonList": [] },
{ "id": 3063, "name": "湟中县", "sonList": [] },
{ "id": 3064, "name": "湟源县", "sonList": [] },
{ "id": 3065, "name": "开发区", "sonList": [] }] },
{ "id": 3066, "name": "海东地区", "sonList": [{ "id": 3067, "name": "平安县", "sonList": [] },
{ "id": 3068, "name": "民和县", "sonList": [] },
{ "id": 3069, "name": "乐都县", "sonList": [] },
{ "id": 3070, "name": "互助县", "sonList": [] },
{ "id": 3071, "name": "化隆县", "sonList": [] },
{ "id": 3072, "name": "循化县", "sonList": [] }] },
{ "id": 3073, "name": "海南州", "sonList": [{ "id": 3074, "name": "共和县", "sonList": [] },
{ "id": 3075, "name": "同德县", "sonList": [] },
{ "id": 3076, "name": "贵德县", "sonList": [] },
{ "id": 3077, "name": "兴海县", "sonList": [] },
{ "id": 3078, "name": "贵南县", "sonList": [] }] },
{ "id": 3079, "name": "海北州", "sonList": [{ "id": 3080, "name": "门源县", "sonList": [] },
{ "id": 3081, "name": "祁连县", "sonList": [] },
{ "id": 3082, "name": "海晏县", "sonList": [] },
{ "id": 3083, "name": "刚察县", "sonList": [] }] },
{ "id": 3084, "name": "海西蒙古族州", "sonList": [{ "id": 3085, "name": "格尔木市", "sonList": [] },
{ "id": 3086, "name": "德令哈市", "sonList": [] },
{ "id": 3087, "name": "乌兰县", "sonList": [] },
{ "id": 3088, "name": "都兰县", "sonList": [] },
{ "id": 3089, "name": "天峻县", "sonList": [] }] },
{ "id": 3090, "name": "黄南州", "sonList": [{ "id": 3091, "name": "同仁县", "sonList": [] },
{ "id": 3092, "name": "尖扎县", "sonList": [] },
{ "id": 3093, "name": "泽库县", "sonList": [] },
{ "id": 3094, "name": "河南县", "sonList": [] }] },
{ "id": 3095, "name": "果洛州", "sonList": [{ "id": 3096, "name": "玛沁县", "sonList": [] },
{ "id": 3097, "name": "班玛县", "sonList": [] },
{ "id": 3098, "name": "甘德县", "sonList": [] },
{ "id": 3099, "name": "达日县", "sonList": [] },
{ "id": 3100, "name": "久治县", "sonList": [] },
{ "id": 3101, "name": "玛多县", "sonList": [] }] },
{ "id": 3102, "name": "玉树州", "sonList": [{ "id": 3103, "name": "玉树县", "sonList": [] },
{ "id": 3104, "name": "杂多县", "sonList": [] },
{ "id": 3105, "name": "称多县", "sonList": [] },
{ "id": 3106, "name": "治多县", "sonList": [] },
{ "id": 3107, "name": "囊谦县", "sonList": [] },
{ "id": 3108, "name": "曲麻莱县", "sonList": [] }] }] },
{ "id": 3109, "name": "宁夏", "sonList": [{ "id": 3110, "name": "银川市", "sonList": [{ "id": 3111, "name": "兴庆区", "sonList": [] },
{ "id": 3112, "name": "西夏区", "sonList": [] },
{ "id": 3113, "name": "金凤区", "sonList": [] },
{ "id": 3114, "name": "永宁县", "sonList": [] },
{ "id": 3115, "name": "贺兰县", "sonList": [] },
{ "id": 3116, "name": "灵武市", "sonList": [] },
{ "id": 3117, "name": "开发区", "sonList": [] }] },
{ "id": 3118, "name": "石嘴山市", "sonList": [{ "id": 3119, "name": "大武口区", "sonList": [] },
{ "id": 3120, "name": "惠农区", "sonList": [] },
{ "id": 3121, "name": "平罗县", "sonList": [] }] },
{ "id": 3122, "name": "吴忠市", "sonList": [{ "id": 3123, "name": "利通区", "sonList": [] },
{ "id": 3124, "name": "盐池县", "sonList": [] },
{ "id": 3125, "name": "同心县", "sonList": [] },
{ "id": 3126, "name": "青铜峡市", "sonList": [] }] },
{ "id": 3127, "name": "固原市", "sonList": [{ "id": 3128, "name": "原州区", "sonList": [] },
{ "id": 3129, "name": "西吉县", "sonList": [] },
{ "id": 3130, "name": "隆德县", "sonList": [] },
{ "id": 3131, "name": "泾源县", "sonList": [] },
{ "id": 3132, "name": "彭阳县", "sonList": [] }] },
{ "id": 3133, "name": "中卫市", "sonList": [{ "id": 3134, "name": "沙坡头区", "sonList": [] },
{ "id": 3135, "name": "中宁县", "sonList": [] },
{ "id": 3136, "name": "海原县", "sonList": [] }] }] },
{ "id": 3137, "name": "新疆", "sonList": [{ "id": 3138, "name": "乌鲁木齐市", "sonList": [{ "id": 3139, "name": "天山区", "sonList": [] },
{ "id": 3140, "name": "沙依巴克区", "sonList": [] },
{ "id": 3141, "name": "水磨沟区", "sonList": [] },
{ "id": 3142, "name": "头屯河区(开发区)", "sonList": [] },
{ "id": 3143, "name": "达坂城区", "sonList": [] },
{ "id": 3144, "name": "米东区", "sonList": [] },
{ "id": 3145, "name": "乌鲁木齐县", "sonList": [] },
{ "id": 3146, "name": "新市区(高新区)", "sonList": [] }] },
{ "id": 3147, "name": "伊犁州", "sonList": [{ "id": 3148, "name": "伊宁市", "sonList": [] },
{ "id": 3149, "name": "奎屯市", "sonList": [] },
{ "id": 3150, "name": "伊宁县", "sonList": [] },
{ "id": 3151, "name": "察布查尔", "sonList": [] },
{ "id": 3152, "name": "霍城县", "sonList": [] },
{ "id": 3153, "name": "巩留县", "sonList": [] },
{ "id": 3154, "name": "新源县", "sonList": [] },
{ "id": 3155, "name": "昭苏县", "sonList": [] },
{ "id": 3156, "name": "特克斯县", "sonList": [] },
{ "id": 3157, "name": "尼勒克县", "sonList": [] }] },
{ "id": 3158, "name": "阿勒泰地区", "sonList": [{ "id": 3159, "name": "阿勒泰市", "sonList": [] },
{ "id": 3160, "name": "布尔津县", "sonList": [] },
{ "id": 3161, "name": "富蕴县", "sonList": [] },
{ "id": 3162, "name": "福海县", "sonList": [] },
{ "id": 3163, "name": "哈巴河县", "sonList": [] },
{ "id": 3164, "name": "青河县", "sonList": [] },
{ "id": 3165, "name": "吉木乃县", "sonList": [] }] },
{ "id": 3166, "name": "塔城地区", "sonList": [{ "id": 3167, "name": "塔城市", "sonList": [] },
{ "id": 3168, "name": "乌苏市", "sonList": [] },
{ "id": 3169, "name": "额敏县", "sonList": [] },
{ "id": 3170, "name": "沙湾县", "sonList": [] },
{ "id": 3171, "name": "托里县", "sonList": [] },
{ "id": 3172, "name": "裕民县", "sonList": [] },
{ "id": 3173, "name": "和布克赛尔", "sonList": [] }] },
{ "id": 3174, "name": "博尔塔拉", "sonList": [{ "id": 3175, "name": "博乐市", "sonList": [] },
{ "id": 3176, "name": "精河县", "sonList": [] },
{ "id": 3177, "name": "温泉县", "sonList": [] }] },
{ "id": 3178, "name": "昌吉", "sonList": [{ "id": 3179, "name": "昌吉市", "sonList": [] },
{ "id": 3180, "name": "阜康市", "sonList": [] },
{ "id": 3181, "name": "呼图壁县", "sonList": [] },
{ "id": 3182, "name": "玛纳斯县", "sonList": [] },
{ "id": 3183, "name": "奇台县", "sonList": [] },
{ "id": 3184, "name": "吉木萨尔县", "sonList": [] },
{ "id": 3185, "name": "木垒县", "sonList": [] },
{ "id": 3186, "name": "高新区", "sonList": [] }] },
{ "id": 3187, "name": "吐鲁番地区", "sonList": [{ "id": 3188, "name": "吐鲁番市", "sonList": [] },
{ "id": 3189, "name": "鄯善县", "sonList": [] },
{ "id": 3190, "name": "托克逊县", "sonList": [] }] },
{ "id": 3191, "name": "巴音郭楞", "sonList": [{ "id": 3192, "name": "库尔勒市", "sonList": [] },
{ "id": 3193, "name": "轮台县", "sonList": [] },
{ "id": 3194, "name": "尉犁县", "sonList": [] },
{ "id": 3195, "name": "若羌县", "sonList": [] },
{ "id": 3196, "name": "且末县", "sonList": [] },
{ "id": 3197, "name": "焉耆县", "sonList": [] },
{ "id": 3198, "name": "和静县", "sonList": [] },
{ "id": 3199, "name": "和硕县", "sonList": [] },
{ "id": 3200, "name": "博湖县", "sonList": [] }] },
{ "id": 3201, "name": "哈密地区", "sonList": [{ "id": 3202, "name": "哈密市", "sonList": [] },
{ "id": 3203, "name": "巴里坤县", "sonList": [] },
{ "id": 3204, "name": "伊吾县", "sonList": [] }] },
{ "id": 3205, "name": "和田地区", "sonList": [{ "id": 3206, "name": "和田市", "sonList": [] },
{ "id": 3207, "name": "和田县", "sonList": [] },
{ "id": 3208, "name": "墨玉县", "sonList": [] },
{ "id": 3209, "name": "皮山县", "sonList": [] },
{ "id": 3210, "name": "洛浦县", "sonList": [] },
{ "id": 3211, "name": "策勒县", "sonList": [] },
{ "id": 3212, "name": "于田县", "sonList": [] },
{ "id": 3213, "name": "民丰县", "sonList": [] }] },
{ "id": 3214, "name": "阿克苏地区", "sonList": [{ "id": 3215, "name": "阿克苏市", "sonList": [] },
{ "id": 3216, "name": "温宿县", "sonList": [] },
{ "id": 3217, "name": "库车县", "sonList": [] },
{ "id": 3218, "name": "沙雅县", "sonList": [] },
{ "id": 3219, "name": "新和县", "sonList": [] },
{ "id": 3220, "name": "拜城县", "sonList": [] },
{ "id": 3221, "name": "乌什县", "sonList": [] },
{ "id": 3222, "name": "阿瓦提县", "sonList": [] },
{ "id": 3223, "name": "柯坪县", "sonList": [] }] },
{ "id": 3224, "name": "克孜勒苏", "sonList": [{ "id": 3225, "name": "阿图什市", "sonList": [] },
{ "id": 3226, "name": "阿克陶县", "sonList": [] },
{ "id": 3227, "name": "阿合奇县", "sonList": [] },
{ "id": 3228, "name": "乌恰县", "sonList": [] }] },
{ "id": 3229, "name": "喀什地区", "sonList": [{ "id": 3230, "name": "喀什市", "sonList": [] },
{ "id": 3231, "name": "疏附县", "sonList": [] },
{ "id": 3232, "name": "疏勒县", "sonList": [] },
{ "id": 3233, "name": "英吉沙县", "sonList": [] },
{ "id": 3234, "name": "泽普县", "sonList": [] },
{ "id": 3235, "name": "莎车县", "sonList": [] },
{ "id": 3236, "name": "叶城县", "sonList": [] },
{ "id": 3237, "name": "麦盖提县", "sonList": [] },
{ "id": 3238, "name": "岳普湖县", "sonList": [] },
{ "id": 3239, "name": "伽师县", "sonList": [] },
{ "id": 3240, "name": "巴楚县", "sonList": [] },
{ "id": 3241, "name": "塔什库尔干", "sonList": [] }] },
{ "id": 3242, "name": "克拉玛依市", "sonList": [{ "id": 3243, "name": "独山子区", "sonList": [] },
{ "id": 3244, "name": "克拉玛依区", "sonList": [] },
{ "id": 3245, "name": "白碱滩区", "sonList": [] },
{ "id": 3246, "name": "乌尔禾区", "sonList": [] }] },
{ "id": 3247, "name": "石河子市", "sonList": [] },
{ "id": 3248, "name": "五家渠市", "sonList": [] },
{ "id": 3249, "name": "阿拉尔市", "sonList": [] },
{ "id": 3250, "name": "图木舒克市", "sonList": [] }] },
{ "id": 3251, "name": "甘肃省", "sonList": [{ "id": 3252, "name": "兰州市", "sonList": [{ "id": 3253, "name": "城关区", "sonList": [] },
{ "id": 3254, "name": "七里河区", "sonList": [] },
{ "id": 3255, "name": "西固区", "sonList": [] },
{ "id": 3256, "name": "安宁区", "sonList": [] },
{ "id": 3257, "name": "红古区", "sonList": [] },
{ "id": 3258, "name": "永登县", "sonList": [] },
{ "id": 3259, "name": "皋兰县", "sonList": [] },
{ "id": 3260, "name": "榆中县", "sonList": [] },
{ "id": 3261, "name": "开发区", "sonList": [] }] },
{ "id": 3262, "name": "天水市", "sonList": [{ "id": 3263, "name": "秦州区", "sonList": [] },
{ "id": 3264, "name": "麦积区", "sonList": [] },
{ "id": 3265, "name": "清水县", "sonList": [] },
{ "id": 3266, "name": "秦安县", "sonList": [] },
{ "id": 3267, "name": "甘谷县", "sonList": [] },
{ "id": 3268, "name": "武山县", "sonList": [] },
{ "id": 3269, "name": "张家川县", "sonList": [] },
{ "id": 3270, "name": "开发区", "sonList": [] }] },
{ "id": 3271, "name": "嘉峪关市", "sonList": [] },
{ "id": 3272, "name": "武威市", "sonList": [{ "id": 3273, "name": "凉州区", "sonList": [] },
{ "id": 3274, "name": "民勤县", "sonList": [] },
{ "id": 3275, "name": "古浪县", "sonList": [] },
{ "id": 3276, "name": "天祝县", "sonList": [] }] },
{ "id": 3277, "name": "金昌市", "sonList": [{ "id": 3278, "name": "金川区", "sonList": [] },
{ "id": 3279, "name": "永昌县", "sonList": [] },
{ "id": 3280, "name": "开发区", "sonList": [] }] },
{ "id": 3281, "name": "酒泉市", "sonList": [{ "id": 3282, "name": "肃州区", "sonList": [] },
{ "id": 3283, "name": "金塔县", "sonList": [] },
{ "id": 3284, "name": "瓜州县", "sonList": [] },
{ "id": 3285, "name": "肃北县", "sonList": [] },
{ "id": 3286, "name": "阿克塞县", "sonList": [] },
{ "id": 3287, "name": "玉门市", "sonList": [] },
{ "id": 3288, "name": "敦煌市", "sonList": [] }] },
{ "id": 3289, "name": "张掖市", "sonList": [{ "id": 3290, "name": "甘州区", "sonList": [] },
{ "id": 3291, "name": "肃南县", "sonList": [] },
{ "id": 3292, "name": "民乐县", "sonList": [] },
{ "id": 3293, "name": "临泽县", "sonList": [] },
{ "id": 3294, "name": "高台县", "sonList": [] },
{ "id": 3295, "name": "山丹县", "sonList": [] }] },
{ "id": 3296, "name": "庆阳市", "sonList": [{ "id": 3297, "name": "西峰区", "sonList": [] },
{ "id": 3298, "name": "庆城县", "sonList": [] },
{ "id": 3299, "name": "环县", "sonList": [] },
{ "id": 3300, "name": "华池县", "sonList": [] },
{ "id": 3301, "name": "合水县", "sonList": [] },
{ "id": 3302, "name": "正宁县", "sonList": [] },
{ "id": 3303, "name": "宁县", "sonList": [] },
{ "id": 3304, "name": "镇原县", "sonList": [] }] },
{ "id": 3305, "name": "平凉市", "sonList": [{ "id": 3306, "name": "崆峒区", "sonList": [] },
{ "id": 3307, "name": "泾川县", "sonList": [] },
{ "id": 3308, "name": "灵台县", "sonList": [] },
{ "id": 3309, "name": "崇信县", "sonList": [] },
{ "id": 3310, "name": "华亭县", "sonList": [] },
{ "id": 3311, "name": "庄浪县", "sonList": [] },
{ "id": 3312, "name": "静宁县", "sonList": [] }] },
{ "id": 3313, "name": "白银市", "sonList": [{ "id": 3314, "name": "白银区", "sonList": [] },
{ "id": 3315, "name": "平川区", "sonList": [] },
{ "id": 3316, "name": "靖远县", "sonList": [] },
{ "id": 3317, "name": "会宁县", "sonList": [] },
{ "id": 3318, "name": "景泰县", "sonList": [] },
{ "id": 3319, "name": "高新区", "sonList": [] }] },
{ "id": 3320, "name": "定西市", "sonList": [{ "id": 3321, "name": "安定区", "sonList": [] },
{ "id": 3322, "name": "通渭县", "sonList": [] },
{ "id": 3323, "name": "陇西县", "sonList": [] },
{ "id": 3324, "name": "渭源县", "sonList": [] },
{ "id": 3325, "name": "临洮县", "sonList": [] },
{ "id": 3326, "name": "漳县", "sonList": [] },
{ "id": 3327, "name": "岷县", "sonList": [] }] },
{ "id": 3328, "name": "陇南市", "sonList": [{ "id": 3329, "name": "武都区", "sonList": [] },
{ "id": 3330, "name": "成县", "sonList": [] },
{ "id": 3331, "name": "文县", "sonList": [] },
{ "id": 3332, "name": "宕昌县", "sonList": [] },
{ "id": 3333, "name": "康县", "sonList": [] },
{ "id": 3334, "name": "西和县", "sonList": [] },
{ "id": 3335, "name": "礼县", "sonList": [] },
{ "id": 3336, "name": "徽县", "sonList": [] },
{ "id": 3337, "name": "两当县", "sonList": [] }] },
{ "id": 3338, "name": "临夏", "sonList": [{ "id": 3339, "name": "临夏市", "sonList": [] },
{ "id": 3340, "name": "临夏县", "sonList": [] },
{ "id": 3341, "name": "康乐县", "sonList": [] },
{ "id": 3342, "name": "永靖县", "sonList": [] },
{ "id": 3343, "name": "广河县", "sonList": [] },
{ "id": 3344, "name": "和政县", "sonList": [] },
{ "id": 3345, "name": "东乡族自治县", "sonList": [] },
{ "id": 3346, "name": "积石山县", "sonList": [] }] },
{ "id": 3347, "name": "甘南州", "sonList": [{ "id": 3348, "name": "合作市", "sonList": [] },
{ "id": 3349, "name": "临潭县", "sonList": [] },
{ "id": 3350, "name": "卓尼县", "sonList": [] },
{ "id": 3351, "name": "舟曲县", "sonList": [] },
{ "id": 3352, "name": "迭部县", "sonList": [] },
{ "id": 3353, "name": "玛曲县", "sonList": [] },
{ "id": 3354, "name": "碌曲县", "sonList": [] },
{ "id": 3355, "name": "夏河县", "sonList": [] }] }] },
] }


let allCity = {
  cityId
};
module.exports = allCity